"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "medadmin-page eh-ds" };
var _hoisted_2 = { class: "page-help-corner" };
var _hoisted_3 = { class: "table-container" };
var _hoisted_4 = {
    key: 0,
    class: "status-filter"
};
var _hoisted_5 = { class: "status-buttons" };
var _hoisted_6 = ["onClick"];
var _hoisted_7 = {
    key: 1,
    class: "date-range-selector"
};
var _hoisted_8 = {
    key: 2,
    class: "mobile-toolbar"
};
var _hoisted_9 = { class: "date-range-selector" };
var _hoisted_10 = { class: "mobile-filter-sort-row" };
var _hoisted_11 = { class: "mobile-filter-sort-col" };
var _hoisted_12 = { class: "mobile-filter-sort-col" };
var _hoisted_13 = { class: "mobile-date-scroll" };
var _hoisted_14 = ["onClick"];
var _hoisted_15 = {
    key: 4,
    class: "sort-controls"
};
var _hoisted_16 = { key: 0 };
var _hoisted_17 = { class: "category-header" };
var _hoisted_18 = { class: "category-section" };
var _hoisted_19 = { class: "schedule-table" };
var _hoisted_20 = {
    key: 0,
    class: "sticky-header-2"
};
var _hoisted_21 = {
    key: 1,
    class: "sticky-header-3"
};
var _hoisted_22 = {
    key: 2,
    class: "sticky-header-4"
};
var _hoisted_23 = {
    key: 3,
    class: "sticky-header-5"
};
var _hoisted_24 = {
    key: 4,
    class: "sticky-header-6"
};
var _hoisted_25 = ["data-med-index"];
var _hoisted_26 = { class: "sticky-column-1" };
var _hoisted_27 = ["onClick"];
var _hoisted_28 = {
    class: "signature-badge",
    role: "img",
    "aria-label": "Nurse signature required"
};
var _hoisted_29 = {
    key: 0,
    class: "sig-text"
};
var _hoisted_30 = {
    key: 1,
    class: "sig-text"
};
var _hoisted_31 = {
    class: "pen",
    viewBox: "0 0 24 24",
    width: "16",
    height: "16",
    "aria-hidden": "true",
    style: { "transform": "scaleX(-1)", "transform-origin": "center" }
};
var _hoisted_32 = {
    key: 1,
    class: "sched-banner-sec"
};
var _hoisted_33 = { class: "container" };
var _hoisted_34 = { class: "banner-text" };
var _hoisted_35 = ["aria-disabled", "onClick"];
var _hoisted_36 = ["title"];
var _hoisted_37 = ["aria-disabled"];
var _hoisted_38 = ["disabled", "onChange"];
var _hoisted_39 = ["value", "selected"];
var _hoisted_40 = ["aria-disabled"];
var _hoisted_41 = { class: "tabs-counter-inputs" };
var _hoisted_42 = { class: "input-group" };
var _hoisted_43 = ["onUpdate:modelValue", "onChange"];
var _hoisted_44 = { class: "input-group" };
var _hoisted_45 = ["onUpdate:modelValue", "onChange"];
var _hoisted_46 = ["value"];
var _hoisted_47 = {
    key: 2,
    class: "sticky-column-4"
};
var _hoisted_48 = {
    key: 3,
    class: "sticky-column-5"
};
var _hoisted_49 = ["aria-disabled"];
var _hoisted_50 = ["disabled", "onClick"];
var _hoisted_51 = ["aria-disabled"];
var _hoisted_52 = ["onClick"];
var _hoisted_53 = {
    key: 1,
    class: "prn-times-list"
};
var _hoisted_54 = ["onMouseover", "onClick"];
var _hoisted_55 = { key: 0 };
var _hoisted_56 = {
    key: 1,
    class: "icon-immediate",
    style: { "color": "#28a745", "margin-left": "0.3rem" },
    title: "Taken"
};
var _hoisted_57 = {
    key: 2,
    class: "icon-immediate",
    style: { "color": "#dc3545", "margin-left": "0.3rem" },
    title: "Refused"
};
var _hoisted_58 = {
    key: 3,
    class: "icon-immediate",
    style: { "color": "#ffe600", "margin-left": "0.3rem" },
    title: "Take Later"
};
var _hoisted_59 = {
    key: 4,
    class: "icon-immediate",
    style: { "color": "#cdb0d1", "margin-left": "0.3rem" },
    title: "Discontinue"
};
var _hoisted_60 = ["title"];
var _hoisted_61 = ["onClick"];
var _hoisted_62 = {
    key: 0,
    class: "icon-immediate",
    style: { "color": "#28a745", "margin-left": "0.3rem" },
    title: "Taken"
};
var _hoisted_63 = {
    key: 1,
    class: "icon-immediate",
    style: { "color": "#dc3545", "margin-left": "0.3rem" },
    title: "Refused"
};
var _hoisted_64 = {
    key: 2,
    class: "icon-immediate",
    style: { "color": "#ffe600", "margin-left": "0.3rem" },
    title: "Take Later"
};
var _hoisted_65 = {
    key: 3,
    class: "icon-immediate",
    style: { "color": "#cdb0d1", "margin-left": "0.3rem" },
    title: "Taken"
};
var _hoisted_66 = ["title"];
var _hoisted_67 = {
    key: 1,
    class: "no-select-result-found"
};
var _hoisted_68 = {
    key: 6,
    class: "mobile-accordion-container"
};
var _hoisted_69 = { class: "category-header" };
var _hoisted_70 = { class: "accordion" };
var _hoisted_71 = { class: "accordion-item__header-group" };
var _hoisted_72 = ["onClick"];
var _hoisted_73 = { class: "accordion-button__name" };
var _hoisted_74 = ["onClick"];
var _hoisted_75 = { class: "mobile-sig-action__label" };
var _hoisted_76 = { class: "accordion-content" };
var _hoisted_77 = ["aria-disabled"];
var _hoisted_78 = { class: "mobile-times" };
var _hoisted_79 = ["disabled", "onClick"];
var _hoisted_80 = {
    key: 0,
    class: "time-bubble__icon time-bubble__icon--taken",
    "aria-hidden": "true"
};
var _hoisted_81 = {
    key: 1,
    class: "time-bubble__icon time-bubble__icon--refused",
    "aria-hidden": "true"
};
var _hoisted_82 = {
    key: 2,
    class: "time-bubble__icon time-bubble__icon--later",
    "aria-hidden": "true"
};
var _hoisted_83 = { class: "detail-row" };
var _hoisted_84 = { class: "value" };
var _hoisted_85 = { class: "detail-row" };
var _hoisted_86 = { class: "value" };
var _hoisted_87 = { class: "detail-row" };
var _hoisted_88 = ["onUpdate:modelValue"];
var _hoisted_89 = { class: "detail-row" };
var _hoisted_90 = ["disabled", "onClick"];
var _hoisted_91 = { class: "detail-row" };
var _hoisted_92 = ["disabled", "onChange"];
var _hoisted_93 = ["value", "selected"];
var _hoisted_94 = {
    key: 1,
    class: "modal-overlay"
};
var _hoisted_95 = { class: "modal-content" };
var _hoisted_96 = {
    key: 2,
    class: "modal-overlay"
};
var _hoisted_97 = { class: "modal-content" };
var _hoisted_98 = { key: 0 };
var _hoisted_99 = { class: "form-group" };
var _hoisted_100 = { class: "form-group" };
var _hoisted_101 = {
    key: 1,
    class: "form-group"
};
var _hoisted_102 = ["onUpdate:modelValue"];
var _hoisted_103 = {
    key: 2,
    class: "fom-group"
};
var _hoisted_104 = { class: "form-actions" };
var _hoisted_105 = {
    key: 4,
    class: "modal-overlay"
};
var _hoisted_106 = { class: "modal-content" };
var _hoisted_107 = { key: 0 };
var _hoisted_108 = {
    key: 0,
    class: "button-row"
};
var _hoisted_109 = { key: 1 };
var _hoisted_110 = { key: 1 };
var _hoisted_111 = {
    key: 5,
    class: "modal-overlay"
};
var _hoisted_112 = { class: "modal-content" };
var _hoisted_113 = {
    key: 6,
    class: "modal-overlay"
};
var _hoisted_114 = { class: "modal-content" };
var _hoisted_115 = { key: 0 };
var _hoisted_116 = { class: "button-row" };
var _hoisted_117 = { key: 1 };
var _hoisted_118 = {
    key: 0,
    style: { "color": "#28a745" }
};
var _hoisted_119 = {
    key: 1,
    style: { "color": "#dc3545" }
};
var _hoisted_120 = { class: "form-group" };
var _hoisted_121 = { class: "button-row" };
var _hoisted_122 = ["disabled"];
var _hoisted_123 = {
    key: 7,
    class: "modal-overlay"
};
var _hoisted_124 = { class: "modal-content" };
var _hoisted_125 = { key: 0 };
var _hoisted_126 = { class: "form-group" };
var _hoisted_127 = { class: "form-group" };
var _hoisted_128 = { class: "button-row" };
var _hoisted_129 = ["disabled"];
var _hoisted_130 = { class: "scanner-modal-content" };
var _hoisted_131 = {
    key: 1,
    class: "modal-overlay"
};
var _hoisted_132 = { class: "modal-content" };
var _hoisted_133 = { style: { "display": "block", "margin-bottom": "1rem", "color": "#dc3545" } };
var _hoisted_134 = {
    key: 2,
    class: "modal-overlay"
};
var _hoisted_135 = { class: "modal-content" };
var _hoisted_136 = {
    key: 3,
    class: "modal-overlay"
};
var vuex_1 = require("vuex");
var MedicationActionPopup_vue_1 = require("./MedicationActionPopup.vue");
var vue_3 = require("vue");
require("flatpickr/dist/flatpickr.css");
var flatpickr_1 = require("flatpickr");
var axios_1 = require("axios");
var sweetalert2_1 = require("sweetalert2");
//import ExpandableDetails from './ExpandableDetails.vue'
var AddMedicationForm_vue_1 = require("./AddMedicationForm.vue");
var HoldTimeSelector_vue_1 = require("./HoldTimeSelector.vue");
var nonPrescription_1 = require("@/utils/nonPrescription");
var medicationCourseDates_1 = require("@/utils/medicationCourseDates");
// import BarcodeScanner from './barcode-scanner/BarcodeScanner.vue'
var BarcodeScanner_vue_1 = require("../barcode-scanner/BarcodeScanner.vue");
var MedadminshortOrderTemplate_vue_1 = require("./MedadminshortOrderTemplate.vue");
// import LabelScanner from '../scanner/LabelScanner.vue'
var LabelScanner_vue_1 = require("../../scanner/LabelScanner.vue");
var textParser_1 = require("@/utils/medicationRecognition/textParser");
var fdaApiUtils_1 = require("@/utils/fdaApiUtils");
var apis_1 = require("@/constants/apis");
var privileges_1 = require("@/stores/privileges");
var privileges_2 = require("@/constants/privileges");
var privilegeGate_1 = require("@/utils/privilegeGate");
var HelpIcon_vue_1 = require("@/components/help/HelpIcon.vue");
var medAdminSlots_1 = require("@/utils/medAdminSlots");
var keyonRefusal_1 = require("@/utils/keyonRefusal");
var FUTURE_DAYS_TO_POPULATE = 365;
/*Try new bckground mapping function */
var REQUIRE_BARCODE_SCAN_FOR_ADMIN = false;
exports.default = (0, vue_1.defineComponent)({
    __name: 'MedAdmin',
    props: {
        medications: { default: function () { return []; } }
    },
    emits: ["statusChange", "medicationTaken", "signatureSubmit", "tabsChange"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        // import { mapGetters } from "vuex"
        var store = (0, vuex_1.useStore)();
        var privilegesStore = (0, privileges_1.usePrivilegesStore)();
        var canMedicationEditOrdered = (0, vue_3.computed)(function () { return privilegesStore.effectiveGranted(privileges_2.PRIVILEGES.MEDICATION_EDIT_ORDERED); });
        var canMedicationHold = (0, vue_3.computed)(function () { return privilegesStore.effectiveGranted(privileges_2.PRIVILEGES.MEDICATION_HOLD); });
        var canMedicationDiscontinue = (0, vue_3.computed)(function () { return privilegesStore.effectiveGranted(privileges_2.PRIVILEGES.MEDICATION_DISCONTINUE); });
        var canMedicationAdminister = (0, vue_3.computed)(function () { return privilegesStore.effectiveGranted(privileges_2.PRIVILEGES.MEDICATION_ADMINISTER); });
        var canOrderSign = (0, vue_3.computed)(function () { return privilegesStore.effectiveGranted(privileges_2.PRIVILEGES.ORDER_SIGN); });
        var showOrderModal = (0, vue_3.ref)(false);
        var selectedOrder = (0, vue_3.ref)({});
        var allData = (0, vue_3.computed)(function () { var _a; return (_a = store.getters) === null || _a === void 0 ? void 0 : _a['login/getAllData']; });
        var patient = (0, vue_3.computed)(function () { var _a; return (_a = allData.value) === null || _a === void 0 ? void 0 : _a.patient; });
        var actionProviderSignature = (0, vue_3.ref)('Keyon James');
        var srchDtfield = (0, vue_3.ref)('');
        var fpInstance = null;
        var scanRegion = (0, vue_3.ref)(null);
        var rapidScanMode = (0, vue_3.ref)(false);
        function toYMD(date) {
            var d = new Date(date);
            var y = d.getFullYear();
            var m = String(d.getMonth() + 1).padStart(2, '0'); // months 0-based
            var day = String(d.getDate()).padStart(2, '0');
            return "".concat(y, "-").concat(m, "-").concat(day);
        }
        // normalize times to "HH:MM" for matching (adjust to your formats)
        function normalizeTime(t) {
            if (!t)
                return '';
            // strip seconds if any: "08:00:00" -> "08:00"
            return String(t).split(':').slice(0, 2).join(':');
        }
        function isObject(val) {
            return val != null && typeof val === 'object' && !Array.isArray(val);
        }
        /** DB column is medadmin; FE form uses administration — treat either as truthy. */
        function isAdminFlagOn(med) {
            var _a;
            var v = (_a = med === null || med === void 0 ? void 0 : med.administration) !== null && _a !== void 0 ? _a : med === null || med === void 0 ? void 0 : med.medadmin;
            return v === true || v === 1 || v === '1';
        }
        // find medlog entry for the medication + date + time
        function findMedLogFor(med, dateObj, timeObj) {
            var _a;
            //alert(med.medname);
            if (!(med === null || med === void 0 ? void 0 : med.administerdate) || !Array.isArray(med.administerdate))
                return null;
            //alert(med.administerdate);
            // Find the administeredate entry that corresponds to this dateObj.
            // Use whichever key matches your dateObj.date, date string, or id.
            var dateKey = (_a = toYMD(dateObj)) !== null && _a !== void 0 ? _a : dateObj;
            /*console.log("Seeing whats in the date Object");
            console.log(dateKey);
            console.log("Seeing whats in the administrdate object");
            console.log(med.administerdate); */
            //alert(dateKey);// is date but wonder if it needs formatting 
            var dateEntry = med.administerdate.find(function (d) {
                // try matching properties present in your data
                return d && (d.administerdate == dateKey);
            }) || med.administerdate[0];
            /*console.log("Seeing whats inside of Date Entry const");
            console.log(dateEntry); */
            if (isObject(dateEntry) == true) {
                /* console.log("Date Entry is an object");
                  console.log("date entry medlogtime");
                  console.log(dateEntry.medlogtimes); */
            }
            if (!dateEntry || !isObject(dateEntry))
                return null;
            var desired = normalizeTime(timeObj.time);
            /*console.log("desire time");
            console.log(desired);*/
            return dateEntry.medlogtimes.find(function (log) { return normalizeTime(log.time) === desired; }) || null;
        }
        function isStatusDisabled(med) {
            var _a;
            //set values 
            var pairs = (0, medAdminSlots_1.parseTimeStatusPairs)((_a = med.time_status_pairs) !== null && _a !== void 0 ? _a : null);
            // Derived arrays for backward compatibility
            var pairStatuses = pairs.map(function (p) { return p.status; }).filter(Boolean);
            var statusexist = pairStatuses.includes('taken') || pairStatuses.includes('hold-medtime') || pairStatuses.includes('discontinue-medtime');
            return statusexist;
        }
        function clearFilter() {
            fpInstance.clear();
            dateList.value = [];
            loadMedications();
            //srchDtfield.value="";
        }
        // compute background color using medlog.tagstatus when available
        function bgForTime(med, dateObj, timeObj) {
            var log = findMedLogFor(med, dateObj, timeObj);
            var tag = log === null || log === void 0 ? void 0 : log.tagstatus; // this is the per-time tagstatus you want
            /*console.log("Backgroun Medicaton");
            console.log(med.medname);
            console.log("tag status");
            console.log(tag);*/
            // replicate your existing rules, but prefer per-time tagstatus
            if ((timeObj.locked && timeObj.status === 'taken') || timeObj.temporaryStatus === 'taken')
                return '#b3f0b3';
            if (timeObj.locked && timeObj.status === 'refused')
                return '#f9b3b3';
            if ((timeObj.locked && timeObj.status === 'hold' || getEffectiveStatus(med) === 'hold') || med.status === 'hold' || tag === 'hold')
                return '#fff3cd';
            if ((timeObj.locked && timeObj.status === 'hold-medtime' || getEffectiveStatus(med) === 'hold-medtime') || med.status === 'hold-medtime')
                return '#fff3cd';
            if ((timeObj.locked && timeObj.status === 'discontinue-medtime' || getEffectiveStatus(med) == 'discontinue') || med.status === 'discontinue')
                return '#f8d7da';
            // use per-time tagstatus here instead of med.tagstatus
            if (timeObj.status === 'New' || tag === 'new' || (med.tagstatus && med.tagstatus.toLowerCase().includes('new')))
                return '#869dcd';
            if (timeObj.status === 'discontinue-medtime')
                return '#f8d7da';
            return 'transparent';
        }
        /** Status colors override the CSS default; omit style when pending so teal-wash shows. */
        function timeBubbleStyle(med, dateObj, timeObj) {
            var bg = bgForTime(med, dateObj, timeObj);
            return bg && bg !== 'transparent' ? { backgroundColor: bg } : undefined;
        }
        /*End New backgrounf mapping code */
        // --------------- Chris additions to <script> ---------------
        // Determines if screen is mobile or not for mobile UI
        var isMobile = (0, vue_3.ref)(window.innerWidth < 768);
        window.addEventListener('resize', function () {
            isMobile.value = window.innerWidth < 768;
            initializeDateRangePicker();
        });
        // reactive map to track which med is open
        var openAccordions = (0, vue_3.reactive)({});
        // toggler
        function toggleAccordion(key) {
            openAccordions[key] = !openAccordions[key];
        }
        var selectedSort = (0, vue_3.ref)('');
        var showNdcMismatchPopup = (0, vue_3.ref)(false);
        var manualNdcPopup = (0, vue_3.ref)(false);
        var ndcFailure = (0, vue_3.ref)(false);
        var mismatchScannedValue = (0, vue_3.ref)('');
        var mismatchExpectedNdc = (0, vue_3.ref)('');
        // when it changes, call your existing sort functions
        function onSortChange() {
            switch (selectedSort.value) {
                case 'Medication':
                    handleSort('medication');
                    break;
                case 'Time':
                    handleSort('time');
                    break;
                case 'Diagnosis':
                    handleSort('diagnosis');
                    break;
                case 'Route':
                    handleSort('route');
                    break;
                case 'PRN':
                    handleSort('prn');
                    break;
            }
        }
        /**
         * Call your existing updateDateRange(start, end)
         * and also populate the mobile chips.
         */
        function onDateRangePicked(selDates) {
            // first, build your full dateList via your existing logic
            updateDateRange(selDates[0], selDates[1]);
            // now map each Date in dateList into "M/D" strings
            selectedDates.value = dateList.value.map(function (d) {
                var m = d.getMonth() + 1;
                var dd = d.getDate();
                return "".concat(m, "/").concat(dd);
            });
        }
        function currentTimeObj(med) {
            var _a;
            // if the scannerContext.med matches this med, return its timeObj
            if (((_a = scannerContext.value) === null || _a === void 0 ? void 0 : _a.med) === med) {
                return scannerContext.value.timeObj;
            }
            return null;
        }
        /** We reuse the same unit options for both the "AddMedicationForm" and the dropdown here. */
        var unitOptions = [
            "Actuation", "Ampule", "Application", "Applicator", "Auto-Injector", "Bar",
            "Capful", "Caplet", "Capsule", "Cartridge", "Centimeter", "Disk", "Dropperful",
            "Each", "Film", "Fluid Ounce", "Gallon", "Gram", "Gum", "Implant", "Inch",
            "Inhalation", "Injection", "Insert", "Liter", "Lollipop", "Lozenge", "Metric Drop",
            "Microgram", "Milliequivalent", "Milligram", "Milliliter", "Nebule", "Ounce",
            "Package", "Packet", "Pad", "Patch", "Pellet", "Pill", "Pint", "Pre-filled Pen Syringe",
            "Puff", "Pump", "Ring", "Sachet", "Scoopful", "Sponge", "Spray", "Stick", "Strip",
            "Suppository", "Swab", "Syringe", "Tablet", "Troche", "Unit", "Vial", "Wafer"
        ];
        var showBarcodeScanner = (0, vue_3.ref)(false);
        var scannerContext = (0, vue_3.ref)(null);
        /** TESTING: set `true` to require NDC barcode scan before administer / PRN sign-off. */
        var prevScannerContext = (0, vue_3.ref)(null);
        var prevScannerContextCount = 0;
        var manualNdc = '';
        var selectedDates = (0, vue_3.ref)([]);
        //const editingMedication = ref<Object | null>(null)
        /*6/23 New Function to Handle the Edit Medical Form Data (prepopulate data) */
        function openMedicationForm(med) {
            if (!canMedicationEditOrdered.value) {
                return;
            }
            /* Commented out code to stop already administered times from being editd - Need more context from DR on edge case and then I can circle back
             if(Array.isArray(med.times) && med.times.length !==0)
             {
               for(let i=0; i < med.times.length;i++)
               {
                 if(med.times[i].status=="taken" || med.times[i].status=="refused")
                 {
                   alert("Sorry! Can't edit medication that has already been administered.");
                   showAddForm.value =false;
                   return;
                 }
               }
             } */
            isEditForm.value = true;
            editFormdata.value = med;
            //set the selectedMedicationForTime object for the 
            selectedMedicationForTime.value = med;
            showAddForm.value = true;
        }
        // Signature popup
        var signOffNurseSignature = (0, vue_3.ref)('');
        /** Tooltip for which nurse added med + timestamp */
        function getAddMedicationTooltip(med) {
            /* if (!med.addedByNurse || !med.addedTimestamp) return ''
            const addedTime = new Date(med.addedTimestamp).toLocaleString()
            return `Nurse: ${med.addedByNurse}\nAdded On: ${addedTime}` */
            /*2/18/26 Refactor to account for attributes that are actually on the Med object. addedbyNurse is no longer relvant*/
            if (!med.nursesignature && !med.providersignature)
                return 'Warning: No Provider and Or Nurse Signature Found Please update system data.';
            var addedTime = new Date((med.nurssigtimestamp || '1970-01-01 00:00:00').replace(' ', 'T'));
            //alert( addedTime.toLocaleString());
            if (med.ordertype == "Nurse Order" && med.nursesignature !== "" && med.providersignature == "") {
                return "Nurse: ".concat(med.nursesignature, "\nAdded On: ").concat(addedTime);
            }
            else if (med.ordertype == "Nurse Order" && med.nursesignature !== "" && med.providersignature != "") {
                return "Nurse: ".concat(med.nursesignature, "\nAdded On: ").concat(addedTime);
            }
            else if (med.ordertype == "Physicians Order" && med.nursesignature == "" && med.providersignature != "") {
                return "Provider: ".concat(med.providersignature, "\nAdded On: ").concat(addedTime);
            }
            else if (med.ordertype == "Physicians Order" && med.nursesignature != "" && med.providersignature != "") {
                return "Provider: ".concat(med.providersignature, "\nAdded On: ").concat(addedTime);
            }
            else if (med.ordertype == "Provider" && med.nursesignature.trim() == "" && med.providersignature.trim() == "") {
                return 'Warning: No Provider and Or Nurse Signature Found. Administrator needs to update system data.';
            }
            else {
                return 'Note: Please have system administrator confirm and or update missing information';
            }
        }
        function isMedicationVisible(med) {
            // If no discontinuedDate => show
            if (!med.discontinuedDate)
                return true;
            // If no date range => show
            if (dateList.value.length === 0)
                return true;
            // If earliest day is after med.discontinuedDate => hide the med entirely
            var earliestDay = normalizeToMidnight(dateList.value[0]);
            if (earliestDay.getTime() > normalizeToMidnight(med.discontinuedDate).getTime()) {
                return false;
            }
            return true;
        }
        var activeDate = (0, vue_3.ref)('');
        // handler when user clicks a date box
        function selectDate(date) {
            activeDate.value = date;
        }
        (0, vue_3.onUnmounted)(function () {
            if (fpInstance) {
                fpInstance.destroy();
                fpInstance = null;
            }
        });
        /*const localEmit = defineEmits<{
          (e: 'statusChange', medication: Medication, status: string): void;
          (e: 'medicationTaken', medication: Medication, time: string, action: string): void;
          (e: 'signatureSubmit', signature: string, medications: Medication[], time: string): void;
          (e: 'tabsChange', medication: Medication, tabs: number): void;
        }>() */
        /*
        *3/14/2026 KW Adding to chek for Scheduled Hold Dates
        * @med: objet that has properties that's needed to defne logic and return boolean
        */
        function hasScheduleDate(med) {
            var cday = formatDateToYYYYMMDD(new Date());
            if (med.schedHoldStartDate != '' && med.schedHoldStartDate >= cday) {
                return true;
            }
            else {
                false;
            }
            // alert("Logic didn't pan out on banner");
            return false; //derault in case logic doesn't ban out
        }
        /** For PRN meds, we check if any times exist that day to hide "As needed" */
        function hasPrnTimesForDate(med, dateObj) {
            var dateStr = formatDateToYYYYMMDD(dateObj);
            //----Test Code------//
            // Skip PRN rows for dates before the medication's start date
            if (med.prn === "1" && med.med_startdate) {
                var medStartStr = typeof med.med_startdate === 'string'
                    ? med.med_startdate.split('T')[0]
                    : formatDateToYYYYMMDD(new Date(med.med_startdate));
                if (dateStr < medStartStr) {
                    // don't create PRN/time_status_pairs rows for this date
                    return true; // returning true here | second func will take care of removing label
                }
            }
            //-----endtestcode----//
            // Check for confirmed times
            if (med.times && Array.isArray(med.times)) {
                var confirmedTimesForDate = med.times.filter(function (entry) { return entry.date === dateStr; });
                if (confirmedTimesForDate.length > 0) {
                    // Has confirmed times, hide button
                    //alert("Has Time");
                    return true;
                }
            }
            // Check for pending times in pendingPrnTimes
            if (pendingPrnTimes.value && pendingPrnTimes.value.medication === med) {
                var pendingTimesForDate = pendingPrnTimes.value.timeObjects.filter(function (entry) { return entry.date === dateStr; });
                if (pendingTimesForDate.length > 0) {
                    // Has pending times, hide button
                    return true;
                }
            }
            // No times, show button
            return false;
        }
        function getPrnTimesForDate(med, dateObj) {
            if (!med.times || !Array.isArray(med.times))
                return [];
            var dateStr = formatDateToYYYYMMDD(dateObj);
            return med.times.filter(function (entry) { return entry.date === dateStr; });
        }
        (0, vue_3.watch)(selectedDates, function (dates) {
            if (dates.length && !activeDate.value) {
                activeDate.value = dates[0];
            }
        });
        function findDateObj(dateStr) {
            var found = dateList.value.find(function (d) {
                return "".concat(d.getMonth() + 1, "/").concat(d.getDate()) === dateStr;
            });
            return found !== null && found !== void 0 ? found : normalizeToMidnight(new Date());
        }
        function parseDateKey(key) {
            var _a = key.split('-').map(Number), y = _a[0], m = _a[1], d = _a[2];
            return new Date(y, m - 1, d);
        }
        function normalizeNdc(ndc) {
            if (!ndc)
                return '';
            // Remove all non-digit characters
            var digitsOnly = ndc.replace(/\D/g, '');
            return digitsOnly;
        }
        function ndcMatches(ndc1, ndc2) {
            if (!ndc1 || !ndc2)
                return false;
            var normalized1 = normalizeNdc(ndc1);
            var normalized2 = normalizeNdc(ndc2);
            if (!normalized1 || !normalized2)
                return false;
            return normalized1.includes(normalized2) || normalized2.includes(normalized1);
        }
        function onBarcodeScanned(barcode) {
            var _a;
            if (!scannerContext.value)
                return;
            var _b = scannerContext.value, med = _b.med, timeObj = _b.timeObj, dateObj = _b.dateObj;
            var expected = (_a = med.ndcnumber) !== null && _a !== void 0 ? _a : '';
            // Normalize both NDCs and compare, handles dashes and leading zeros
            if (expected && ndcMatches(expected, barcode)) {
                // Check if this is a PRN medication
                if (med.prn === '1' || med.prn === true || med.prn === 1) {
                    // For PRN medications, open the PRN sign-off popup
                    openPrnSignOffPopup(med, timeObj);
                }
                else {
                    // For regular medications, show the time action popup
                    selectedDateAndTime.value = { medication: med, timeObj: timeObj, dateObj: dateObj };
                    showTimeActionPopup.value = true;
                }
            }
            else {
                // mismatch
                prevScannerContextCount += 1;
                if (prevScannerContextCount == 3) {
                    prevScannerContextCount = 0;
                    manualNdcPopup.value = true;
                }
                else {
                    mismatchScannedValue.value = barcode;
                    mismatchExpectedNdc.value = expected;
                    showNdcMismatchPopup.value = true;
                }
            }
            // reset scanner UI
            scannerContext.value = null;
            // save context for retries
            prevScannerContext.value = { med: med, timeObj: timeObj, dateObj: dateObj };
            showBarcodeScanner.value = false;
        }
        function retryScan() {
            showNdcMismatchPopup.value = false;
            // re-open the camera
            // load prev scanner context
            var _a = prevScannerContext.value, med = _a.med, timeObj = _a.timeObj, dateObj = _a.dateObj;
            scannerContext.value = { med: med, timeObj: timeObj, dateObj: dateObj };
            showBarcodeScanner.value = true;
        }
        function closeMismatchPopup() {
            var _a;
            // Clear pending PRN times if scanner was for a PRN medication
            if (((_a = prevScannerContext.value) === null || _a === void 0 ? void 0 : _a.med) && (prevScannerContext.value.med.prn === '1' || prevScannerContext.value.med.prn === true || prevScannerContext.value.med.prn === 1)) {
                if (pendingPrnTimes.value && pendingPrnTimes.value.medication === prevScannerContext.value.med) {
                    pendingPrnTimes.value = null;
                }
            }
            prevScannerContext.value = null;
            showNdcMismatchPopup.value = false;
        }
        function handleManualNdc() {
            var _a = prevScannerContext.value, med = _a.med, timeObj = _a.timeObj, dateObj = _a.dateObj;
            // Use normalized comparison to handle dashes and leading zeros
            if (manualNdc && ndcMatches(mismatchExpectedNdc.value, manualNdc)) {
                // Check if this is a PRN medication
                if (med.prn === '1' || med.prn === true || med.prn === 1) {
                    // For PRN medications, open the PRN sign-off popup
                    openPrnSignOffPopup(med, timeObj);
                }
                else {
                    // For regular medications, show the time action popup
                    selectedDateAndTime.value = { medication: med, timeObj: timeObj, dateObj: dateObj };
                    showTimeActionPopup.value = true;
                }
            }
            else {
                ndcFailure.value = true;
            }
            scannerContext.value = null;
            prevScannerContext.value = null;
            manualNdcPopup.value = false;
        }
        function closeManualNdcPopup() {
            var _a;
            // Clear pending PRN times if scanner was for a PRN medication
            if (((_a = scannerContext.value) === null || _a === void 0 ? void 0 : _a.med) && (scannerContext.value.med.prn === '1' || scannerContext.value.med.prn === true || scannerContext.value.med.prn === 1)) {
                if (pendingPrnTimes.value && pendingPrnTimes.value.medication === scannerContext.value.med) {
                    pendingPrnTimes.value = null;
                }
            }
            scannerContext.value = null;
            prevScannerContext.value = null;
            manualNdcPopup.value = false;
        }
        function handleScannerClose() {
            var _a;
            // Clear pending PRN times if scanner was for a PRN medication
            if (((_a = scannerContext.value) === null || _a === void 0 ? void 0 : _a.med) && (scannerContext.value.med.prn === '1' || scannerContext.value.med.prn === true || scannerContext.value.med.prn === 1)) {
                if (pendingPrnTimes.value && pendingPrnTimes.value.medication === scannerContext.value.med) {
                    pendingPrnTimes.value = null;
                }
            }
            scannerContext.value = null;
            prevScannerContext.value = null;
        }
        function closeNdcFailure() {
            ndcFailure.value = false;
        }
        function handleTimeClick(dateObj, timeObj, med) {
            if (ifOrderSigned(med))
                return;
            if (!canMedicationAdminister.value) {
                alert("You do not have permission to administer medications");
                return;
            }
            // Only allow today’s date
            var today = normalizeToMidnight(new Date());
            var selectedDay = normalizeToMidnight(dateObj);
            if (selectedDay.getTime() !== today.getTime()) {
                errorMessage.value = "Medications can only be given on the current date.";
                showErrorModal.value = true;
                return;
            }
            // Compute minutes difference from scheduled time
            var _a = timeObj.time.split(':').map(function (s) { return s.trim(); }), hStr = _a[0], mStr = _a[1];
            var scheduled = new Date(dateObj);
            scheduled.setHours(parseInt(hStr, 10), parseInt(mStr, 10), 0, 0);
            var diffMinutes = (new Date().getTime() - scheduled.getTime()) / 60000;
            // Early / late check (±60min window)
            if (diffMinutes < -60 || diffMinutes > 60) {
                pendingDateAndTime.value = { dateObj: dateObj, timeObj: timeObj, medication: med };
                isEarly.value = diffMinutes < -60;
                confirmationMessage.value = isEarly.value
                    ? "This medication is early, do you still want to give it?"
                    : "This medication is late, do you still want to give it?";
                showTimeConfirmationPopup.value = true;
                return;
            }
            // All checks passed: open camera (or skip barcode for testing)
            if (REQUIRE_BARCODE_SCAN_FOR_ADMIN) {
                scannerContext.value = { med: med, timeObj: timeObj, dateObj: dateObj };
            }
            else if (med.prn === '1' || med.prn === true || med.prn === 1) {
                openPrnSignOffPopup(med, timeObj);
            }
            else {
                selectedDateAndTime.value = { medication: med, timeObj: timeObj, dateObj: dateObj };
                showTimeActionPopup.value = true;
            }
        }
        // Signature grouping
        function groupTransactionsByTime(transactions) {
            var map = {};
            transactions.forEach(function (item) {
                var rawTime = item.timeObj.time.includes("(")
                    ? item.timeObj.time.split("(")[0].trim()
                    : item.timeObj.time;
                if (!map[rawTime]) {
                    map[rawTime] = [];
                }
                map[rawTime].push(item);
            });
            return Object.entries(map).map(function (_a) {
                var time = _a[0], items = _a[1];
                return ({ time: time, items: items });
            });
        }
        var takenGrouped = (0, vue_3.computed)(function () {
            var takenItems = pendingTransactions.value.filter(function (pt) { return pt.timeObj.temporaryStatus === 'taken'; });
            return groupTransactionsByTime(takenItems);
        });
        var refusedGrouped = (0, vue_3.computed)(function () {
            var refusedItems = pendingTransactions.value.filter(function (pt) { return pt.timeObj.temporaryStatus === 'refused'; });
            return groupTransactionsByTime(refusedItems);
        });
        // --------------- End of Chris additions to <script> ---------------
        // router imported directly from @/router/index to avoid injection timing issues with <Transition>
        var medications = (0, vue_3.ref)([]);
        var pastProvar = (0, vue_3.ref)([]);
        //const pastProvar = ref<string[]>([]);
        var pastProvloaded = (0, vue_3.ref)(false);
        // Sorting
        var sortBy = (0, vue_3.ref)('');
        // Default pinned date
        var currentDate = (0, vue_3.ref)(new Date());
        // Collapse/Expand columns toggle
        var collapsed = (0, vue_3.ref)(true);
        function toggleCollapse() {
            collapsed.value = !collapsed.value;
        }
        // UI Toggles & Selected Data
        var showAddForm = (0, vue_3.ref)(false);
        var isSavingMedication = (0, vue_3.ref)(false);
        var selectedMedicationForTime = (0, vue_3.ref)(null);
        var selectedMedStatusForTime = (0, vue_3.ref)('');
        var selectedFrequency = (0, vue_3.ref)('');
        var selectedDosage = (0, vue_3.ref)('1');
        var timeInputs = (0, vue_3.ref)([]);
        var dateList = (0, vue_3.ref)([]);
        var pendingSignoff = (0, vue_3.ref)(false);
        // For storing statuses
        var medicationStatus = (0, vue_3.ref)({});
        // Status Filter
        var selectedStatus = (0, vue_3.ref)(null);
        // "Hold/New/Discontinue" popup
        var showHoldSelector = (0, vue_3.ref)(false);
        var holdSelectorCancelledCounter = (0, vue_3.ref)(0);
        var selectedMedicationForHold = (0, vue_3.ref)(null);
        var selectedStatusOption = (0, vue_3.ref)('hold');
        var pendingStatusChange = (0, vue_3.ref)(null);
        // Time & Dosage modal
        var showTimeModal = (0, vue_3.ref)(false);
        // "Taken/Refused/Later" popup
        var showTimeActionPopup = (0, vue_3.ref)(false);
        var selectedDateAndTime = (0, vue_3.ref)(null);
        // Early/Late confirmation
        var showTimeConfirmationPopup = (0, vue_3.ref)(false);
        var confirmationMessage = (0, vue_3.ref)("");
        var pendingDateAndTime = (0, vue_3.ref)(null);
        var isEarly = (0, vue_3.ref)(false);
        var showEarlyReasonInput = (0, vue_3.ref)(false);
        var earlyReason = (0, vue_3.ref)("");
        // Error Modal
        var showErrorModal = (0, vue_3.ref)(false);
        var errorMessage = (0, vue_3.ref)("");
        // Sign-Off Popup
        var showSignOffPopup = (0, vue_3.ref)(false);
        var pendingTransactions = (0, vue_3.ref)([]);
        // PRN Sign-Off
        var showPrnSignOffPopup = (0, vue_3.ref)(false);
        var prnSignOffMedication = (0, vue_3.ref)(null);
        var editFormdata = (0, vue_3.ref)(null);
        var prnSignOffTimeObj = (0, vue_3.ref)(null);
        var prnNurseSignature = (0, vue_3.ref)('');
        var pendingPrnTimes = (0, vue_3.ref)(null);
        var changeActiveMed = (0, vue_3.ref)(false);
        // Keyon Added variables for Time Change - Status change
        var ifStatusIsChange = (0, vue_3.ref)(false);
        var Reasaon4change = (0, vue_3.ref)('');
        var isEditForm = (0, vue_3.ref)(false);
        var isAddmedForm = (0, vue_3.ref)(false);
        function openAddMedicationManually(fullManual) {
            if (!(0, privilegeGate_1.assertPrivilegeOrAlert)(privileges_2.PRIVILEGES.MEDICATION_ADD_ORDERED, "You do not have permission to add ordered medications.")) {
                return;
            }
            if (fullManual) {
                isAddmedForm.value = true;
                showAddForm.value = true;
                isEditForm.value = false;
            }
            else {
                showAddForm.value = true;
            }
        }
        var medval = {};
        // Label Scanner state
        var showLabelScanner = (0, vue_3.ref)(false);
        // FREQUENCY OPTIONS
        var frequencyOptions = [
            '1 time daily', '2 time daily', '3 time daily', '4 time daily',
            'as directed', 'as needed', 'as one dose', 'at bedtime',
            'before every meal', 'bi-weekly', 'constant infusion', 'daily',
            'daily as directed', 'every day', 'every month', 'every other day',
            'every morning', 'every evening', 'every hour', 'every 2 hours',
            'every 3 hours', 'every 4 hours', 'every 4 to 6 hours, as needed',
            'every 4 to 6 minutes', 'every 4 to 8 hours', 'every 6 hours',
            'every 8 hours', 'every 12 hours', 'every 24 hours',
            'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday',
            'every Monday, Wednesday, Friday, Sunday', 'every Tuesday, Thursday, Saturday',
            'before breakfast, lunch, dinner', 'after breakfast, lunch, dinner',
            'once a week', 'one time dose', 'three times a week', 'twice daily',
            'two times a week', 'use as directed per instructions in pack', 'weekly'
        ];
        function updatepastProvBoolean() {
            pastProvloaded.value = false;
        }
        //loadpastProv axios call here 
        function loadpastProv() {
            return __awaiter(this, void 0, void 0, function () {
                var content;
                return __generator(this, function (_a) {
                    try {
                        content = {
                            Provider: {
                                API_Meth: "GetAllProviders",
                                patientid: allData.value.patient.externId, //"709081242", //"70894333",
                                accountnumber: allData.value.patient.externId2
                            }
                        };
                        axios_1.default.post(apis_1.CURR_API + '/tswebhook.php', content)
                            .then(function (response) {
                            pastProvar.value = response.data.provider;
                            pastProvloaded.value = true;
                            //errorMessage = ""; // Clear any previous error messages     
                        })
                            .catch(function (error) {
                            var _a;
                            if (axios_1.default.isAxiosError(error)) {
                                console.error('Error posting data:', ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) || error.message);
                                // errorMessage = error.response?.data?.message || 'An error occurred while posting data.';  
                            }
                            else {
                                // errorMessage = 'An unexpected error occurred. Please try again.'; 
                            }
                        });
                    }
                    catch (error) {
                        console.error("Error Posting to Past Provider enpoint:", error);
                    }
                    return [2 /*return*/];
                });
            });
        }
        function extractBaseTime(rawTime) {
            return rawTime.split('(')[0].trim();
        }
        function normalizeToMidnight(d) {
            return new Date(d.getFullYear(), d.getMonth(), d.getDate());
        }
        function formatDate(date) {
            return date.toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            });
        }
        function formatTime12Hour(date) {
            var hours = date.getHours();
            var minutes = date.getMinutes();
            var ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12;
            var minutesStr = minutes < 10 ? '0' + minutes : minutes;
            return hours + ":" + minutesStr + " " + ampm;
        }
        function formatTime24Hour(date) {
            var hours = date.getHours();
            var minutes = date.getMinutes();
            var hoursStr = hours < 10 ? '0' + hours : String(hours);
            var minutesStr = minutes < 10 ? '0' + minutes : String(minutes);
            return hoursStr + ":" + minutesStr;
        }
        function formatTimeString12Hour(timeStr) {
            var baseTime = extractBaseTime(timeStr).trim();
            // Check if there's additional text after the base time
            var additionalText = timeStr.includes('(') ? timeStr.substring(timeStr.indexOf('(')) : '';
            var _a = baseTime.split(':'), hoursStr = _a[0], minutesStr = _a[1];
            if (!hoursStr || !minutesStr)
                return timeStr; // Return original if format is unexpected
            var hours = parseInt(hoursStr, 10);
            var minutes = parseInt(minutesStr, 10);
            if (isNaN(hours) || isNaN(minutes))
                return timeStr;
            // Convert to 12-hour format
            var ampm = hours >= 12 ? 'PM' : 'AM';
            var displayHours = hours % 12;
            displayHours = displayHours ? displayHours : 12;
            var displayMinutes = minutes < 10 ? '0' + minutes : minutes;
            return "".concat(displayHours, ":").concat(displayMinutes, " ").concat(ampm).concat(additionalText ? ' ' + additionalText : '');
        }
        function formatDateToYYYYMMDD(d) {
            return (d.getFullYear() +
                '-' +
                String(d.getMonth() + 1).padStart(2, '0') +
                '-' +
                String(d.getDate()).padStart(2, '0'));
        }
        // ---- Adding checkHoldDates to detect a date change or update and then and Trigger ChangeOrder -----//
        function checkMedHoldDatesUpdate(hldstartdate, hldenddate) {
            if (isEditForm && editFormdata.value.medholdstartdate != hldstartdate || editFormdata.value.medholdenddate != hldenddate) {
                changeActiveMed.value = true; //Should trigger Emit for Change Order 
                ifStatusIsChange.value = true; //Reason for change should now be showing 
            }
            else {
                changeActiveMed.value = false; //Should trigger Emit for Change Order 
                ifStatusIsChange.value = false; //Reason for change should now be showing
            }
        }
        // ---- Adding checkMedActiveStatus to check lock status and Trigger Hold Modal -----//
        function checkMedActiveStatus(obj, frequency) {
            if (isEditForm.value && editFormdata.value && editFormdata.value.med_frequency != frequency) {
                //I think they are chanign the frequency and we need to alert them that its a change order
                changeActiveMed.value = true;
                ifStatusIsChange.value = true; //Reason for change should now be showing
            }
            else {
                // Check if dosage also matches - only set to false if both frequency AND dosage match
                if (editFormdata.value && editFormdata.value.med_frequency == frequency) {
                    // Check if dosage also matches original
                    var currentDosage = selectedDosage.value;
                    var originalDosage = editFormdata.value.med_amount;
                    if (originalDosage == currentDosage) {
                        changeActiveMed.value = false;
                        ifStatusIsChange.value = false; //disable the Reason for change field
                    }
                    // If dosage doesn't match, keep change order active (handled by checkMedActiveDosageStatus)
                }
                // changeActiveMed.value = false;
                // ifStatusIsChange.value = false; //disable the Reason for change field
            }
            /* let tempstatus = obj.temporaryStatus.split(",");
             
             if(tempstatus[0]=="taken" || tempstatus[0]=="hold" && tempstatus !=null)
             {
               changeActiveMed.value =true;
              
             }
             else{
               changeActiveMed.value=false;
             } */
        }
        //----Adding function for checkMedActiveDosageStatus-----//
        function checkMedActiveDosageStatus(obj, dosage) {
            selectedDosage.value = dosage;
            if (isEditForm.value && editFormdata.value && editFormdata.value.med_amount != dosage) {
                //I think they are changing the dosage and we need to alert them that its a change order
                changeActiveMed.value = true;
                ifStatusIsChange.value = true; //Reason for change should now be showing
            }
            else {
                // Check if frequency also matches - only set to false if both dosage AND frequency match
                if (editFormdata.value && editFormdata.value.med_amount == dosage) {
                    // Check if frequency also matches original
                    var currentFrequency = selectedFrequency.value;
                    var originalFrequency = editFormdata.value.med_frequency;
                    if (originalFrequency == currentFrequency) {
                        changeActiveMed.value = false;
                        ifStatusIsChange.value = false; //disable the Reason for change field
                    }
                    // If frequency doesn't match, keep change order active (handled by checkMedActiveStatus)
                }
            }
        }
        // ---------- STATUS & SORT ----------
        var statusOptions = (0, vue_3.computed)(function () {
            var base = [
                { value: 'active', label: 'Active', color: '#d4edda' },
                { value: 'discontinue', label: 'Discontinue', color: '#f8d7da' },
                { value: 'hold', label: 'Hold', color: '#fff3cd' },
                { value: 'new', label: 'New', color: '#869ccd' },
                { value: 'pending', label: 'Pending', color: '#bf86cd' },
                { value: 'change', label: 'Change', color: '#bf8d05' },
                { value: 'completed', label: 'Completed', color: '#00f445' },
                { value: 'partial', label: 'Partial', color: '#ff69b4' }
            ];
            return base.filter(function (option) {
                if (option.value === 'hold' && !canMedicationHold.value)
                    return false;
                if (option.value === 'discontinue' && !canMedicationDiscontinue.value)
                    return false;
                return true;
            });
        });
        function handleSort(type) {
            sortBy.value = type;
        }
        function handleStatusFilter(status) {
            selectedStatus.value = selectedStatus.value === status ? null : status;
            sortBy.value = ''; //"Medication";//reset bottom filter 
        }
        // ---------- GROUPING ----------
        var routeCategories = [
            'PRN',
            'Neb/INH',
            'Oral/Sublingual',
            'IVI Intravaginal',
            'SQ/IM/IV/ID',
            'NAS Intranasal',
            'TD Transdermal',
            'TOP Topical',
            'Urethral',
            'Rectally',
            'Optic',
            'Otic'
        ];
        function groupMedicationsByDiagnosis(meds) {
            var grouped = {};
            meds.forEach(function (med) {
                var diag = med.diagnose_code || 'Unspecified Diagnosis';
                if (!grouped[diag]) {
                    grouped[diag] = [];
                }
                grouped[diag].push(med);
            });
            var keys = Object.keys(grouped).sort(function (a, b) { return a.localeCompare(b); });
            var sortedDiags = {};
            keys.forEach(function (key) {
                sortedDiags[key] = grouped[key];
            });
            return sortedDiags;
        }
        var groupedMedications = (0, vue_3.computed)(function () {
            // let sortedMeds = [...medications.value]
            // Chris version, just this one line change
            var sortedMeds = __spreadArray([], (Array.isArray(medications.value) ? medications.value : []), true).filter(function (med) { return isMedicationVisible(med); });
            //  let sortedMeds = [...medications.value].filter(med => isMedicationVisible(med))
            if (selectedStatus.value) {
                var lc_1 = function (v) { return String(v !== null && v !== void 0 ? v : '').toLowerCase(); };
                var sel_1 = lc_1(selectedStatus.value);
                //alert(sel);
                if (sel_1 === 'active') {
                    sortedMeds = sortedMeds.filter(function (med) { return lc_1((med.status === 'active' || med.status === 'Active-pending')); });
                }
                else if (sel_1 === 'change') {
                    sortedMeds = sortedMeds.filter(function (med) { return lc_1(med.medchangetype) === 'change'; });
                }
                else if (sel_1 === 'pending') {
                    sortedMeds = sortedMeds.filter(function (med) { return lc_1(med.medchangetype) === 'pending'; });
                }
                else if (sel_1 === 'new') {
                    sortedMeds = sortedMeds.filter(function (med) { return lc_1(med.tagstatus) === 'new,new'; });
                }
                else if (sel_1 === 'discontinue') {
                    sortedMeds = sortedMeds.filter(function (med) { return lc_1((med.tagstatus || med.medchangetype)) === 'discontinue'; });
                }
                else {
                    // fallback: compare against medchangetype safely
                    sortedMeds = sortedMeds.filter(function (med) { return lc_1(med.medchangetype) === sel_1; });
                }
            }
            var groups = {};
            if (sortBy.value === 'time') {
                var allTimes_1 = new Set();
                sortedMeds.forEach(function (med) {
                    if (med.prn !== '1' && med.dates) {
                        Object.values(med.dates).forEach(function (timeArray) {
                            timeArray.forEach(function (obj) {
                                allTimes_1.add(extractBaseTime(obj.time));
                            });
                        });
                    }
                });
                var sortedTimes = Array.from(allTimes_1).sort(function (a, b) {
                    var timeA = new Date('1970/01/01 ' + a);
                    var timeB = new Date('1970/01/01 ' + b);
                    return timeA.getTime() - timeB.getTime();
                });
                sortedTimes.forEach(function (time) {
                    groups[time] = [];
                    var uniqueMedSet = new Set();
                    sortedMeds.forEach(function (med) {
                        if (med.prn !== '1' && med.dates) {
                            Object.values(med.dates).forEach(function (arr) {
                                arr.forEach(function (tObj) {
                                    if (extractBaseTime(tObj.time) === time && !uniqueMedSet.has(med.medentryid)) {
                                        groups[time].push(med);
                                        uniqueMedSet.add(med.medentryid);
                                    }
                                });
                            });
                        }
                    });
                });
            }
            else if (sortBy.value === 'prn') {
                var prnMeds = sortedMeds.filter(function (med) { return med.prn === '1'; });
                if (prnMeds.length > 0) {
                    groups['PRN Medications'] = prnMeds;
                }
            }
            else if (sortBy.value === 'route') {
                routeCategories.forEach(function (route) {
                    var medsForRoute = sortedMeds.filter(function (med) { return med.route === route; });
                    if (medsForRoute.length > 0) {
                        groups[route] = medsForRoute;
                    }
                });
                var uncategorized = sortedMeds.filter(function (med) { return !med.route || !routeCategories.includes(med.route); });
                if (uncategorized.length > 0) {
                    groups['Uncategorized'] = uncategorized;
                }
            }
            else if (sortBy.value === 'diagnosis') {
                var groupedByDiagnosis = groupMedicationsByDiagnosis(sortedMeds);
                Object.assign(groups, groupedByDiagnosis);
            }
            else if (sortBy.value === 'medication') {
                sortedMeds.sort(function (a, b) { return a.medname.localeCompare(b.medname); });
                groups['All Medications'] = sortedMeds;
            }
            else {
                groups['All Medications'] = sortedMeds;
            }
            Object.keys(groups).forEach(function (key) {
                if (groups[key].length === 0) {
                    //alert("Groups");
                    //alert(groups);
                    //remove keys
                    //delete groups[key]
                }
            });
            return groups;
        });
        // ---------- ALL COLUMNS ----------
        var allColumns = (0, vue_3.computed)(function () {
            if (dateList.value.length > 0) {
                var cols = dateList.value.map(function (d) { return normalizeToMidnight(d); });
                cols.sort(function (a, b) { return a.getTime() - b.getTime(); });
                return cols;
            }
            else {
                return [normalizeToMidnight(currentDate.value)];
            }
        });
        // ---------- LOAD & WATCH ----------
        function loadMedications() {
            return __awaiter(this, void 0, void 0, function () {
                var content;
                var _a, _b, _c, _d;
                return __generator(this, function (_e) {
                    /* const savedMedications = localStorage.getItem('medications')
                     let errorMessage=""
                     if (savedMedications) {
                       //medications.value = JSON.parse(savedMedications)
                     }*/
                    //  Check if patient is logged in, resolve session timeout issue
                    if (!((_a = patient.value) === null || _a === void 0 ? void 0 : _a.externId) || !((_b = patient.value) === null || _b === void 0 ? void 0 : _b.externId2)) {
                        return [2 /*return*/];
                    }
                    content = {
                        MedicationAdmin: {
                            API_Meth: "GetPatientMeds",
                            pid: patient.value.externId,
                            accountId: patient.value.externId2,
                            providerid: "123456789", // (needs to be this dynamic data but pacmny-fe not prov proper data attr yet)allData.value.manager.npi
                            proflicensenumber: "609382",
                            provsubaccount: ((_d = (_c = allData.value) === null || _c === void 0 ? void 0 : _c.manager) === null || _d === void 0 ? void 0 : _d.externid) || ''
                        }
                    };
                    axios_1.default.post(apis_1.CURR_API + '/tswebhook.php', content)
                        .then(function (response) {
                        if (response.data.code == '304' && response.data.error == '304-Order Creation' && response.data.errorMsg != "") {
                            //If HoldAuto Expire Code have issue 
                            alert(response.data.errorMsg);
                        }
                        else if (response.data.code === "700-SQL" && response.data.error) {
                            alert(response.data.results);
                        }
                        else if (response.data.code === "304-System" && response.data.error === "Provider information do not match") {
                            alert(response.data.results);
                        }
                        // A failed read comes back as a 200 carrying the legacy error
                        // envelope, which has no `records` key — so this used to throw
                        // "cannot read properties of undefined" inside the .then and the MAR
                        // rendered as an empty grid with a console error nobody sees. An
                        // empty MAR is indistinguishable from "this patient has no
                        // medications", which is the one thing it must never be mistaken for.
                        if (!Array.isArray(response.data.records)) {
                            errorMessage.value = response.data.message || 'The medication record could not be loaded.';
                            alert('The medication record could not be loaded: ' + errorMessage.value);
                            return;
                        }
                        medications.value = response.data.records;
                        var cur = new Date();
                        /*let tstdt = new Date(med.administrated_at);
                        console.log("Test medDt:"+" "+ med.administrated_at);
                        *If you use Dates from the database it will set the Date column to that date and you can't administered past med | So this means that you can only view today
                        * of each day to administer the meds. Keep this in mind for adjustments
                        *
                        */
                        dateList.value.push(normalizeToMidnight(cur)); //setting this to today's date so that populateMedicationTable can load the times into the slots
                        populateMedicationTable();
                        errorMessage.value = ""; // Clear any previous error messages     
                    })
                        .catch(function (error) {
                        var _a, _b, _c;
                        if (axios_1.default.isAxiosError(error)) {
                            console.error('Error posting data:', ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) || error.message);
                            errorMessage.value = ((_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) || 'An error occurred while posting data.';
                        }
                        else {
                            errorMessage.value = 'An unexpected error occurred. Please try again.';
                        }
                    });
                    return [2 /*return*/];
                });
            });
        }
        /*watch(medications, (newVal) => {
          localStorage.setItem('medications', JSON.stringify(newVal));
          console.log("Keyon watching localStorate");
          console.log(localStorage.getItem("medications"));
          if(newVal.length >0)
          {
            medications.value = newVal;
            //populateMedicationTable()
          }
          //medications.value = newVal;
          
        }, { deep: true }) */
        var props = __props;
        (0, vue_3.watch)(function () { return props.medications; }, function (newMeds) {
            if (newMeds && newMeds.length > 0) {
                medications.value = __spreadArray([], newMeds, true);
            }
        }, { immediate: true });
        var emit = __emit;
        // ---------- FREQUENCY WATCH ----------
        (0, vue_3.watch)(selectedFrequency, function (newFreq) {
            if (!newFreq || (selectedMedicationForTime.value && selectedMedicationForTime.value.prn === '1')) {
                timeInputs.value = [];
                return;
            }
            var timesCount = getTimesCountFromFrequency(newFreq);
            // Preserve existing times when frequency changes
            var existingTimes = __spreadArray([], timeInputs.value, true).filter(function (t) { return t && t.trim() !== ''; });
            // Create new array with preserved times, filling remaining slots with empty strings
            timeInputs.value = Array.from({ length: timesCount }, function (_, i) {
                return i < existingTimes.length ? existingTimes[i] : '';
            });
        });
        // Chris version below, might need to be adjusted
        // watch(selectedFrequency, (newFreq) => {
        //   if (selectedMedicationForTime.value?.prn || !newFreq) {
        //     timeInputs.value = []
        //     return
        //   }
        //   const count = getTimesCountFromFrequency(newFreq)
        //   const existingTimes = [...timeInputs.value]
        //   timeInputs.value = Array.from({ length: count }, (_, i) =>
        //     i < existingTimes.length ? existingTimes[i] : ''
        //   )
        // })
        function getTimesCountFromFrequency(frequency) {
            // alert("Frequncy in GetTimesCount"+" "+ frequency);
            if (!frequency)
                return 0;
            var dailyMatch = frequency.match(/(\d+)\s*times?\s*daily/);
            //alert(dailyMatch);
            if (dailyMatch) {
                return parseInt(dailyMatch[1], 10);
            }
            var hoursMatch = frequency.match(/every\s*(\d+)\s*hours?/);
            if (hoursMatch) {
                var hours = parseInt(hoursMatch[1], 10);
                return Math.floor(24 / hours);
            }
            switch (frequency) { //12/3/25 Expandng mapping for frequency - confirm question with Dr/team about freq mapping with ambigous terms
                case 'every hour': return 24;
                case 'daily': return 1;
                case 'at bedtime': return 1;
                case 'every 24 hours': return 1;
                case 'every other day': return 4;
                case 'monday, wednesday, friday, sunday': return 4;
                case 'tuesday, thursday, saturday': return 3;
                case 'bi-weekly': return 2;
                case 'as needed': return 1;
                case 'before every meal': return 3;
                case 'every day': return 1;
                case 'every month': return 1;
                case 'as directed': return 1;
                default: return 1;
            }
        }
        // ---------- TIME & DOSAGE MODAL ----------
        function toggleSelectDropdown(medication) {
            if (ifOrderSigned(medication))
                return;
            if (medication.tabsAvailable <= 0) {
                errorMessage.value = "Please add tabs available";
                showErrorModal.value = true;
                return;
            }
            selectedMedicationForTime.value = medication;
            selectedDosage.value = medication.med_amount || '1';
            if (!selectedMedStatusForTime.value) //if this is empty lets set the status to Active 
             {
                selectedMedStatusForTime.value = "pending";
            }
            if (medication.administrationTimes && medication.administrationTimes !== 'As needed') {
                //need to see whats here 
                var splitted_1 = medication.administrationTimes.split(',');
                // Reset frequency to trigger watcher
                selectedFrequency.value = '';
                // First set frequency to trigger watcher
                (0, vue_3.nextTick)(function () {
                    selectedFrequency.value = medication.med_frequency || '';
                    // Then overwrite admin times in case the frequency is the same
                    (0, vue_3.nextTick)(function () {
                        timeInputs.value = splitted_1.map(function (t) { return t.trim(); });
                    });
                });
            }
            else {
                selectedFrequency.value = '';
                // Use nextTick to ensure reset before setting new value
                (0, vue_3.nextTick)(function () {
                    selectedFrequency.value = medication.med_frequency || '';
                });
            }
            showTimeModal.value = true;
        }
        // Chris version below, might need to be adjusted
        // function toggleSelectDropdown(med: Medication) {
        //   if (med.tabsAvailable <= 0) {
        //     errorMessage.value = "Please add tabs available"
        //     showErrorModal.value = true
        //     return
        //   }
        //   selectedMedicationForTime.value = med
        //   let splitted: string[] = []
        //   if (med.administrationTimes && med.administrationTimes !== 'As needed') {
        //     splitted = med.administrationTimes.split(',').map(t => t.trim())
        //   }
        //   selectedFrequency.value = ''
        //   timeInputs.value = []
        //   nextTick(() => {
        //     selectedFrequency.value = med.frequency || ''
        //     selectedDosage.value = med.dosage || '1'
        //     if (!med.prn && splitted.length > 0) {
        //       timeInputs.value = splitted
        //     }
        //     showTimeModal.value = true
        //   })
        // }
        //---New async function -----//
        function handleSave(medication, nwtime, selectedFreq) {
            return __awaiter(this, void 0, void 0, function () {
                var ordnumber, normalizedNwtime, ismedlocked, med, medname, medholdstartdate, medholdenddate, medstatus, newTimeArray_1, courseRow, courseStart_1, courseEnd_1, todayMidnight, _i, _a, dStr, d, _loop_1, i, state_1, todaydt_1, changeorder_1, content;
                var _b, _c, _d, _e;
                return __generator(this, function (_f) {
                    ordnumber = '';
                    normalizedNwtime = [];
                    if (nwtime != null && nwtime !== undefined) {
                        if (typeof nwtime === 'object' && 'value' in nwtime) {
                            // It's a ref object
                            normalizedNwtime = Array.isArray(nwtime.value) ? nwtime.value : [];
                        }
                        else if (Array.isArray(nwtime)) {
                            // It's already a plain array
                            normalizedNwtime = nwtime;
                        }
                    }
                    if (isEditForm.value == true || isAddmedForm.value == true) {
                        selectedMedicationForTime.value = medication; //new line
                        timeInputs.value = normalizedNwtime;
                        if (!timeInputs.value || !Array.isArray(timeInputs.value)) {
                            timeInputs.value = [];
                        }
                        Reasaon4change.value = medication.coreason || ((_b = selectedMedicationForTime.value) === null || _b === void 0 ? void 0 : _b.coreason) || '';
                        ordnumber = selectedMedicationForTime.value.ordernumber;
                    }
                    else {
                        ordnumber = medication.order_number;
                    }
                    if (!selectedMedicationForTime.value) {
                        showTimeModal.value = false;
                        return [2 /*return*/];
                    }
                    if (!timeInputs.value || !Array.isArray(timeInputs.value)) {
                        timeInputs.value = [];
                    }
                    if (selectedMedicationForTime.value.prn !== '1' && timeInputs.value.length > 0) {
                        if (timeInputs.value.some(function (t) { return !t; })) {
                            errorMessage.value = "Please select all required times.";
                            showErrorModal.value = true;
                            return [2 /*return*/];
                        }
                    }
                    ismedlocked = (0, vue_3.ref)(false);
                    ismedlocked.value = changeActiveMed.value;
                    med = selectedMedicationForTime.value;
                    medname = (0, vue_3.ref)('');
                    medholdstartdate = (0, vue_3.ref)('');
                    medholdenddate = (0, vue_3.ref)('');
                    med.frequency = selectedFreq || selectedFrequency.value || med.med_frequency || '';
                    med.dosage = med.dosage || selectedDosage.value || med.med_amount || '1';
                    if (isEditForm.value == true) {
                        Reasaon4change.value = med.coreason;
                    }
                    if (isEditForm.value == true) {
                        medname.value = med.medicationName;
                    }
                    else {
                        medname.value = med.medname; //setting this so that I can grab the actual MedId that's needed to lo
                    }
                    if (isEditForm.value == true && med.medholdstartdate != "") {
                        medholdstartdate.value = med.medholdstartdate;
                    }
                    else {
                        medholdstartdate.value = "";
                    }
                    if (isEditForm.value == true && med.medholdenddate != "") {
                        medholdenddate.value = med.medholdenddate;
                    }
                    else {
                        medholdenddate.value = "";
                    }
                    if (changeActiveMed.value == true) {
                        med.status = "Change";
                    }
                    else {
                        med.status = "Active";
                    }
                    medstatus = med.status;
                    if (med.prn === '1') {
                        med.administrationTimes = 'As needed';
                        med.dates = {};
                    }
                    else {
                        //const newtime =[]; //new 
                        /*Need to check to see what Mode (Add or Edit) in order to account for the appropoirate inputTimes variale
                        * isEditMode = Located in the Medication object that was passed over
                        * isAddMed = Lcoated in the Medication/FormData object
                        * if its not either of them run original Parent inputTime needs to be used
                        * */
                        if (isEditForm.value == true && normalizedNwtime.length > 0) //should be in the object passed over from the emit
                         {
                            //I might need to pass the AddMedication timeInput const over to in order to build a newTimeArray const 
                            // timeInputs.value = normalizedNwtime;
                            // selectedDosage.value = med.value.dosage;
                        }
                        if (!timeInputs.value || !Array.isArray(timeInputs.value)) {
                            timeInputs.value = [];
                        }
                        newTimeArray_1 = timeInputs.value.filter(function (t) { return t; }).map(function (t) { return ({
                            time: t,
                            status: 'pending',
                            dosage: parseInt(selectedDosage.value, 10) || 1
                        }); });
                        med.administrationTimes = timeInputs.value.length > 0 ? timeInputs.value.join(', ') : '';
                        courseRow = (isEditForm.value && editFormdata.value) ? editFormdata.value : med;
                        courseStart_1 = (0, medicationCourseDates_1.changedCourseDate)(med.startDate, (_c = courseRow.med_startdate) !== null && _c !== void 0 ? _c : courseRow.startDate);
                        courseEnd_1 = (0, medicationCourseDates_1.changedCourseDate)(med.endDate, courseRow.endDate);
                        todayMidnight = normalizeToMidnight(new Date());
                        if (med.dates) {
                            for (_i = 0, _a = Object.keys(med.dates); _i < _a.length; _i++) {
                                dStr = _a[_i];
                                d = new Date(dStr);
                                if (normalizeToMidnight(d).getTime() >= todayMidnight.getTime()) {
                                    med.dates[dStr] = med.dates[dStr].filter(function (slot) {
                                        return slot.locked === true || slot.status === 'discontinue';
                                    });
                                }
                            }
                        }
                        _loop_1 = function (i) {
                            var futureDate = new Date(todayMidnight);
                            futureDate.setDate(futureDate.getDate() + i);
                            if (med.discontinuedDate && normalizeToMidnight(futureDate).getTime() > normalizeToMidnight(med.discontinuedDate).getTime()) {
                                return "break";
                            }
                            var ds = formatDateToYYYYMMDD(futureDate);
                            if (!med.dates) {
                                med.dates = {};
                            }
                            if (!med.dates[ds]) {
                                med.dates[ds] = [];
                            }
                            newTimeArray_1.forEach(function (t) {
                                var existing = med.dates[ds].find(function (slot) { return slot.time === t.time && (slot.locked || slot.status === 'discontinue'); });
                                if (!existing) {
                                    var idx = med.dates[ds].findIndex(function (slot) { return slot.time === t.time; });
                                    if (idx === -1) {
                                        med.dates[ds].push(__assign({}, t));
                                    }
                                    else {
                                        if (!med.dates[ds][idx].locked && med.dates[ds][idx].status !== 'discontinue') {
                                            med.dates[ds][idx] = __assign({}, t);
                                        }
                                    }
                                }
                            });
                        };
                        for (i = 0; i < FUTURE_DAYS_TO_POPULATE; i++) {
                            state_1 = _loop_1(i);
                            if (state_1 === "break")
                                break;
                        }
                        todaydt_1 = formatDate(new Date());
                        changeorder_1 = (0, vue_3.ref)(false);
                        //lets check to see if this med (normally setting the log time and date) is currenly logged and ative. If so the change will require a change order 
                        //alert(changeActiveMed.value);
                        if (changeActiveMed.value == true) {
                            sweetalert2_1.default.fire({
                                title: 'Change Order Required',
                                text: "You are changing Dose or Frequency of an active Medication and a New Order is required. Do you want to proceed? If not, the administrative time will be updated.",
                                icon: 'question',
                                showCancelButton: true,
                                confirmButtonText: 'Yes, proceed with change order',
                                cancelButtonText: 'No, just update times',
                                confirmButtonColor: '#0c8687',
                                cancelButtonColor: '#6c757d'
                            }).then(function (result) {
                                var _a, _b;
                                if (result.isConfirmed) {
                                    // User clicks yes
                                    changeorder_1.value = changeActiveMed.value;
                                    var now = new Date();
                                    var orderDate = now.toISOString().split('T')[0];
                                    var orderTime = now.toTimeString().split(' ')[0];
                                    var content = {
                                        MedicationAdmin: {
                                            API_Meth: "ChangeOrderForMedLogTimes",
                                            medentryid: med.medentryid, // 2026-10: names the line, so the rewrite and its flags stay on this medication, not every line of the order
                                            pid: allData.value.patient.externId,
                                            accountId: allData.value.patient.externId2,
                                            providerid: "123456789",
                                            slotedtimes: newTimeArray_1,
                                            adminDate: todaydt_1,
                                            medname: medname.value,
                                            ordernumber: ordnumber,
                                            status: medstatus,
                                            changeorder: changeorder_1.value,
                                            changereason: Reasaon4change.value || '',
                                            frequency: selectedFreq || selectedFrequency.value || med.med_frequency || med.frequency || '',
                                            dosage: med.dosage || selectedDosage.value || med.med_amount || '',
                                            provsubaccount: allData.value.manager.externid,
                                            diagnosis: med.diagnosis || '',
                                            medholdstartdate: medholdstartdate.value,
                                            medholdenddate: medholdenddate.value,
                                            route: med.route || '',
                                            prn: med.prn === true || med.prn === '1' || med.prn === 1,
                                            unitType: med.unitType || med.med_doseuom || '',
                                            ndcnumber: med.ndcNumber || med.ndcnumber || '',
                                            rxnorns: med.rxNumber || med.rxnorns || '',
                                            quantity: med.tabsAvailable || med.total || 0,
                                            providerName: med.providerName || med.providername || '',
                                            providerNpi: med.providerNpi || med.providernpi || '',
                                            providerDea: med.providerDea || med.providerdeanumber || '',
                                            providerAddress: med.providerAddress || med.provideraddress || '',
                                            providerOffice: med.providerOffice || med.provideroffice || '',
                                            providerCell: med.providerCell || med.providercell || '',
                                            providerEmail: med.providerEmail || med.provideremail || '',
                                            previousProvider: med.previousProvider || '',
                                            pharmacyName: med.pharmacyName || med.pharmacy || '',
                                            pharmacyNpi: med.pharmacyNpi || '',
                                            pharmacyDea: med.pharmacyDea || med.pharmacyDea || '',
                                            pharmacyAddress: med.pharmacyAddress || '',
                                            pharmacyPhone: med.pharmacyPhone || med.pharmacyOffice || med.pharmacyoffice || '',
                                            pharmacyCell: med.pharmacyCell || med.pharmacycell || '',
                                            pharmacyEmail: med.pharmacyEmail || med.pharmacyemail || '',
                                            orderDate: orderDate,
                                            orderTime: orderTime,
                                            writerName: allData.value.manager.name,
                                            // Prescription data
                                            rxNumber: med.rxNumber || med.rxnorns || '',
                                            filledDate: med.filledDate || '',
                                            refills: med.refills || 0,
                                            startDate: courseStart_1,
                                            endDate: courseEnd_1,
                                            refillReminderDate: med.refillReminderDate || '',
                                            expirationDate: med.expirationDate || ''
                                        }
                                    };
                                    // Show loading popup
                                    sweetalert2_1.default.fire({
                                        title: 'Saving medication...',
                                        text: 'Please wait while the medication change order is being processed.',
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                        showConfirmButton: false,
                                        didOpen: function () {
                                            sweetalert2_1.default.showLoading();
                                        }
                                    });
                                    axios_1.default.post(apis_1.CURR_API + '/tswebhook.php', content)
                                        .then(function (response) {
                                        sweetalert2_1.default.close();
                                        // Check for success response
                                        if (response.data && (response.data.results == "Insert" || response.data.results == "Updated")) {
                                            sweetalert2_1.default.fire({
                                                icon: 'success',
                                                title: 'Change Order Created Successfully',
                                                text: 'Medication changes made successfully. However, meds are pending until provider signs the Pending Order.',
                                                confirmButtonText: 'Ok'
                                            }).then(function () {
                                                // Close edit popup and reset state
                                                showAddForm.value = false;
                                                isEditForm.value = false;
                                                editFormdata.value = null;
                                                dateList.value = []; //should be reset now. 
                                                changeActiveMed.value = false;
                                                ifStatusIsChange.value = false;
                                                //lets update the the data for the app 
                                                loadMedications();
                                            });
                                            return;
                                        }
                                        // Check for error responses with code field
                                        else if (response.data && (response.data.code && response.data.code.includes("Error") || response.data.code && response.data.code.includes("402"))) {
                                            var errorMessage_1 = 'There was a problem processing the change order.';
                                            if (response.data.message) {
                                                errorMessage_1 = response.data.message;
                                            }
                                            else if (response.data.error) {
                                                errorMessage_1 = typeof response.data.error === 'string' ? response.data.error : 'An error occurred during processing.';
                                            }
                                            else if (response.data.code) {
                                                errorMessage_1 = response.data.code;
                                            }
                                            sweetalert2_1.default.fire({
                                                icon: 'error',
                                                title: 'Change Order Failed',
                                                text: errorMessage_1,
                                                confirmButtonText: 'Ok'
                                            });
                                            return;
                                        }
                                        // Check for error status field
                                        else if (response.data && response.data.status && response.data.status.includes("Error")) {
                                            var errorMessage_2 = 'There was a problem processing the change order.';
                                            // The bridge carries an API refusal's sentence as `message`.
                                            if (response.data.message) {
                                                errorMessage_2 = response.data.message;
                                            }
                                            else if (response.data.error) {
                                                errorMessage_2 = typeof response.data.error === 'string' ? response.data.error : JSON.stringify(response.data.error);
                                            }
                                            sweetalert2_1.default.fire({
                                                icon: 'error',
                                                title: 'Change Order Failed',
                                                text: errorMessage_2,
                                                confirmButtonText: 'Ok'
                                            });
                                            return;
                                        }
                                        // Unexpected response format
                                        else {
                                            sweetalert2_1.default.fire({
                                                icon: 'error',
                                                title: 'Unexpected Response',
                                                text: 'The server returned an unexpected response format. Please try again or contact support if the problem persists.',
                                                confirmButtonText: 'Ok'
                                            });
                                            return;
                                        }
                                    })
                                        .catch(function (error) {
                                        var _a, _b, _c;
                                        sweetalert2_1.default.close();
                                        var errorText = 'An error occurred while processing the change order. Please try again.';
                                        if (axios_1.default.isAxiosError(error)) {
                                            console.error('Error posting data:', ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) || error.message);
                                            errorText = ((_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) || errorText;
                                        }
                                        else {
                                        }
                                        sweetalert2_1.default.fire({
                                            icon: 'error',
                                            title: 'Error Processing Change Order',
                                            text: errorText,
                                            confirmButtonText: 'Ok'
                                        });
                                    });
                                }
                                else {
                                    // User clicks no, just update times without change order
                                    var content = {
                                        MedicationAdmin: {
                                            API_Meth: "InsertUpdateMedLogTimes",
                                            medentryid: med.medentryid, // 2026-10: names the line, so the rewrite and its flags stay on this medication, not every line of the order
                                            pid: allData.value.patient.externId, // "709081242",
                                            accountId: allData.value.patient.externId2, //"904575107",
                                            providerid: med.providerNpi || med.providernpi || allData.value.manager.externid || '',
                                            provsubaccount: ((_b = (_a = allData.value) === null || _a === void 0 ? void 0 : _a.manager) === null || _b === void 0 ? void 0 : _b.externid) || '', // 2026-10 (#336): who changed the times, for History (providerid is the prescriber's NPI)
                                            slotedtimes: newTimeArray_1,
                                            adminDate: todaydt_1,
                                            medname: medname.value, // 2026-10 (#335): was the ref itself - keyon got an object and failed (500) on every "No, just update times"
                                            ordernumber: med.ordernumber, // Order number is hard coded for now but should or could be set when the admin app is loaded || or when loaded it could pass the order information as param
                                            status: medstatus,
                                            changeorder: false,
                                            changereason: Reasaon4change.value || ''
                                        }
                                    };
                                    // Show loading popup
                                    sweetalert2_1.default.fire({
                                        title: 'Saving medication...',
                                        text: 'Please wait while the medication times are being updated.',
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                        showConfirmButton: false,
                                        didOpen: function () {
                                            sweetalert2_1.default.showLoading();
                                        }
                                    });
                                    axios_1.default.post(apis_1.CURR_API + '/tswebhook.php', content)
                                        .then(function (response) {
                                        sweetalert2_1.default.close();
                                        // Check for success Insert
                                        if (response.data && response.data.results == "Insert") {
                                            sweetalert2_1.default.fire({
                                                icon: 'success',
                                                title: 'Medication Times Added Successfully',
                                                text: 'The medication times have been added successfully.',
                                                confirmButtonText: 'Ok'
                                            }).then(function () {
                                                // Close edit popup and reset state
                                                showAddForm.value = false;
                                                isEditForm.value = false;
                                                editFormdata.value = null;
                                                dateList.value = []; //should be reset now. 
                                                changeActiveMed.value = false;
                                                ifStatusIsChange.value = false;
                                                //lets update the the data for the app 
                                                loadMedications();
                                            });
                                            return;
                                        }
                                        // Check for success Update
                                        else if (response.data && response.data.results == "Updated") {
                                            sweetalert2_1.default.fire({
                                                icon: 'success',
                                                title: 'Medication has been successfully updated.',
                                                // text: 'The medication times have been updated successfully.',
                                                confirmButtonText: 'Ok'
                                            }).then(function () {
                                                // Close edit popup and reset state
                                                showAddForm.value = false;
                                                isEditForm.value = false;
                                                editFormdata.value = null;
                                                dateList.value = []; //should be reset now. 
                                                changeActiveMed.value = false;
                                                ifStatusIsChange.value = false;
                                                //lets update the the data for the app 
                                                loadMedications();
                                            });
                                            return;
                                        }
                                        // Check for error responses with code field
                                        else if (response.data && response.data.code && (response.data.code.includes("Error") || response.data.code.includes("402"))) {
                                            var errorMessage_3 = 'A New MedLog Entry Failed to be established.';
                                            if (response.data.message) {
                                                errorMessage_3 = response.data.message;
                                            }
                                            else if (response.data.code) {
                                                errorMessage_3 = response.data.code;
                                            }
                                            sweetalert2_1.default.fire({
                                                icon: 'error',
                                                title: 'Change Order Required',
                                                text: errorMessage_3,
                                                confirmButtonText: 'Ok'
                                            });
                                            return;
                                        }
                                        // An API refusal, as the bridge answers it ({status:'Error', message}
                                        // with no keyon code): the server's sentence says why the times were
                                        // not changed — a change waiting for its change order keeps the times
                                        // that change order describes, for one (FX-ORDERS).
                                        else if (response.data && response.data.status === 'Error' && response.data.message) {
                                            sweetalert2_1.default.fire({
                                                icon: 'error',
                                                title: 'Times Not Changed',
                                                text: response.data.message,
                                                confirmButtonText: 'Ok'
                                            });
                                            return;
                                        }
                                        // Unexpected response format
                                        else {
                                            sweetalert2_1.default.fire({
                                                icon: 'error',
                                                title: 'Unexpected Response',
                                                text: 'The server returned an unexpected response format. Please try again or contact support if the problem persists.',
                                                confirmButtonText: 'Ok'
                                            });
                                            return;
                                        }
                                    })
                                        .catch(function (error) {
                                        var _a, _b, _c, _d, _e, _f, _g;
                                        sweetalert2_1.default.close();
                                        var errorText = 'An error occurred while updating the medication times. Please try again.';
                                        if (axios_1.default.isAxiosError(error)) {
                                            console.error('Error posting data:', ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) || error.message);
                                            if ((_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) {
                                                errorText = error.response.data.message;
                                            }
                                            else if ((_e = (_d = error.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.code) {
                                                errorText = error.response.data.code;
                                            }
                                            else if ((_g = (_f = error.response) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.error) {
                                                errorText = typeof error.response.data.error === 'string' ? error.response.data.error : 'An error occurred during processing.';
                                            }
                                        }
                                        else {
                                        }
                                        sweetalert2_1.default.fire({
                                            icon: 'error',
                                            title: 'Error Updating Medication Times',
                                            text: errorText,
                                            confirmButtonText: 'Ok'
                                        });
                                    });
                                }
                            });
                        }
                        else {
                            content = {
                                MedicationAdmin: {
                                    API_Meth: "InsertUpdateMedLogTimes",
                                    medentryid: med.medentryid, // 2026-10: names the line, so the rewrite and its flags stay on this medication, not every line of the order
                                    pid: allData.value.patient.externId, //"709081242",
                                    accountId: allData.value.patient.externId2, //"904575107",
                                    providerid: med.providerNpi || med.providernpi || allData.value.manager.externid || '',
                                    provsubaccount: ((_e = (_d = allData.value) === null || _d === void 0 ? void 0 : _d.manager) === null || _e === void 0 ? void 0 : _e.externid) || '', // 2026-10 (#336): who changed the times, for History (providerid is the prescriber's NPI)
                                    slotedtimes: newTimeArray_1,
                                    adminDate: todaydt_1,
                                    medname: medname.value,
                                    ordernumber: med.ordernumber, //'36', // Order number is hard coded for now but should or could be set when the admin app is loaded || or when loaded it could pass the order information as param
                                    status: medstatus,
                                    changeorder: false,
                                    // Medication data to update
                                    diagnosis: med.diagnosis || '',
                                    dosage: med.dosage || selectedDosage.value || med.med_amount || '',
                                    frequency: selectedFreq || selectedFrequency.value || med.med_frequency || med.frequency || '',
                                    route: med.route || '',
                                    prn: med.prn === true || med.prn === '1' || med.prn === 1,
                                    unitType: med.unitType || med.med_doseuom || '',
                                    // Provider information
                                    providerName: med.providerName || med.providername || '',
                                    providerNpi: med.providerNpi || med.providernpi || '',
                                    providerDea: med.providerDea || med.providerdeanumber || '',
                                    providerAddress: med.providerAddress || med.provideraddress || '',
                                    providerOffice: med.providerOffice || med.provideroffice || '',
                                    providerCell: med.providerCell || med.providercell || '',
                                    providerEmail: med.providerEmail || med.provideremail || '',
                                    previousProvider: med.previousProvider || '',
                                    // Pharmacy information
                                    pharmacyName: med.pharmacyName || med.pharmacy || '',
                                    pharmacyNpi: med.pharmacyNpi || '',
                                    pharmacyDea: med.pharmacyDea || '',
                                    pharmacyAddress: med.pharmacyAddress || '',
                                    pharmacyPhone: med.pharmacyPhone || med.pharmacyOffice || med.pharmacyoffice || '',
                                    pharmacyCell: med.pharmacyCell || med.pharmacycell || '',
                                    pharmacyEmail: med.pharmacyEmail || med.pharmacyemail || '',
                                    // Additional fields
                                    ndcnumber: med.ndcnumber || med.ndcNumber || '',
                                    rxnorns: med.rxnorns || med.rxNumber || '',
                                    quantity: med.quantity || med.total || 0,
                                    administration: isAdminFlagOn(med) ? 1 : 0,
                                    prepour: med.prepour === true || med.prepour === 1 || med.prepour === '1' ? 1 : 0,
                                    nebulizer: med.nebulizer === true || med.nebulizer === 1 || med.nebulizer === '1' ? 1 : 0,
                                    // Prescription data
                                    rxNumber: med.rxNumber || med.rxnorns || '',
                                    filledDate: med.filledDate || '',
                                    refills: med.refills || 0,
                                    startDate: courseStart_1,
                                    endDate: courseEnd_1,
                                    refillReminderDate: med.refillReminderDate || '',
                                    expirationDate: med.expirationDate || ''
                                }
                            };
                            // Show loading popup
                            sweetalert2_1.default.fire({
                                title: 'Saving medication...',
                                text: 'Please wait while the medication is being saved.',
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                showConfirmButton: false,
                                didOpen: function () {
                                    sweetalert2_1.default.showLoading();
                                }
                            });
                            axios_1.default.post(apis_1.CURR_API + '/tswebhook.php', content)
                                .then(function (response) {
                                sweetalert2_1.default.close();
                                // Check for success Insert
                                if (response.data && response.data.results == "Insert") {
                                    sweetalert2_1.default.fire({
                                        icon: 'success',
                                        title: 'Medication Times Added Successfully',
                                        text: 'The medication times have been added successfully.',
                                        confirmButtonText: 'Ok'
                                    }).then(function () {
                                        // Close edit popup and reset state
                                        showAddForm.value = false;
                                        isEditForm.value = false;
                                        editFormdata.value = null;
                                        dateList.value = []; //should be reset now. 
                                        changeActiveMed.value = false;
                                        ifStatusIsChange.value = false;
                                        //lets update the the data for the app 
                                        loadMedications();
                                    });
                                    return;
                                }
                                // Check for success Update
                                else if (response.data && response.data.results == "Updated") {
                                    sweetalert2_1.default.fire({
                                        icon: 'success',
                                        title: 'Medication has been successfully updated.',
                                        // text: 'The medication times have been updated successfully.',
                                        confirmButtonText: 'Ok'
                                    }).then(function () {
                                        // Close edit popup and reset state
                                        showAddForm.value = false;
                                        isEditForm.value = false;
                                        editFormdata.value = null;
                                        dateList.value = []; //should be reset now. 
                                        changeActiveMed.value = false;
                                        ifStatusIsChange.value = false;
                                        //lets update the the data for the app 
                                        loadMedications();
                                    });
                                    return;
                                }
                                // Check for error responses with code field
                                else if (response.data && response.data.code && (response.data.code.includes("Error") || response.data.code.includes("402"))) {
                                    var errorMessage_4 = 'A New MedLog Entry Failed to be established.';
                                    if (response.data.message) {
                                        errorMessage_4 = response.data.message;
                                    }
                                    else if (response.data.code) {
                                        errorMessage_4 = response.data.code;
                                    }
                                    sweetalert2_1.default.fire({
                                        icon: 'error',
                                        title: response.data.code && response.data.code.includes("402") ? 'Change Order Required' : 'Save Failed',
                                        text: errorMessage_4,
                                        confirmButtonText: 'Ok'
                                    });
                                    return;
                                }
                                // An API refusal, as the bridge answers it ({status:'Error', message}
                                // with no keyon code): the server's sentence says why the times were
                                // not changed — a change waiting for its change order keeps the times
                                // that change order describes, for one (FX-ORDERS).
                                else if (response.data && response.data.status === 'Error' && response.data.message) {
                                    sweetalert2_1.default.fire({
                                        icon: 'error',
                                        title: 'Times Not Changed',
                                        text: response.data.message,
                                        confirmButtonText: 'Ok'
                                    });
                                    return;
                                }
                                // Unexpected response format
                                else {
                                    sweetalert2_1.default.fire({
                                        icon: 'error',
                                        title: 'Unexpected Response',
                                        text: 'The server returned an unexpected response format. Please try again or contact support if the problem persists.',
                                        confirmButtonText: 'Ok'
                                    });
                                    return;
                                }
                            })
                                .catch(function (error) {
                                var _a, _b, _c, _d, _e, _f, _g;
                                sweetalert2_1.default.close();
                                var errorText = 'An error occurred while saving the medication. Please try again.';
                                if (axios_1.default.isAxiosError(error)) {
                                    console.error('Error posting data:', ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) || error.message);
                                    if ((_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) {
                                        errorText = error.response.data.message;
                                    }
                                    else if ((_e = (_d = error.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.code) {
                                        errorText = error.response.data.code;
                                    }
                                    else if ((_g = (_f = error.response) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.error) {
                                        errorText = typeof error.response.data.error === 'string' ? error.response.data.error : 'An error occurred during processing.';
                                    }
                                }
                                else {
                                }
                                sweetalert2_1.default.fire({
                                    icon: 'error',
                                    title: 'Error Saving Medication',
                                    text: errorText,
                                    confirmButtonText: 'Ok'
                                });
                            });
                        }
                    }
                    showTimeModal.value = false;
                    selectedMedicationForTime.value = null;
                    timeInputs.value = [];
                    return [2 /*return*/];
                });
            });
        }
        //---end saync function HandleSave ---//
        function handleCancel() {
            selectedMedicationForTime.value = null;
            timeInputs.value = [];
            changeActiveMed.value = false;
            ifStatusIsChange.value = false;
            editFormdata.value = null;
            isEditForm.value = false;
            isAddmedForm.value = false;
            showTimeModal.value = false;
        }
        // Label Scanner handlers
        function handleScanLabelClick() {
            showLabelScanner.value = true;
        }
        function handleLabelScanClose() {
            showLabelScanner.value = false;
        }
        function handleLabelScanned(text) {
            return __awaiter(this, void 0, void 0, function () {
                var parsedInfo, hasUsefulInfo, fdaInfo, error_1, scannedMedication, baseName, ingredients, rawDf, dfBase, routeMap, candidate, r, key, routeMap, error_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!text || !text.trim()) {
                                alert('No text was recognized from the label. Please try again with a clearer image.');
                                showLabelScanner.value = false;
                                return [2 /*return*/];
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 7, 8, 9]);
                            parsedInfo = (0, textParser_1.parseText)(text);
                            hasUsefulInfo = parsedInfo.medicationName ||
                                parsedInfo.ndcNumber ||
                                parsedInfo.rxNumber ||
                                parsedInfo.quantity ||
                                parsedInfo.route ||
                                parsedInfo.pharmacy ||
                                parsedInfo.prescriberInfo;
                            if (!hasUsefulInfo) {
                                alert('No medication information was recognized from the label. Please try again with a clearer image or different angle.');
                                showLabelScanner.value = false;
                                return [2 /*return*/];
                            }
                            fdaInfo = null;
                            if (!parsedInfo.ndcNumber) return [3 /*break*/, 5];
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            return [4 /*yield*/, (0, fdaApiUtils_1.fetchMedicationDetailsFromAPI)(parsedInfo.ndcNumber)];
                        case 3:
                            fdaInfo = _a.sent();
                            return [3 /*break*/, 5];
                        case 4:
                            error_1 = _a.sent();
                            console.error('Error performing FDA lookup:', error_1);
                            return [3 /*break*/, 5];
                        case 5:
                            scannedMedication = {
                                medname: '',
                                tabsAvailable: 0,
                                medchangetype: '',
                                providername: '',
                                providernpi: '',
                                providerdeanumber: '',
                                providerlicense: '',
                                provideraddress: '',
                                provideroffice: '',
                                providercell: '',
                                provideremail: '',
                                pharmacyoffice: '',
                                pharmacycell: '',
                                pharmacyemail: '',
                                medholdstartdate: '',
                                medholdenddate: ''
                            };
                            // Map medication name (enhance with FDA data if available)
                            if (fdaInfo) {
                                baseName = fdaInfo.brand_name || fdaInfo.generic_name || parsedInfo.medicationName || '';
                                if (fdaInfo.active_ingredients && fdaInfo.active_ingredients.length > 0) {
                                    ingredients = fdaInfo.active_ingredients.map(function (ing) { return "".concat(ing.name, ": ").concat(ing.strength); }).join(', ');
                                    scannedMedication.medname = "".concat(baseName, " (").concat(ingredients, ")");
                                }
                                else {
                                    scannedMedication.medname = baseName;
                                }
                                // Extract unit type from dosage form
                                if (fdaInfo.dosage_form) {
                                    rawDf = fdaInfo.dosage_form;
                                    dfBase = rawDf.split(',')[0].trim().toLowerCase();
                                    scannedMedication.med_doseuom = dfBase.charAt(0).toUpperCase() + dfBase.slice(1);
                                }
                                // Extract route information
                                if (fdaInfo.route && Array.isArray(fdaInfo.route) && fdaInfo.route.length > 0) {
                                    routeMap = {
                                        oral: 'Oral/Sublingual',
                                        sublingual: 'Oral/Sublingual',
                                        subcutaneous: 'SQ (Subcutaneous)',
                                        sq: 'SQ (Subcutaneous)',
                                        intramuscular: 'IM (Intramuscular)',
                                        im: 'IM (Intramuscular)',
                                        intravenous: 'IV (Intravenous)',
                                        iv: 'IV (Intravenous)',
                                        topical: 'TOP Topical',
                                        otic: 'Otic'
                                    };
                                    candidate = fdaInfo.route[0];
                                    r = candidate.toLowerCase();
                                    for (key in routeMap) {
                                        if (r.includes(key)) {
                                            scannedMedication.route = routeMap[key];
                                            break;
                                        }
                                    }
                                }
                            }
                            else {
                                scannedMedication.medname = parsedInfo.medicationName || '';
                            }
                            // Map other fields
                            if (parsedInfo.dosage) {
                                scannedMedication.med_amount = parsedInfo.dosage;
                            }
                            if (parsedInfo.ndcNumber) {
                                scannedMedication.ndcnumber = parsedInfo.ndcNumber;
                            }
                            if (parsedInfo.rxNumber) {
                                scannedMedication.rxnorns = parsedInfo.rxNumber;
                            }
                            if (parsedInfo.quantity) {
                                scannedMedication.available = parseInt(parsedInfo.quantity) || 0;
                                scannedMedication.total = parseInt(parsedInfo.quantity) || 0;
                            }
                            if (parsedInfo.route && !scannedMedication.route) {
                                routeMap = {
                                    'oral': 'Oral/Sublingual',
                                    'topical': 'TOP Topical',
                                    'subcutaneous': 'SQ (Subcutaneous)',
                                    'intramuscular': 'IM (Intramuscular)',
                                    'intravenous': 'IV (Intravenous)'
                                };
                                scannedMedication.route = routeMap[parsedInfo.route.toLowerCase()] || parsedInfo.route;
                            }
                            if (parsedInfo.pharmacy) {
                                scannedMedication.pharmacy = parsedInfo.pharmacy;
                            }
                            if (parsedInfo.pharmacyPhone) {
                                scannedMedication.pharmacyPhone = parsedInfo.pharmacyPhone;
                                scannedMedication.pharmacyoffice = parsedInfo.pharmacyPhone;
                            }
                            if (parsedInfo.pharmacyAddress) {
                                scannedMedication.pharmacyAddress = parsedInfo.pharmacyAddress;
                            }
                            if (parsedInfo.prescriberInfo) {
                                scannedMedication.providername = parsedInfo.prescriberInfo;
                            }
                            // Set flags first
                            isAddmedForm.value = true;
                            isEditForm.value = false;
                            // Store the scanned data for the form to use BEFORE showing the form
                            // This ensures the watch in AddMedicationForm will trigger when the form opens
                            editFormdata.value = scannedMedication;
                            // Use nextTick to ensure reactivity has processed
                            return [4 /*yield*/, (0, vue_3.nextTick)()];
                        case 6:
                            // Use nextTick to ensure reactivity has processed
                            _a.sent();
                            // Show the Add Medication form with pre-filled data
                            showAddForm.value = true;
                            return [3 /*break*/, 9];
                        case 7:
                            error_2 = _a.sent();
                            console.error('Error processing label scan:', error_2);
                            alert('Error processing the label scan. Please try again.');
                            return [3 /*break*/, 9];
                        case 8:
                            showLabelScanner.value = false;
                            return [7 /*endfinally*/];
                        case 9: return [2 /*return*/];
                    }
                });
            });
        }
        function setProviderSignature(provsignature) {
            actionProviderSignature.value = provsignature;
        }
        // ---------- ON MOUNT ----------
        (0, vue_3.onMounted)(function () {
            var _a, _b;
            loadMedications();
            initializeDateRangePicker();
            // Check if manager is logged in, resolve session timeout issue
            if ((_b = (_a = allData.value) === null || _a === void 0 ? void 0 : _a.manager) === null || _b === void 0 ? void 0 : _b.name) {
                setProviderSignature(allData.value.manager.name);
            }
        });
        // ---------- DATE RANGE PICKER ----------
        // function initializeDateRangePicker() {
        //   const dateRangePicker = document.getElementById('date-range-picker')
        //   if (dateRangePicker) {
        //     flatpickr(dateRangePicker, {
        //       mode: "range",
        //       dateFormat: "l, M d, Y",
        //       maxDate: new Date().fp_incr(365),
        //       onChange: (selDates) => {
        //         if (selDates.length === 2) {
        //           updateDateRange(selDates[0], selDates[1])
        //         }
        //       }
        //     })
        //   }
        // }
        // Chris version
        function initializeDateRangePicker() {
            var el = document.getElementById('date-range-picker');
            if (!el)
                return;
            // clean up old instance
            if (fpInstance)
                fpInstance.destroy();
            fpInstance = (0, flatpickr_1.default)(el, {
                mode: 'range',
                inline: false,
                dateFormat: isMobile.value ? 'm/d' : 'l, M d, Y',
                disableMobile: false,
                maxDate: new Date().fp_incr(365),
                onChange: function (selDates) {
                    if (selDates.length === 2) {
                        if (isMobile.value) {
                            onDateRangePicked(selDates);
                        }
                        else {
                            updateDateRange(selDates[0], selDates[1]);
                        }
                    }
                }
            });
        }
        function updateDateRange(startDate, endDate) {
            /*Function sets up the dateList array with start and end date from calendar*/
            if (!startDate || !endDate) {
                alert("Please select both a start and an end date.");
                return;
            }
            GetDynamicMedDates(startDate, endDate);
            dateList.value = [];
            var cur = new Date(startDate);
            while (cur <= endDate) {
                dateList.value.push(normalizeToMidnight(cur));
                //populateMedicationTable()
                cur.setDate(cur.getDate() + 1);
            }
            /* Now we are going to make a call the the backend using axios* -8/7/25 */
            //populateMedicationTableFilter()
        }
        function GetDynamicMedDates(startDate, endDate) {
            return __awaiter(this, void 0, void 0, function () {
                var content;
                var _a, _b, _c, _d, _e, _f;
                return __generator(this, function (_g) {
                    // Check if patient is logged in, resolve session timeout issue
                    if (!((_a = patient.value) === null || _a === void 0 ? void 0 : _a.externId) || !((_b = patient.value) === null || _b === void 0 ? void 0 : _b.externId2))
                        return [2 /*return*/];
                    content = {
                        MedicationAdmin: {
                            API_Meth: "GetPatientsMedByID",
                            pid: patient.value.externId,
                            provsubaccount: ((_d = (_c = allData.value) === null || _c === void 0 ? void 0 : _c.manager) === null || _d === void 0 ? void 0 : _d.externid) || '',
                            accountId: patient.value.externId2,
                            providerid: ((_f = (_e = allData.value) === null || _e === void 0 ? void 0 : _e.manager) === null || _f === void 0 ? void 0 : _f.externid) || '',
                            startDate: startDate,
                            endDate: endDate
                        }
                    };
                    axios_1.default.post(apis_1.CURR_API + '/tswebhook.php', content)
                        .then(function (response) {
                        if (response.data && response.data.records) {
                            // alert("Medication based on Date Range brought back  Successfully");
                            medications.value = response.data.records;
                            newpopulateMedicationTableFilter();
                            return;
                        }
                        if (response.data && response.data.error) {
                            alert("There was an issue with the Date Range Filter");
                            return;
                        }
                        // Neither branch above fires for the legacy error envelope the bridge
                        // emits (`{status:'Error', message}` — no `error` key), so a failed
                        // range read used to leave the previous range on screen with no
                        // indication that the dates the user picked were never fetched.
                        alert("The medication record could not be loaded for these dates: " +
                            ((response.data && response.data.message) || "please contact an administrator."));
                    })
                        .catch(function (error) {
                        var _a;
                        if (axios_1.default.isAxiosError(error)) {
                            console.error('Error posting data:', ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) || error.message);
                            // errorMessage.value = error.response?.data?.message || 'An error occurred while posting data.';  
                        }
                        else {
                        }
                    });
                    return [2 /*return*/];
                });
            });
        }
        //--New Filter Name Different------ //
        //--New Function 2/24---//
        function newpopulateMedicationTableFilter() {
            var _a;
            if (!Array.isArray(medications === null || medications === void 0 ? void 0 : medications.value))
                return;
            // Safe converters (kept as in original)
            var toYYYYMMDD = function (d) {
                if (!d)
                    return '';
                if (typeof d === 'string') {
                    var s = d.trim();
                    if (/^\d{4}-\d{2}-\d{2}/.test(s))
                        return s.slice(0, 10);
                    var parsed = new Date(s);
                    if (!Number.isNaN(parsed.getTime()))
                        return formatDateToYYYYMMDD(parsed);
                    return '';
                }
                return formatDateToYYYYMMDD(d);
            };
            var normalize = function (d) { return normalizeToMidnight(d); };
            var _loop_2 = function (medIndex) {
                var med = medications.value[medIndex];
                // Save original backend med.dates BEFORE we reset med.dates
                var originalBackendDates = med.dates && typeof med.dates === 'object' ? __assign({}, med.dates) : null;
                // Parse yearmedtime/dcyearmedtime safely
                var yrmedtimeArray = [];
                var dcyrmedtimeArray = [];
                try {
                    yrmedtimeArray = Array.isArray(med.yearmedtime) ? med.yearmedtime : JSON.parse(med.yearmedtime || '[]');
                    med.administrationTimes = yrmedtimeArray.map(function (item) { return item.time; }).join(",");
                }
                catch (e) {
                    yrmedtimeArray = [];
                }
                try {
                    dcyrmedtimeArray = Array.isArray(med.dcyearmedtime) ? med.dcyearmedtime : JSON.parse(med.dcyearmedtime || '[]');
                }
                catch (e) {
                    dcyrmedtimeArray = [];
                }
                //normalize med start for PRN 
                // normalize med.start once for consistent date comparisons (YYYY-MM-DD)
                var medStartStr = med.med_startdate
                    ? (typeof med.med_startdate === 'string' ? med.med_startdate.split('T')[0] : toYYYYMMDD(new Date(med.med_startdate)))
                    : null;
                // Normalize administerdate buckets from backend (array of { administerdate, medlogtimes })
                var adminArr = [];
                if (Array.isArray(med.administerdate)) {
                    adminArr = med.administerdate;
                }
                else if (med.administerdate && typeof med.administerdate === 'string') {
                    adminArr = [{
                            administerdate: med.administerdate,
                            medlogtimes: Array.isArray(med.medlogtimes) ? med.medlogtimes : []
                        }];
                }
                else {
                    adminArr = [];
                }
                // Reset med.dates for fresh build
                med.dates = {};
                // derived pairs/time-status from backend string
                var pairs = (0, medAdminSlots_1.parseTimeStatusPairs)((_a = med.time_status_pairs) !== null && _a !== void 0 ? _a : null) || [];
                var hasPairs = pairs.length > 0;
                // If med is PRN and has no pairs and no schedule (administrationTimes or yearmedtime) -> skip this med entirely
                var defaultAdministrationTimes = (Array.isArray(yrmedtimeArray) ? yrmedtimeArray.map(function (x) { return x === null || x === void 0 ? void 0 : x.time; }).filter(Boolean) : []).join(',');
                var fallbackSplitTimes = defaultAdministrationTimes ? defaultAdministrationTimes.split(',').map(function (t) { return t.trim(); }).filter(Boolean) : [];
                if (med.prn === "1" && !hasPairs && (!med.administrationTimes || med.administrationTimes === 'As needed') && (!fallbackSplitTimes || fallbackSplitTimes.length === 0)) {
                    return "continue";
                }
                var dosageNum = parseInt(med.med_amount || '1', 10) || 1;
                var _loop_4 = function (d) {
                    var curdt = toYYYYMMDD(d);
                    //----Test Code------//
                    // Skip PRN rows for dates before the medication's start date
                    if (med.prn === "1" && med.med_startdate) {
                        var medStartStr_1 = typeof med.med_startdate === 'string'
                            ? med.med_startdate.split('T')[0]
                            : formatDateToYYYYMMDD(new Date(med.med_startdate));
                        if (curdt < medStartStr_1) {
                            return "continue";
                        }
                    }
                    //-----endtestcode----//
                    // Skip if med-level discontinued BEFORE this date
                    if (med.discontinuedDate && normalize(d).getTime() > normalize(med.discontinuedDate).getTime()) {
                        return "continue";
                    }
                    // Respect med.startdate: skip this date when curdt < startDateStr
                    if (med.med_startdate) {
                        var startDateStr = typeof med.med_startdate === 'string'
                            ? med.med_startdate.split('T')[0]
                            : toYYYYMMDD(new Date(med.med_startdate));
                        if (curdt < startDateStr) {
                            // allow only if backend provided medlog for this date or if pairs include this date
                            var backendHas = !!(originalBackendDates && originalBackendDates[curdt]);
                            var pairsHaveDate = hasPairs && pairs.some(function (p) { return p && p.administerdate && toYYYYMMDD(p.administerdate) === curdt; });
                            if (!backendHas && !pairsHaveDate) {
                                return "continue";
                            }
                            // else: fall through to process because there is actual medlog/pairs for this date
                        }
                    }
                    // If backend provided med.dates for curdt, treat as authoritative
                    if (originalBackendDates && originalBackendDates[curdt] && Array.isArray(originalBackendDates[curdt]) && originalBackendDates[curdt].length > 0) {
                        med.dates[curdt] = originalBackendDates[curdt].map(function (entry) {
                            var _a, _b, _c, _d, _e, _f, _g;
                            return ({
                                time: entry.time,
                                status: (_a = entry.status) !== null && _a !== void 0 ? _a : (entry.temporaryStatus ? entry.temporaryStatus : (entry.rawTime ? '' : 'pending')),
                                dosage: (_b = entry.dosage) !== null && _b !== void 0 ? _b : dosageNum,
                                earlyReason: (_c = entry.earlyReason) !== null && _c !== void 0 ? _c : '',
                                locked: (_d = entry.locked) !== null && _d !== void 0 ? _d : (entry.status === 'hold-medtime' || entry.status === 'discontinue-medtime' || entry.status === 'taken'),
                                temporaryStatus: (_f = (_e = entry.temporaryStatus) !== null && _e !== void 0 ? _e : entry.status) !== null && _f !== void 0 ? _f : 'pending',
                                medlog: (_g = entry.medlog) !== null && _g !== void 0 ? _g : []
                            });
                        });
                        return "continue";
                    }
                    // find dateBucket from backend medlogtimes array
                    var dateBucket = adminArr.find(function (e) { return e && e.administerdate && toYYYYMMDD(e.administerdate) === curdt; });
                    // determine earliest discontinue time for date (existing logic)
                    var earliestDiscontinueTimeForDate = null;
                    if (dateBucket && Array.isArray(dateBucket.medlogtimes)) {
                        dateBucket.medlogtimes.forEach(function (x) {
                            var _a, _b, _c, _d;
                            var discDate = (_b = (_a = x.discontinueDate) !== null && _a !== void 0 ? _a : x.discontinue_date) !== null && _b !== void 0 ? _b : null;
                            var discTime = (_d = (_c = x.discontinueTime) !== null && _c !== void 0 ? _c : x.discontinue_time) !== null && _d !== void 0 ? _d : null;
                            if (!discDate || !discTime)
                                return;
                            var discDay = toYYYYMMDD(new Date(discDate));
                            if (discDay === curdt) {
                                if (!earliestDiscontinueTimeForDate || discTime < earliestDiscontinueTimeForDate)
                                    earliestDiscontinueTimeForDate = discTime;
                            }
                        });
                    }
                    // --- Safe PRN handling (only act when there is concrete medlog for this curdt) ---
                    if (med.prn === "1") {
                        // Determine if there is backend medlog for this date
                        var backendHasForDate = !!(dateBucket && Array.isArray(dateBucket.medlogtimes) && dateBucket.medlogtimes.length > 0);
                        // Filter pairs that explicitly belong to this date (require administerdate match)
                        var prnPairsForDate = (pairs || []).filter(function (p) { return p && p.administerdate && toYYYYMMDD(p.administerdate) === curdt; });
                        // If there are no backend medlog entries AND no prn pairs for this date, do not create PRN entries for this date.
                        if (!backendHasForDate && prnPairsForDate.length === 0) {
                            return "continue";
                        }
                        else {
                            // Build dated medlog entries either from backend bucket (prefer backend) or from prnPairsForDate
                            var sourceEntries = backendHasForDate
                                ? (dateBucket.medlogtimes || []).map(function (x) { return ({ time: x.time, takentime: x.takentime, status: x.status, reason: x.reason, raw: x }); })
                                : prnPairsForDate.map(function (p) { return ({ time: p.time, takentime: p.takentime || null, status: p.status || null, reason: p.reason || null, raw: p }); });
                            if (sourceEntries.length > 0) {
                                // Populate med.dates[curdt] for grid display
                                med.dates[curdt] = sourceEntries.map(function (e) { return ({
                                    time: e.time,
                                    status: e.status || '',
                                    dosage: dosageNum,
                                    earlyReason: e.reason || '',
                                    locked: (0, medAdminSlots_1.isLockedStatus)(e.status),
                                    temporaryStatus: e.status || 'pending',
                                    medlog: e.raw || null
                                }); });
                                // Ensure med.times contains dated PRN entries for template helpers (only add entries for this curdt)
                                med.times = Array.isArray(med.times) ? med.times : [];
                                // Remove any existing med.times entries for this curdt (prevent duplicates)
                                med.times = med.times.filter(function (t) { return t && t.date !== curdt; });
                                var datedTimes = sourceEntries.map(function (e) { return ({
                                    time: e.time,
                                    status: e.status || '',
                                    date: curdt,
                                    locked: (0, medAdminSlots_1.isLockedStatus)(e.status),
                                    takentime: e.takentime || null,
                                    earlyReason: e.reason || '',
                                    reason: e.reason || ''
                                }); });
                                med.times = med.times.concat(datedTimes);
                                return "continue";
                            }
                        }
                    }
                    // --- end PRN handling ---
                    // build per-date scheduled times: choose dc or year times
                    var useDcTimes = !!med.discontinueDate && String(med.discontinueDate) < curdt;
                    var perDateTimes = useDcTimes ? (Array.isArray(dcyrmedtimeArray) ? dcyrmedtimeArray : []) : (Array.isArray(yrmedtimeArray) ? yrmedtimeArray : []);
                    var originalSplitTimes = perDateTimes.map(function (x) { return x === null || x === void 0 ? void 0 : x.time; }).filter(Boolean);
                    // handle med-level discontinue filtering (existing code used med.discontinuedDate; keep backward compat)
                    if (med.discontinuedDate && normalize(d).getTime() > normalize(med.discontinuedDate).getTime()) {
                        return "continue";
                    }
                    // baseTimes and splitTimes (respect earliest discontinue time for date)
                    // If dateBucket has medlogtimes entries, use those times 
                    var splitTimes;
                    if (dateBucket && Array.isArray(dateBucket.medlogtimes) && dateBucket.medlogtimes.length > 0) {
                        var timesFromMedlogtimes = dateBucket.medlogtimes
                            .map(function (x) {
                            var time = (x.time || '').trim();
                            return time ? time.split(':').slice(0, 2).join(':') : null;
                        })
                            .filter(function (time, index, self) { return time && self.indexOf(time) === index; }) // Get unique times
                            .sort(); // Sort times chronologically
                        if (timesFromMedlogtimes.length > 0) {
                            // Use times from medlogtimes as the schedule for this date
                            splitTimes = earliestDiscontinueTimeForDate
                                ? timesFromMedlogtimes.filter(function (t) { return t !== earliestDiscontinueTimeForDate; })
                                : __spreadArray([], timesFromMedlogtimes, true);
                        }
                        else {
                            // Fallback to schedule if no valid times found in medlogtimes
                            var baseTimes = originalSplitTimes.length ? originalSplitTimes : fallbackSplitTimes;
                            splitTimes = earliestDiscontinueTimeForDate ? baseTimes.filter(function (t) { return t !== earliestDiscontinueTimeForDate; }) : __spreadArray([], baseTimes, true);
                        }
                    }
                    else {
                        // No medlogtimes for this date, use the current schedule
                        var baseTimes = originalSplitTimes.length ? originalSplitTimes : fallbackSplitTimes;
                        splitTimes = earliestDiscontinueTimeForDate ? baseTimes.filter(function (t) { return t !== earliestDiscontinueTimeForDate; }) : __spreadArray([], baseTimes, true);
                    }
                    // If no scheduled times for this date:
                    if (!splitTimes || splitTimes.length === 0) {
                        if (med.prn === "1") {
                            // only create "As needed" if med has started by this date (or if no start date provided)
                            var medStarted = !medStartStr || medStartStr <= curdt;
                            // also ensure there is no backend medlog and no dated pairs for this curdt
                            var backendHasForDate = !!(dateBucket && Array.isArray(dateBucket.medlogtimes) && dateBucket.medlogtimes.length > 0);
                            var prnPairsForDate = (pairs || []).filter(function (p) { return p && p.administerdate && toYYYYMMDD(p.administerdate) === curdt; });
                            if (medStarted && !backendHasForDate && prnPairsForDate.length === 0) {
                                med.dates[curdt] = [{
                                        time: 'As needed',
                                        status: '',
                                        dosage: dosageNum,
                                        earlyReason: '',
                                        locked: false,
                                        temporaryStatus: 'pending',
                                        medlog: null
                                    }];
                            }
                        }
                        return "continue";
                    }
                    // If there is no medlog for this date, create pending entries only (do NOT reuse medlog from other dates)
                    var hasNoMedlogForDate = !dateBucket || !Array.isArray(dateBucket.medlogtimes) || dateBucket.medlogtimes.length === 0;
                    if (hasNoMedlogForDate) {
                        med.dates[curdt] = splitTimes.map(function (t) { return ({
                            time: t,
                            status: '',
                            dosage: dosageNum,
                            earlyReason: '',
                            locked: false,
                            temporaryStatus: 'pending',
                            medlog: null
                        }); });
                        return "continue";
                    }
                    // Build medlogtimes from the dateBucket and ensure medlog.administerdate (if present) matches curdt
                    var medlogtimes = (dateBucket.medlogtimes || [])
                        .map(function (x) {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                        return ({
                            time: (x.time || '').trim(),
                            takentime: x.takentime || null,
                            status: x.status || null,
                            tagstatus: x.tagstatus || '',
                            temporaryStatus: (_b = (_a = x.temporaryStatus) !== null && _a !== void 0 ? _a : x.status) !== null && _b !== void 0 ? _b : null,
                            reason: (_c = x.reason) !== null && _c !== void 0 ? _c : null,
                            discontinueDate: (_e = (_d = x.discontinueDate) !== null && _d !== void 0 ? _d : x.discontinue_date) !== null && _e !== void 0 ? _e : null,
                            discontinueTime: (_g = (_f = x.discontinueTime) !== null && _f !== void 0 ? _f : x.discontinue_time) !== null && _g !== void 0 ? _g : null,
                            raw: x,
                            srcAdminDate: (_j = (_h = x.administerdate) !== null && _h !== void 0 ? _h : x.administrateDate) !== null && _j !== void 0 ? _j : null
                        });
                    })
                        .filter(function (mlt) {
                        // Strict: if medlog has an administerdate, require it to match curdt
                        if (mlt.srcAdminDate && toYYYYMMDD(mlt.srcAdminDate) !== curdt)
                            return false;
                        // Discontinue filtering
                        if (!mlt.discontinueDate || !mlt.discontinueTime)
                            return true;
                        var discDay = toYYYYMMDD(new Date(mlt.discontinueDate));
                        if (discDay > curdt)
                            return false;
                        if (discDay < curdt)
                            return true;
                        if (!mlt.time)
                            return true;
                        if (mlt.discontinueTime > mlt.time)
                            return false;
                        return true;
                    });
                    // Match medlog entries to scheduled slots: exact-time first, then by order (within this date only)
                    // Normalize time format for comparison (remove seconds if present)
                    var normalizeTimeForMatch = function (timeStr) {
                        if (!timeStr)
                            return '';
                        return timeStr.split(':').slice(0, 2).join(':');
                    };
                    var usedIndices = new Set();
                    var matchedByTime = {};
                    medlogtimes.forEach(function (mlt, idx) {
                        if (!mlt.time)
                            return;
                        var normalizedMltTime = normalizeTimeForMatch(mlt.time);
                        var schedMatchIdx = splitTimes.findIndex(function (t) { return normalizeTimeForMatch(t) === normalizedMltTime; });
                        if (schedMatchIdx >= 0 && !matchedByTime[schedMatchIdx]) {
                            matchedByTime[schedMatchIdx] = { entry: mlt, idx: idx };
                            usedIndices.add(idx);
                        }
                    });
                    var remainingIdx = 0;
                    medlogtimes.forEach(function (mlt, idx) {
                        if (usedIndices.has(idx))
                            return;
                        while (remainingIdx < splitTimes.length && matchedByTime[remainingIdx])
                            remainingIdx++;
                        if (remainingIdx < splitTimes.length) {
                            matchedByTime[remainingIdx] = { entry: mlt, idx: idx };
                            usedIndices.add(idx);
                        }
                    });
                    // Build med.dates[curdt] from matched results
                    med.dates[curdt] = splitTimes.map(function (schedTime, sIdx) {
                        var _a, _b;
                        var match = (_b = (_a = matchedByTime[sIdx]) === null || _a === void 0 ? void 0 : _a.entry) !== null && _b !== void 0 ? _b : null;
                        var status = match ? (match.status || match.temporaryStatus || '') : '';
                        var earlyReason = match ? match.reason : (dateBucket.earlyReason || []).join(', ') || '';
                        var locked = status === 'hold' || status === 'hold-medtime' || status === 'discontinue-medtime';
                        return {
                            time: schedTime,
                            status: status || (match ? '' : 'pending'),
                            dosage: dosageNum,
                            earlyReason: earlyReason,
                            locked: locked,
                            temporaryStatus: status || 'pending',
                            medlog: match ? match.raw : null
                        };
                    });
                };
                // Iterate dates (use for..of so we can continue per-date)
                for (var _c = 0, _d = (dateList.value || []); _c < _d.length; _c++) {
                    var d = _d[_c];
                    _loop_4(d);
                } // end dates loop
                // Final pass for med: ensure every date in dateList has med.dates populated (create scheduled blanks if missing)
                for (var _e = 0, _f = (dateList.value || []); _e < _f.length; _e++) {
                    var d = _f[_e];
                    var curdt = toYYYYMMDD(d);
                    if (med.dates[curdt])
                        continue;
                    // Respect med.startdate and med.discontinuedDate
                    if (med.med_startdate) {
                        var startDateStr = typeof med.med_startdate === 'string' ? med.med_startdate.split('T')[0] : toYYYYMMDD(new Date(med.med_startdate));
                        if (curdt < startDateStr)
                            continue;
                    }
                    if (med.discontinuedDate && normalize(d).getTime() > normalize(med.discontinuedDate).getTime())
                        continue;
                    var useDcTimes = !!med.discontinueDate && String(med.discontinueDate) < curdt;
                    var perDateTimes = useDcTimes ? (Array.isArray(dcyrmedtimeArray) ? dcyrmedtimeArray : []) : (Array.isArray(yrmedtimeArray) ? yrmedtimeArray : []);
                    var times = perDateTimes.map(function (x) { return x === null || x === void 0 ? void 0 : x.time; }).filter(Boolean);
                    var scheduled = (times.length ? times : fallbackSplitTimes).slice();
                    if (!scheduled || scheduled.length === 0)
                        continue;
                    med.dates[curdt] = scheduled.map(function (t) { return ({
                        time: t,
                        status: '', // explicit blank so future dates are not cloned
                        dosage: dosageNum,
                        earlyReason: '',
                        locked: false,
                        temporaryStatus: 'pending',
                        medlog: null
                    }); });
                }
            };
            // iterate meds with for..of so we can continue per-med or per-date
            for (var medIndex = 0; medIndex < medications.value.length; medIndex++) {
                _loop_2(medIndex);
            } // end medications loop
            var _loop_3 = function (date) {
                var dateStr = toYYYYMMDD(date);
                medicationStatus.value[dateStr] = {}; // reset
                medications.value.forEach(function (med, idx) {
                    if (!med.dates)
                        return;
                    var dayTimes = med.dates[dateStr] || [];
                    dayTimes.forEach(function (timeObj) {
                        if (!medicationStatus.value[dateStr][timeObj.time])
                            medicationStatus.value[dateStr][timeObj.time] = {};
                        var s = timeObj.status;
                        // Only propagate non-empty, non-pending statuses; otherwise set neutral marker
                        if (s) {
                            medicationStatus.value[dateStr][timeObj.time][idx] = s;
                        }
                        else {
                            medicationStatus.value[dateStr][timeObj.time][idx] = med.earlyReason && med.earlyReason !== '' ? med.earlyReason : 'dont';
                        }
                    });
                });
            };
            // STRICT: always rebuild medicationStatus and only populate when a real status exists
            for (var _i = 0, _b = (dateList.value || []); _i < _b.length; _i++) {
                var date = _b[_i];
                _loop_3(date);
            }
        }
        //--- END Populate Medication Filter ------ //
        // ---------- POPULATE & STATUS ----------
        function populateMedicationTable() {
            var today = new Date();
            var dtStr = formatDateToYYYYMMDD(today);
            var finaltoday = dtStr; // alias used in original code
            medications.value.forEach(function (med, medIndex) {
                var _a;
                // Parse server paired token once
                //alert(med.medname);
                var pairs = (0, medAdminSlots_1.parseTimeStatusPairs)((_a = med.time_status_pairs) !== null && _a !== void 0 ? _a : null);
                //3/13/206 Adding Code to Chek for Schedule Holds
                //console.log("JSON Pairs length");
                //console.log(JSON.parse(pairs));
                // Derived arrays for backward compatibility
                var pairTimes = pairs.map(function (p) { return p.time; }).filter(Boolean);
                var pairTakentimes = pairs.map(function (p) { return p.takentime; }).filter(Boolean);
                var pairStatuses = pairs.map(function (p) { return p.status; });
                var pairReasons = pairs.map(function (p) { return p.reason; });
                med.administrationTimes = pairTimes.join(',');
                med.takentimes = pairTakentimes.join(',');
                med.temporaryStatus = pairStatuses.join(',');
                med.earlyReason = pairReasons.join(',');
                // Ensure med.dates exists
                if (!med.dates)
                    med.dates = {};
                // Safe parse for year arrays (original code used these)
                var yrmedtimeArray = [];
                try {
                    yrmedtimeArray = Array.isArray(med.yearmedtime) ? med.yearmedtime : JSON.parse(med.yearmedtime || '[]');
                }
                catch (e) {
                    yrmedtimeArray = [];
                }
                var dcyrmedtimeArray = [];
                try {
                    dcyrmedtimeArray = Array.isArray(med.dcyearmedtime) ? med.dcyearmedtime : JSON.parse(med.dcyearmedtime || '[]');
                }
                catch (e) {
                    dcyrmedtimeArray = [];
                }
                // Helper: get admin times from year arrays if needed (keeps original behavior)
                var getAdminTimesFromYearArray = function (useDc) {
                    var arr = useDc ? dcyrmedtimeArray : yrmedtimeArray;
                    return (Array.isArray(arr) ? arr.map(function (x) { return x === null || x === void 0 ? void 0 : x.time; }).filter(Boolean) : []).join(',');
                };
                // If med is PRN but has no pairs and original administrationTimes is empty, bail out early (original logic)
                if (med.prn === "1" && (!pairs || pairs.length == 0) && (!med.administrationTimes || med.administrationTimes === 'As needed')) {
                    // Nothing to populate for this med
                    return;
                }
                // If med is PRN and pairs exist, populate med.times (originally created an array of objects)
                if (med.prn === "1" && pairs.length > 0) {
                    // alert("has length");
                    var prnlabel_1 = "";
                    med.times = pairs.map(function (p) {
                        switch (p.status) {
                            case "taken":
                                {
                                    prnlabel_1 = p.time + "(taken at " + p.takentime + ")";
                                    if (p.reason != "" && p.reason != null) {
                                        prnlabel_1 += "(" + p.reason + ")";
                                    }
                                    break;
                                }
                            case "refused":
                                {
                                    prnlabel_1 = p.time + "(refused at " + p.takentime + ")";
                                    if (p.reason != "" && p.reason != null) {
                                        prnlabel_1 += "(" + p.reason + ")";
                                    }
                                    break;
                                }
                            case null:
                            case undefined:
                            case "":
                                {
                                    prnlabel_1 = p.time;
                                    break;
                                }
                        }
                        var ntime = {
                            time: prnlabel_1, //p.time,
                            status: p.status || '',
                            date: dtStr,
                            locked: (0, medAdminSlots_1.isLockedStatus)(p.status),
                            signedoff: med.nursesignature || '',
                            dosage: med.med_amount,
                            earlyReason: p.reason || '',
                            reason: p.reason || ''
                        };
                        return ntime;
                    });
                }
                // Build med.dates for each date in dateList
                dateList.value.forEach(function (d) {
                    var dStr = formatDateToYYYYMMDD(d);
                    // If discontinued before this date, skip (original logic used med.discontinuedDate)
                    if (med.discontinuedDate && normalizeToMidnight(d).getTime() > normalizeToMidnight(med.discontinuedDate).getTime()) {
                        return;
                    }
                    // Decide which administrationTimes to use from year arrays if you still rely on them for non-medlog cases
                    if (med.dcdate && med.dcdate < dStr) {
                        med.administrationTimes = getAdminTimesFromYearArray(true);
                        //alert(med.administrationTimes);
                    }
                    else {
                        med.administrationTimes = getAdminTimesFromYearArray(false);
                    }
                    // If there are no medlogtime pairs for this med on the day, but there are administrationTimes based on schedule,
                    // we should still build entries (pending/blank status).
                    var scheduledTimes = (med.administrationTimes || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
                    // Use pairs when available (they are the authoritative medlogtimes for the day)
                    var pairsForDay = pairs.length > 0 ? pairs : scheduledTimes.map(function (t) { return ({ time: t, takentime: '', status: '', reason: '' }); });
                    // Build med.dates[dStr] only if not already set (original code often set only when undefined)
                    if (!med.dates[dStr]) {
                        var dosageNum = parseInt(med.med_amount || '1', 10);
                        // each slot from its own pair (src/utils/medAdminSlots.js)
                        med.dates[dStr] = (0, medAdminSlots_1.daySlotsFromPairs)(pairsForDay, dosageNum);
                    }
                    else {
                        // If med.dates[dStr] already exists (perhaps previously created), update locked/status based on current pairs
                        if (med.prn === true && Array.isArray(med.dates[dStr])) {
                            var existing = med.dates[dStr];
                            var dosageNum_1 = parseInt(med.med_amount || '1', 10);
                            var lockArray_1 = existing.map(function (e) { return !!e.locked; });
                            // Rebuild to align with current pairs while preserving existing locked flags where possible
                            med.dates[dStr] = pairs.map(function (p, index) {
                                var displayTime = p.takentime ? "".concat(p.time, " (taken at ").concat(p.takentime, ")") : p.time;
                                var status = p.status || '';
                                var locked = (0, medAdminSlots_1.isLockedStatus)(status) || !!lockArray_1[index];
                                return {
                                    time: displayTime,
                                    rawTime: p.time,
                                    status: status,
                                    takentime: p.takentime || '',
                                    dosage: dosageNum_1,
                                    earlyReason: p.reason || '',
                                    locked: locked,
                                    temporaryStatus: status
                                };
                            });
                        }
                    }
                });
            });
            // Rebuild medicationStatus (per original final block)
            dateList.value.forEach(function (date) {
                var dateStr = formatDateToYYYYMMDD(date);
                if (!medicationStatus.value[dateStr]) {
                    medicationStatus.value[dateStr] = {};
                    medications.value.forEach(function (med, idx) {
                        if (!med.prn && med.dates) {
                            var dayTimes = med.dates[dateStr] || [];
                            dayTimes.forEach(function (timeObj) {
                                if (!medicationStatus.value[dateStr][timeObj.rawTime || timeObj.time]) {
                                    medicationStatus.value[dateStr][timeObj.rawTime || timeObj.time] = {};
                                }
                                medicationStatus.value[dateStr][timeObj.rawTime || timeObj.time][idx] = med.earlyReason ? med.earlyReason : 'pending';
                            });
                        }
                    });
                }
            });
        }
        function handleStatusChange(event, medIndex) {
            var select = event.target;
            var status = select.value;
            var row = select.closest('tr');
            var medication = medications.value[medIndex];
            var originalStatus = medication.status || 'active';
            if (status === 'hold' && !canMedicationHold.value) {
                alert("You do not have permission to hold medications.");
                select.value = originalStatus;
                return;
            }
            if (status === 'discontinue' && !canMedicationDiscontinue.value) {
                alert("You do not have permission to discontinue medications.");
                select.value = originalStatus;
                return;
            }
            if (status === 'hold' || status === 'new' || status === 'discontinue') { //|| status === 'change'
                // Store pending status change instead of applying immediately
                pendingStatusChange.value = {
                    medication: medication,
                    medIndex: medIndex,
                    originalStatus: originalStatus,
                    newStatus: status,
                    rowElement: row
                };
                selectedMedicationForHold.value = medication;
                selectedStatusOption.value = status; // | 'change'
                showHoldSelector.value = true;
                return;
            }
            else if (status == 'change') {
                /* I'm setting the medication, frequency, and administrations times for the Select Times modal to now show the reason of why we need a change and CO */
                selectedMedicationForTime.value = medications.value[medIndex];
                selectedFrequency.value = medications.value[medIndex].med_frequency || '';
                selectedDosage.value = medications.value[medIndex].med_amount || '1';
                showHoldSelector.value = false; //just in case its showing 
                ifStatusIsChange.value = true; //setting this so that the reason field shows up
                showTimeModal.value = true;
                return;
            }
            else {
                // For other status changes (not hold/new/discontinue/change), apply immediately
                if (row) {
                    row.classList.remove('active-row', 'discontinued-row', 'hold-row', 'new-row', 'pending-row');
                    row.classList.add("".concat(status, "-row"));
                }
                medications.value[medIndex].status = status;
            }
            emit('statusChange', medications.value[medIndex], status);
        }
        function handleMobileStatusChange(event, med) {
            if (ifOrderSigned(med))
                return;
            var select = event.target;
            var status = select.value;
            // Find the medication index in the medications array
            var medIndex = medications.value.findIndex(function (m) {
                return m.medentryid === med.medentryid ||
                    (m.medname === med.medname && m.medentryid === med.medentryid);
            });
            if (medIndex === -1) {
                console.error('Could not find medication in medications array');
                // Revert the v-model change
                med.status = med.status || 'active';
                return;
            }
            var medication = medications.value[medIndex];
            var originalStatus = medication.status || 'active';
            if (status === 'hold' || status === 'new' || status === 'discontinue') {
                // Revert the v-model change immediately (will be applied after modal confirmation)
                med.status = originalStatus;
                medication.status = originalStatus;
                // Store pending status change instead of applying immediately
                pendingStatusChange.value = {
                    medication: medication,
                    medIndex: medIndex,
                    originalStatus: originalStatus,
                    newStatus: status,
                    rowElement: null // No row element in mobile view
                };
                selectedMedicationForHold.value = medication;
                selectedStatusOption.value = status;
                showHoldSelector.value = true;
                return;
            }
            else if (status === 'change') {
                selectedMedicationForTime.value = medication;
                selectedFrequency.value = medication.med_frequency || '';
                selectedDosage.value = medication.med_amount || '1';
                showHoldSelector.value = false;
                ifStatusIsChange.value = true;
                showTimeModal.value = true;
                return;
            }
            else {
                // For other status changes, apply immediately
                medications.value[medIndex].status = status;
            }
            emit('statusChange', medications.value[medIndex], status);
        }
        var appData = (0, vue_3.computed)(function () {
            return;
        });
        // ---------- HOLD SUBMIT ----------
        var holdTimes = (0, vue_3.computed)(function () {
            if (!selectedMedicationForHold.value)
                return [];
            var timesSet = new Set();
            var med = selectedMedicationForHold.value;
            if (med.dates) {
                for (var dateKey in med.dates) {
                    med.dates[dateKey].forEach(function (tObj) {
                        timesSet.add(tObj.time);
                    });
                }
            }
            // Fallback to administrationTimes if no times found in dates
            if (timesSet.size === 0 && med.administrationTimes && med.administrationTimes !== 'As needed') {
                var adminTimes = med.administrationTimes.split(',')
                    .map(function (t) { return t.trim(); })
                    .filter(Boolean);
                adminTimes.forEach(function (time) { return timesSet.add(time); });
            }
            return Array.from(timesSet);
        });
        function triggerHoldDCModal(activeStatus, formData) {
            // Don't close the form - just show the hold selector on top
            // This preserves the form data
            selectedMedicationForHold.value = formData;
            // selectedStatusOption.value = activeStatus;
            selectedStatusOption.value = activeStatus;
            showHoldSelector.value = true;
        }
        // puts a row back as it was before a status change - when the change is cancelled (as before) and
        // when keyon refuses it: the row was set to the new status on confirm, before the request, and stayed
        // "Discontinue"/pink after a refusal until a full reload.
        function revertStatusChange(change) {
            if (!change)
                return;
            var medication = change.medication, medIndex = change.medIndex, originalStatus = change.originalStatus, rowElement = change.rowElement;
            var row = medications.value[medIndex] || medication;
            row.status = originalStatus;
            if (rowElement) {
                rowElement.classList.remove('active-row', 'discontinued-row', 'hold-row', 'new-row', 'pending-row');
                if (originalStatus && originalStatus !== 'active') {
                    rowElement.classList.add("".concat(originalStatus, "-row"));
                }
                else {
                    rowElement.classList.add('active-row');
                }
            }
        }
        function handleHoldCancel() {
            // Revert pending status change if it exists
            if (pendingStatusChange.value) {
                revertStatusChange(pendingStatusChange.value);
                // Clear pending status change
                pendingStatusChange.value = null;
                // editFormdata.value=null;
                //alert("Cancel Hold");
            }
            // Close popup
            showHoldSelector.value = false;
            selectedMedicationForHold.value = null;
            holdSelectorCancelledCounter.value++;
        }
        // Helper function to get effective status (considers pending changes)
        function getEffectiveStatus(med) {
            if (pendingStatusChange.value && pendingStatusChange.value.medication === med) {
                // Better handling of pending status changes
                return String(pendingStatusChange.value.newStatus || '').toLowerCase();
            }
            // DB often returns "Active"/"Pending"; statusOptions use lowercase values
            return String(med.status || 'active').toLowerCase();
        }
        function handleHoldSubmitSchedule(data) {
            if (!selectedMedicationForHold.value)
                return;
            var medication = selectedMedicationForHold.value;
            var discDate = normalizeToMidnight(data.dateRange[0]);
            if (medication.order_number) {
                medication.holdInfo = {
                    medname: medication.medname,
                    medentryid: medication.medentryid,
                    dateRange: data.dateRange,
                    times: data.times,
                    reason: data.reason,
                    type: data.holdType,
                    ordernumber: medication.order_number,
                    status: data.statusOption,
                    archiveHLDDC: data.archiveHLDDC,
                    scheduleDates: data.schedDt,
                    action: data.action
                };
            }
            if (medication.ordernumber) {
                medication.holdInfo = {
                    medname: medication.medname,
                    medentryid: medication.medentryid,
                    dateRange: data.dateRange,
                    times: data.times,
                    reason: data.reason,
                    type: data.holdType,
                    ordernumber: medication.ordernumber,
                    status: data.statusOption,
                    archiveHLDDC: data.archiveHLDDC,
                    scheduleDates: data.schedDt,
                    action: data.action
                };
            }
            var ask = "";
            if (data.statusOption == 'hold') {
                switch (data.action) {
                    case "schedule":
                        {
                            ask = confirm("Are you sure you want to schedule a hold on this medication?");
                            break;
                        }
                    case "cancel":
                        {
                            ask = confirm("Are you sure you want to cancel the hold on this medication?");
                            break;
                        }
                    case "update":
                        {
                            ask = confirm("Are you sure you want to Update the Scheduled Hold Dates on this medication?");
                            break;
                        }
                }
                // ask = confirm("Are you sure you want to schedule a hold on this medication?");
            }
            if (ask == true) {
                // kept so a refused request can put the row back (revertStatusChange)
                var appliedChange = pendingStatusChange.value && pendingStatusChange.value.medication === medication ? pendingStatusChange.value : null;
                // Apply pending status change after confirmation
                if (pendingStatusChange.value && pendingStatusChange.value.medication === medication) {
                    medication.status = pendingStatusChange.value.newStatus;
                    // Apply row class changes
                    if (pendingStatusChange.value.rowElement) {
                        var row = pendingStatusChange.value.rowElement;
                        row.classList.remove('active-row', 'discontinued-row', 'hold-row', 'new-row', 'pending-row');
                        row.classList.add("".concat(pendingStatusChange.value.newStatus, "-row"));
                    }
                    // Clear pending status change
                    pendingStatusChange.value = null;
                }
                //adding double check to make sure ordernumber is there or for some reason is missing after a few changes
                if (medication.holdInfo.ordernumber == "" || medication.holdInfo.ordernumber == undefined) {
                    alert("Order Number assocaited with this change does not exit. Please refresh and try again");
                    handleHoldCancel();
                }
                else {
                    scheduleholdMedication(medication.holdInfo, appliedChange);
                }
                //send to backend 
                //we are going to assume everything went well and are going to go ahead and close the showHolder Selector and the SelectedMedicationfor Hold comp
                showHoldSelector.value = false;
                selectedMedicationForHold.value = null;
            }
            else {
                // User cancelled confirmation, revert pending status change
                handleHoldCancel();
            }
        }
        function handleHoldSubmit(data) {
            if (!selectedMedicationForHold.value)
                return;
            var medication = selectedMedicationForHold.value;
            var discDate = normalizeToMidnight(data.dateRange[0]);
            if (data.statusOption === 'discontinue') {
                if (data.holdType === 'all') {
                    medication.discontinuedDate = discDate;
                    var dateStr = formatDateToYYYYMMDD(discDate);
                    if (!medication.dates)
                        medication.dates = {};
                    if (medication.dates[dateStr]) {
                        medication.dates[dateStr].forEach(function (slot) {
                            slot.status = 'discontinue';
                            slot.locked = true;
                        });
                    }
                }
                else if (data.holdType === 'specific' && data.times) {
                    if (!medication.discontinuedTimes) {
                        medication.discontinuedTimes = {};
                    }
                    var dateStr_1 = formatDateToYYYYMMDD(discDate);
                    if (!medication.discontinuedTimes[dateStr_1]) {
                        medication.discontinuedTimes[dateStr_1] = [];
                    }
                    if (medication.dates && medication.dates[dateStr_1]) {
                        data.times.forEach(function (t) {
                            var found = medication.dates[dateStr_1].find(function (obj) { return obj.time === t; });
                            if (found) {
                                found.status = 'discontinue';
                                found.locked = true;
                            }
                            if (!medication.discontinuedTimes[dateStr_1].includes(t)) {
                                medication.discontinuedTimes[dateStr_1].push(t);
                            }
                        });
                    }
                }
            }
            if (medication.order_number) {
                medication.holdInfo = {
                    medname: medication.medname,
                    medentryid: medication.medentryid,
                    dateRange: data.dateRange,
                    times: data.times,
                    reason: data.reason,
                    type: data.holdType,
                    ordernumber: medication.order_number,
                    status: data.statusOption,
                    archiveHLDDC: data.archiveHLDDC
                };
            }
            if (medication.ordernumber) {
                medication.holdInfo = {
                    medname: medication.medname,
                    medentryid: medication.medentryid,
                    dateRange: data.dateRange,
                    times: data.times,
                    reason: data.reason,
                    type: data.holdType,
                    ordernumber: medication.ordernumber,
                    status: data.statusOption,
                    archiveHLDDC: data.archiveHLDDC
                };
            }
            // 2026-10 (#336): a non-prescription medication has no order, so holdInfo was never built and the order check
            // below threw a TypeError - nothing was sent. keyon holds it at once on its own row (no order needed).
            // Decided by keyon's rule - no order - not the nonprescription flag, which keyon does not read (review of #336).
            var isNonPrescription = (0, nonPrescription_1.isNonPrescription)(medication);
            if (isNonPrescription) {
                medication.holdInfo = {
                    medname: medication.medname,
                    medentryid: medication.medentryid,
                    dateRange: data.dateRange,
                    times: data.times,
                    reason: data.reason,
                    type: data.holdType,
                    ordernumber: '',
                    status: data.statusOption,
                    archiveHLDDC: data.archiveHLDDC
                };
            }
            /* medication.holdInfo = {
               medname: medication.medname,
               medentryid:medication.medentryid,
               dateRange: data.dateRange,
               times: data.times,
               reason: data.reason,
               type: data.holdType,
               ordernumber:medication.order_number,
               status:data.statusOption
             } */
            var ask = "";
            if (data.statusOption === 'discontinue') {
                ask = confirm("Are you sure you want to discontinue this medication?");
            }
            if (data.statusOption == 'hold') {
                ask = confirm("Are you sure you want to hold this medication?");
            }
            if (ask == true) {
                // kept so a refused request can put the row back (revertStatusChange)
                var appliedChange = pendingStatusChange.value && pendingStatusChange.value.medication === medication ? pendingStatusChange.value : null;
                // Apply pending status change after confirmation
                if (pendingStatusChange.value && pendingStatusChange.value.medication === medication) {
                    medication.status = pendingStatusChange.value.newStatus;
                    // Apply row class changes
                    if (pendingStatusChange.value.rowElement) {
                        var row = pendingStatusChange.value.rowElement;
                        row.classList.remove('active-row', 'discontinued-row', 'hold-row', 'new-row', 'pending-row');
                        row.classList.add("".concat(pendingStatusChange.value.newStatus, "-row"));
                    }
                    // Clear pending status change
                    pendingStatusChange.value = null;
                }
                //adding double check to make sure ordernumber is there or for some reason is missing after a few changes
                // 2026-10 (#336): a non-prescription medication has no order by design - it is sent without one
                if (!isNonPrescription && (!medication.holdInfo || medication.holdInfo.ordernumber == "" || medication.holdInfo.ordernumber == undefined)) {
                    alert("Order Number assocaited with this change does not exit. Please refresh and try again");
                    handleHoldCancel();
                }
                else {
                    holdMedication(medication.holdInfo, appliedChange);
                }
                // holdMedication(medication.holdInfo);
                //send to backend 
                //we are going to assume everything went well and are going to go ahead and close the showHolder Selector and the SelectedMedicationfor Hold comp
                showHoldSelector.value = false;
                selectedMedicationForHold.value = null;
            }
            else {
                // User cancelled confirmation, revert pending status change
                handleHoldCancel();
            }
        }
        // ---------- CLOSE ERROR MODAL ----------
        function closeErrorModal() {
            showErrorModal.value = false;
        }
        // ---------- TABS CHANGE ----------
        function handleTabsChange(medication, newValue) {
            medication.available = newValue;
            medication.tabsAvailable = newValue;
            var medId = medication.medentryid;
            var medAvailable = medication.available;
            var content = {
                MedicationAdmin: {
                    API_Meth: 'UpdateMedAdminAvailable',
                    medId: medId,
                    medAvailable: medAvailable,
                }
            };
            axios_1.default.post(apis_1.CURR_API + '/tswebhook.php', content).then(function (response) {
            });
        }
        // ---------- Dose UOM CHANGE ----------
        // The unit is part of the prescription: on a live ordered medication the
        // server refuses a new one without a change order
        // (`medication_change_requires_order`), as it refuses a new dose. The select
        // has already moved by then, and the answer was ignored, so the MAR went on
        // showing a unit the medication does not have — 25 g for 25 mg. A refusal is
        // shown, and the record is read again.
        //
        // Main's select changed the unit of a live, signed line at once. The port
        // keeps the select (contract D6) and gives it the signed path: on a live
        // ordered line it raises a change order, as a new dose or frequency does —
        // the reason is asked for, the line's own times, dose and frequency are sent
        // unchanged with the new unit, and the new unit waits, pending, for the
        // provider's signature. An un-ordered line, or one not yet signed, is amended
        // directly as before; the server refuses one whose order already carries a
        // signature, and that refusal is shown.
        function handleDoseUOMChange(medication, newValue) {
            medication.med_doseuom = newValue;
            var notChanged = 'The dose unit was not changed. Please try again.';
            var showRecord = function () {
                dateList.value = [];
                loadMedications();
            };
            if (isLiveOrderedMedication(medication)) {
                changeDoseUnitByOrder(medication, newValue, notChanged, showRecord);
                return;
            }
            var medId = medication.medentryid;
            var medDoseUOM = medication.med_doseuom;
            var content = {
                MedicationAdmin: {
                    API_Meth: 'UpdateMedAdminDoseUOM',
                    medId: medId,
                    medDoseUOM: medDoseUOM,
                }
            };
            axios_1.default.post(apis_1.CURR_API + '/tswebhook.php', content).then(function (response) {
                var data = response.data || {};
                if (data.status === 'Error') {
                    alert(data.message || notChanged);
                    showRecord();
                }
            }).catch(function (error) {
                var _a, _b;
                alert(axios_1.default.isAxiosError(error) ? (((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || notChanged) : notChanged);
                showRecord();
            });
        }
        /** An ordered line that is live: Active or on hold, with an order behind it. */
        function isLiveOrderedMedication(medication) {
            var _a, _b;
            var med = medication;
            var order = String((_b = (_a = med.ordernumber) !== null && _a !== void 0 ? _a : med.order_number) !== null && _b !== void 0 ? _b : '').trim();
            var status = String(med.status || '').trim().toLowerCase();
            return order !== '' && order !== '0' && ['active', 'hold', 'on_hold', 'on hold'].includes(status);
        }
        /**
         * The line's own dose times, as the change order resends them: the schedule
         * template the record carries. NULL when the record did not carry one — sent
         * empty, the change order would take every time off the new version.
         */
        function templateSlotsOf(medication) {
            var _a, _b;
            var med = medication;
            var slots = (_b = (_a = med.administration_schedule) === null || _a === void 0 ? void 0 : _a.slots) !== null && _b !== void 0 ? _b : med.yearmedtime;
            if (typeof slots === 'string') {
                try {
                    slots = JSON.parse(slots);
                }
                catch (e) {
                    slots = null;
                }
            }
            if (!Array.isArray(slots))
                return null;
            return slots.filter(function (slot) { return slot && slot.time; }).map(function (slot) { return ({ time: String(slot.time) }); });
        }
        function changeDoseUnitByOrder(medication, newValue, notChanged, showRecord) {
            var med = medication;
            var slots = templateSlotsOf(medication);
            if (slots === null) {
                alert('The medication\'s dose times could not be read, so the dose unit was not changed. Please reload and try again.');
                showRecord();
                return;
            }
            sweetalert2_1.default.fire({
                title: 'Change Order Required',
                text: "Changing the dose unit of ".concat(med.medname || 'this medication', " to ").concat(newValue, " changes the prescription. A change order is sent for the provider to sign, and the medication is pending until it is signed."),
                icon: 'question',
                input: 'text',
                inputLabel: 'Reason for the change',
                inputValidator: function (value) { return (!value || !String(value).trim() ? 'A change order needs a reason.' : undefined); },
                showCancelButton: true,
                confirmButtonText: 'Yes, send a change order',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#0c8687',
                cancelButtonColor: '#6c757d'
            }).then(function (result) {
                var _a, _b;
                if (!result.isConfirmed) {
                    showRecord();
                    return;
                }
                var content = {
                    MedicationAdmin: {
                        API_Meth: 'ChangeOrderForMedLogTimes',
                        medentryid: med.medentryid,
                        pid: allData.value.patient.externId,
                        accountId: allData.value.patient.externId2,
                        medname: med.medname,
                        ordernumber: (_a = med.ordernumber) !== null && _a !== void 0 ? _a : med.order_number,
                        slotedtimes: slots,
                        dosage: (_b = med.med_amount) !== null && _b !== void 0 ? _b : '',
                        frequency: med.med_frequency || med.frequency || '',
                        unitType: newValue,
                        changeorder: true,
                        changereason: String(result.value).trim(),
                    }
                };
                axios_1.default.post(apis_1.CURR_API + '/tswebhook.php', content).then(function (response) {
                    var data = response.data || {};
                    if (data.results === 'Insert' || data.results === 'Updated') {
                        sweetalert2_1.default.fire({
                            icon: 'success',
                            title: 'Change Order Created Successfully',
                            text: 'The new dose unit is pending until the provider signs the change order.',
                            confirmButtonText: 'Ok'
                        }).then(function () { return showRecord(); });
                        return;
                    }
                    alert(data.message || (typeof data.error === 'string' ? data.error : '') || notChanged);
                    showRecord();
                }).catch(function (error) {
                    var _a, _b;
                    alert(axios_1.default.isAxiosError(error) ? (((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || notChanged) : notChanged);
                    showRecord();
                });
            });
        }
        // ---------- ROW STYLING ----------
        function getRowStatusClass(_medication) {
            return 'active-row';
        }
        function needsSignature(med, dateObj) {
            var times = getTimesForDate(med, dateObj) || [];
            // normalize orderstatus and nursesignature
            var status = (med.orderstatus || '').trim();
            var sig = med.nursesignature;
            var noSig = sig === null || sig === undefined || String(sig).trim() === '';
            return status === 'Active-Pending' && noSig && times.length > 0;
        }
        /** Same rules as the desktop red signature ribbon on the med name cell. */
        function needsSignatureRibbon(med) {
            var _a, _b;
            if (!med)
                return false;
            var nurse = (_a = med.nursesignature) !== null && _a !== void 0 ? _a : '';
            var provider = (_b = med.providersignature) !== null && _b !== void 0 ? _b : '';
            var status = med.orderstatus;
            return ((status == 'Active-Pending' && nurse == '' && provider !== '') ||
                (status == 'Pending' && provider == '' && nurse !== '') ||
                (status == 'discontinue' && nurse !== '' && provider == '') ||
                (status == 'Hold' && nurse !== '' && provider == ''));
        }
        function signatureRibbonLabel(med) {
            var _a, _b;
            if (!med)
                return 'Signature';
            var nurse = (_a = med.nursesignature) !== null && _a !== void 0 ? _a : '';
            var provider = (_b = med.providersignature) !== null && _b !== void 0 ? _b : '';
            var status = med.orderstatus;
            if (nurse == '' && provider != '' && status == 'Active-Pending') {
                return 'Nurse signature';
            }
            if (nurse !== '' &&
                provider == '' &&
                (status == 'Pending' || status == 'discontinue' || status == 'Hold')) {
                return 'Provider signature';
            }
            return 'Signature';
        }
        // ---------- GET TIMES FOR DATE ----------
        function getTimesForDate(med, dateObj) {
            var dateStr = formatDateToYYYYMMDD(dateObj);
            if (!med.dates || !med.dates[dateStr]) {
                return [];
            }
            var slots = __spreadArray([], med.dates[dateStr], true);
            // If medication is fully discontinued after a certain date => no times after that
            if (med.discontinuedDate) {
                var discDay = normalizeToMidnight(med.discontinuedDate);
                var thisDay = normalizeToMidnight(dateObj);
                if (thisDay.getTime() > discDay.getTime()) {
                    return [];
                }
            }
            // For "partial" specific-time discontinuation:
            if (med.discontinuedTimes && med.discontinuedTimes[dateStr]) {
                var timesToSkip_1 = med.discontinuedTimes[dateStr];
                slots = slots.filter(function (s) {
                    if (timesToSkip_1.includes(s.time)) {
                        return s.status === 'discontinue';
                    }
                    return true;
                });
            }
            // ─── Sort chronologically by the base "HH:MM" of each time string ───
            slots.sort(function (a, b) {
                // extractBaseTime strips any "(…)" suffix and returns "HH:MM"
                var tA = extractBaseTime(a.time);
                var tB = extractBaseTime(b.time);
                var _a = tA.split(':').map(Number), hA = _a[0], mA = _a[1];
                var _b = tB.split(':').map(Number), hB = _b[0], mB = _b[1];
                var msA = hA * 3600000 + mA * 60000;
                var msB = hB * 3600000 + mB * 60000;
                return msA - msB;
            });
            return slots;
        }
        // ---------- ACTION POPUP ----------
        function openActionPopup(dateObj, timeObj, medication) {
            if (!canMedicationAdminister.value) {
                alert("You do not have permission to administer medications");
                return;
            }
            if (timeObj.locked)
                return;
            var now = new Date();
            var isToday = dateObj.getFullYear() === now.getFullYear() &&
                dateObj.getMonth() === now.getMonth() &&
                dateObj.getDate() === now.getDate();
            if (!isToday) {
                errorMessage.value = "Medications can only be given on the current date.";
                showErrorModal.value = true;
                return;
            }
            var scheduledTimeStr = timeObj.time.includes("(")
                ? timeObj.time.split("(")[0].trim()
                : timeObj.time;
            var _a = scheduledTimeStr.split(":").map(Number), hours = _a[0], mins = _a[1];
            var scheduledDateTime = new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate(), hours, mins);
            var diffMinutes = (now.getTime() - scheduledDateTime.getTime()) / 60000;
            if (diffMinutes >= -60 && diffMinutes <= 60) {
                selectedDateAndTime.value = { dateObj: dateObj, timeObj: timeObj, medication: medication };
                showTimeActionPopup.value = true;
            }
            else {
                pendingDateAndTime.value = { dateObj: dateObj, timeObj: timeObj, medication: medication };
                if (diffMinutes < -60) {
                    isEarly.value = true;
                    confirmationMessage.value = "This medication is early, do you still want to give it?";
                }
                else {
                    isEarly.value = false;
                    confirmationMessage.value = "This medication is late, do you still want to give it?";
                }
                showTimeConfirmationPopup.value = true;
            }
        }
        function closeTimeActionPopup() {
            //lets try and clear the respective time object whenthe modal is closed
            showTimeActionPopup.value = false;
        }
        function handleTimeActionSelected(_a) {
            return __awaiter(this, arguments, void 0, function (_b) {
                var _c, dateObj, timeObj_1, medication_1, asked, existingIndex, existingIndex;
                var action = _b.action;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            if (!selectedDateAndTime.value) return [3 /*break*/, 3];
                            _c = selectedDateAndTime.value, dateObj = _c.dateObj, timeObj_1 = _c.timeObj, medication_1 = _c.medication;
                            if (!(action === 'refused')) return [3 /*break*/, 2];
                            showTimeActionPopup.value = false;
                            return [4 /*yield*/, sweetalert2_1.default.fire({
                                    title: 'Why was the dose refused?',
                                    input: 'text',
                                    inputPlaceholder: 'Reason for refusal',
                                    showCancelButton: true,
                                    confirmButtonText: 'Record refusal',
                                    inputValidator: function (value) { return (!value || !String(value).trim() ? 'A refusal needs a reason.' : undefined); },
                                })];
                        case 1:
                            asked = _d.sent();
                            if (!asked.isConfirmed) {
                                return [2 /*return*/];
                            }
                            timeObj_1.refusalReason = String(asked.value).trim();
                            _d.label = 2;
                        case 2:
                            timeObj_1.temporaryStatus = action;
                            if (action === 'taken' || action === 'refused') {
                                existingIndex = pendingTransactions.value.findIndex(function (item) { return item.timeObj === timeObj_1 && item.medication === medication_1; });
                                if (existingIndex === -1) {
                                    pendingTransactions.value.push({ medication: medication_1, timeObj: timeObj_1, dateObj: dateObj });
                                    //2/25/26 now we are making the scope Adjustment here (all pending items will be processed one by one)
                                    finalSignOff(); // Calling for immediate final signOff | Alternative method: medFinalSignOff(pendingTransactions);
                                    //now check length and if greater than zero lets call function and pass action to adjust cc class
                                    if (pendingTransactions.value.length > 0) {
                                        pendingSignoff.value = true;
                                    }
                                    else {
                                        pendingSignoff.value = false;
                                    }
                                }
                            }
                            if (action === 'later') { //removing from pending transaction array
                                existingIndex = pendingTransactions.value.findIndex(function (item) { return item.timeObj === timeObj_1 && item.medication === medication_1; });
                                if (existingIndex !== -1) {
                                    pendingTransactions.value.splice(existingIndex, 1);
                                }
                            }
                            _d.label = 3;
                        case 3:
                            showTimeActionPopup.value = false;
                            return [2 /*return*/];
                    }
                });
            });
        }
        // ---------- EARLY / LATE CONFIRMATION ----------
        function confirmTimeAction() {
            showTimeConfirmationPopup.value = false;
            if (pendingDateAndTime.value) {
                var _a = pendingDateAndTime.value, dateObj = _a.dateObj, timeObj = _a.timeObj, medication = _a.medication;
                if (REQUIRE_BARCODE_SCAN_FOR_ADMIN) {
                    scannerContext.value = { med: medication, timeObj: timeObj, dateObj: dateObj };
                }
                else if (medication.prn === '1' || medication.prn === true || medication.prn === 1) {
                    openPrnSignOffPopup(medication, timeObj);
                }
                else {
                    selectedDateAndTime.value = { medication: medication, timeObj: timeObj, dateObj: dateObj };
                    showTimeActionPopup.value = true;
                }
                pendingDateAndTime.value = null;
            }
        }
        //Chris version
        // function confirmTimeAction() {
        //   showTimeConfirmationPopup.value = false
        //   if (pendingDateAndTime.value) {
        //     const { dateObj, timeObj, medication } = pendingDateAndTime.value
        //     // now that user confirmed, open the barcode scanner for this single slot
        //     scannerContext.value = { med: medication, timeObj, dateObj }
        //     pendingDateAndTime.value = null
        //   }
        // }
        function triggerEarlyYes() {
            showEarlyReasonInput.value = true;
        }
        function confirmEarlyWithReason() {
            var _a;
            if (pendingDateAndTime.value && earlyReason.value.trim() !== "") {
                selectedDateAndTime.value = pendingDateAndTime.value;
                // Store the early reason for later use after barcode scan
                var _b = pendingDateAndTime.value, timeObj = _b.timeObj, medication = _b.medication, dateObj = _b.dateObj;
                // Check if this is a PRN medication from stampPRNTime early confirmation
                if (((_a = selectedDateAndTime.value.timeObj.med) === null || _a === void 0 ? void 0 : _a.prn) === '1') {
                    var med = selectedDateAndTime.value.timeObj.med;
                    var now = new Date();
                    var todayStr = formatDateToYYYYMMDD(now);
                    var timeStr = formatTime24Hour(now);
                    if (!med.times || !Array.isArray(med.times)) {
                        med.times = [];
                        var newTimeObj = {
                            time: timeStr,
                            status: 'PRN',
                            date: todayStr,
                            earlyReason: earlyReason.value.trim() || '',
                            dosage: med.dosage || med.med_amount || '1',
                            reason: ''
                        };
                        med.times.push(newTimeObj);
                        if (REQUIRE_BARCODE_SCAN_FOR_ADMIN) {
                            scannerContext.value = { med: med, timeObj: newTimeObj, dateObj: now };
                        }
                        else {
                            openPrnSignOffPopup(med, newTimeObj);
                        }
                    }
                    //lets try this trick here 
                    else if (!med.times || !Array.isArray(med.times) && med.time != "") {
                        med.times = med.time;
                        var newTimeObj = {
                            time: med.time,
                            status: 'PRN',
                            date: todayStr,
                            earlyReason: earlyReason.value.trim() || '',
                            dosage: med.dosage || med.med_amount || '1',
                            reason: ''
                        };
                        med.times.push(newTimeObj);
                        if (REQUIRE_BARCODE_SCAN_FOR_ADMIN) {
                            scannerContext.value = { med: med, timeObj: newTimeObj, dateObj: now };
                        }
                        else {
                            openPrnSignOffPopup(med, newTimeObj);
                        }
                    }
                    //Keyon Try
                    /* const newTimeObj = {
                       time: timeStr,
                       status: 'PRN',
                       date: todayStr,
                       earlyReason: earlyReason.value.trim() ||'',
                       dosage: med.dosage || med.med_amount || '1',
                       reason: ''
                     }
                     med.times.push(newTimeObj)*/
                    // Set up scanner context instead of directly opening PRN sign-off popup
                    // scannerContext.value = { med, timeObj: newTimeObj, dateObj: now }
                }
                else {
                    // For regular medications, store early reason and set up scanner (or skip for testing)
                    timeObj.earlyReason = earlyReason.value.trim();
                    if (REQUIRE_BARCODE_SCAN_FOR_ADMIN) {
                        scannerContext.value = { med: medication, timeObj: timeObj, dateObj: dateObj };
                    }
                    else {
                        selectedDateAndTime.value = { medication: medication, timeObj: timeObj, dateObj: dateObj };
                        showTimeActionPopup.value = true;
                    }
                }
                showTimeConfirmationPopup.value = false;
                showEarlyReasonInput.value = false;
                earlyReason.value = "";
                pendingDateAndTime.value = null;
            }
        }
        function cancelTimeActionConfirmation() {
            showTimeConfirmationPopup.value = false;
            pendingDateAndTime.value = null;
            showEarlyReasonInput.value = false;
            earlyReason.value = "";
        }
        //--1/15/2026 Addeding Submit for MedAdmin Order Template ----///
        function handleSubmit(nurseSignature) {
            var content = {
                MedicationAdmin: {
                    API_Meth: "UpdateOrderWithNurseSignature",
                    accountnumber: allData.value.patient.externId2, //"904575107",
                    patientid: allData.value.patient.externId, //"709081242",
                    ordernumber: nurseSignature.ordernumber, //"36",
                    nurseSignature: nurseSignature.nurseSignature,
                    nurseSigDate: nurseSignature.nurseSignedDate,
                    providerSignature: nurseSignature.provider,
                    providerSignedDate: nurseSignature.providerSignedDate,
                    action: nurseSignature.action,
                    provsubaccount: allData.value.manager.externid
                }
            };
            axios_1.default.post(apis_1.CURR_API + '/tswebhook.php', content)
                .then(function (response) {
                if (response.data && (response.data.code == "200 Successfull" || response.data.code == "200-Sql Success")) {
                    var returnmsg = "";
                    returnmsg = "Order Sign Off Successfully";
                    alert(returnmsg);
                    //clear and reload data after update 
                    dateList.value = []; //reset
                    loadMedications();
                }
                // The port answers a refusal as a reply ({status:'Error', message}), never a rejection (legacyBridge), so the
                // .catch below does not see it: say why, in the server's words (a signer who is not eligible, a closed order).
                else {
                    alert((0, keyonRefusal_1.keyonRefusalMessage)(response.data));
                }
            })
                .catch(function (error) {
                var _a;
                if (axios_1.default.isAxiosError(error)) {
                    alert((0, keyonRefusal_1.keyonRefusalMessage)(error));
                    console.error('Error posting data:', ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) || error.message);
                    //  errorMessage = error.response?.data?.message || 'An error occurred while posting data.';  
                }
                else {
                    alert("Opps, we hit an unexpectant snag, please contact your system administrator if this error presist.");
                    //  errorMessage = 'An unexpected error occurred. Please try again.'; 
                }
            });
        }
        function ifOrderSigned(med) {
            var status = med.orderstatus;
            var nurseSig = med.nursesignature;
            var provSig = med.providersignature;
            /*console.log("Aria disable attributes");
            console.log(status);
            console.log(nurseSig);
            console.log(provSig); */
            if (status == 'Active-Pending' && provSig != "" && nurseSig == "") {
                return true;
            }
            else if (status == 'Pending' && provSig == "" && nurseSig != "") {
                return true;
            }
            else if (status == 'discontinue' && provSig == "" && nurseSig != "") {
                return true;
            }
            else if (status == 'Hold' && provSig == "" && nurseSig != "") {
                return true;
            }
            else {
                return false;
            }
        }
        function openOrderModal(orderId, medId) {
            return __awaiter(this, void 0, void 0, function () {
                var content;
                return __generator(this, function (_a) {
                    if (!canOrderSign.value) {
                        alert("You do not have permission to sign off on orders.");
                        return [2 /*return*/];
                    }
                    try {
                        content = {
                            MedicationAdmin: {
                                API_Meth: "LookupOrderInfoSigSignOff",
                                accountnumber: allData.value.patient.externId2, //"904575107",
                                npinumber: allData.value.manager.externid || '',
                                patientid: allData.value.patient.externId, //"709081242",
                                ordernumber: orderId, //"36",
                                medentryid: medId,
                                provsubaccount: allData.value.manager.externid
                            }
                        };
                        axios_1.default.post(apis_1.CURR_API + '/tswebhook.php', content)
                            .then(function (response) {
                            if (response.data && response.data.code == "200 Successfull" && response.data.results) {
                                var returnmsg = "";
                                returnmsg = "Order Sign Off Lookup Data Returned - Check Console";
                                selectedOrder.value = response.data.results[0];
                                // alert(returnmsg);
                                //showAddForm.value = false;
                            }
                            // a refusal is a reply on the port, not a rejection (see handleSubmit): say why
                            else {
                                alert((0, keyonRefusal_1.keyonRefusalMessage)(response.data));
                            }
                        })
                            .catch(function (error) {
                            var _a;
                            if (axios_1.default.isAxiosError(error)) {
                                alert((0, keyonRefusal_1.keyonRefusalMessage)(error));
                                console.error('Error posting data:', ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) || error.message);
                                //  errorMessage = error.response?.data?.message || 'An error occurred while posting data.';  
                            }
                            else {
                                alert("Opps, we hit an unexpectant snag, please contact your system administrator if this error presist.");
                                //  errorMessage = 'An unexpected error occurred. Please try again.'; 
                            }
                        });
                        showOrderModal.value = true;
                    }
                    catch (err) {
                        console.error('Failed to load order', err);
                    }
                    return [2 /*return*/];
                });
            });
        }
        //--2/11/16 Clear Change Order Hold Functions ----/// 
        function clearMedicationHold(ordernumber, medentryid, medname) {
            return __awaiter(this, void 0, void 0, function () {
                var content;
                return __generator(this, function (_a) {
                    try {
                        content = {
                            MedicationAdmin: {
                                API_Meth: "ClearCurrentMedicationHold",
                                accountnumber: allData.value.patient.externId2, //"904575107",
                                npinumber: allData.value.manager.externid || '',
                                patientid: allData.value.patient.externId, //"709081242",
                                ordernumber: ordernumber, //"36",
                                medentryid: medentryid,
                                medname: medname,
                                provsubaccount: allData.value.manager.externid
                            }
                        };
                        axios_1.default.post(apis_1.CURR_API + '/tswebhook.php', content)
                            .then(function (response) {
                            var _a;
                            // any release, not only a scheduled one - and a reply that is not a success says why (it was silent)
                            if (response.data && response.data.status == "200-Successfull" && ((_a = response.data.result) === null || _a === void 0 ? void 0 : _a.message) == "Auto Change Completed successfully") {
                                alert("The hold on " + medname + " has been released.");
                                showOrderModal.value = false; //close modal
                                dateList.value = []; //reset
                                loadMedications();
                            }
                            else {
                                alert((0, keyonRefusal_1.keyonRefusalMessage)(response.data));
                            }
                        })
                            .catch(function (error) {
                            var _a;
                            if (axios_1.default.isAxiosError(error)) {
                                alert((0, keyonRefusal_1.keyonRefusalMessage)(error));
                                console.error('Error posting data:', ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) || error.message);
                                //  errorMessage = error.response?.data?.message || 'An error occurred while posting data.';  
                            }
                            else {
                                alert("Opps, we hit an unexpectant snag, please contact your system administrator if this error presist.");
                                //  errorMessage = 'An unexpected error occurred. Please try again.'; 
                            }
                        });
                    }
                    catch (err) {
                        console.error('Failed to load order', err);
                    }
                    return [2 /*return*/];
                });
            });
        }
        //---7/16 New Med with Updated Code ------//
        // ---------- NEW MED ----------
        /* Keyon To make this function async to post the API endpoint */
        function handleNewMedication(medication, nwtimeInputs, freq) {
            return __awaiter(this, void 0, void 0, function () {
                var now, orderDate, orderTime, medsetting, slotedtimesArray, times, requestOrdernumber, content_1;
                return __generator(this, function (_a) {
                    // Prevent multiple simultaneous saves - check and set flag BEFORE any processing
                    if (isSavingMedication.value) {
                        return [2 /*return*/];
                    }
                    if (isEditForm.value == true) {
                        //lets run hanldeSave function 
                        // alert("Lets redirect");
                        handleSave(medication, nwtimeInputs || [], freq || '');
                        //return;//should be finished now and no more code should execute
                    }
                    else {
                        // Set loading state IMMEDIATELY to prevent race conditions
                        isSavingMedication.value = true;
                        // Show loading popup immediately
                        sweetalert2_1.default.fire({
                            title: 'Saving medication...',
                            text: 'Please wait while the medication is being saved.',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            showConfirmButton: false,
                            didOpen: function () {
                                sweetalert2_1.default.showLoading();
                            }
                        });
                        now = new Date();
                        orderDate = "".concat(now.getFullYear(), "-").concat(String(now.getMonth() + 1).padStart(2, '0'), "-").concat(String(now.getDate()).padStart(2, '0'));
                        orderTime = now.toTimeString().split(' ')[0];
                        medsetting = "";
                        slotedtimesArray = [];
                        if (nwtimeInputs && nwtimeInputs.length > 0) {
                            // Use the timeInputs array passed from the form
                            slotedtimesArray = nwtimeInputs.filter(function (t) { return t && t.trim() !== ''; }).map(function (t) { return ({
                                time: t.trim(),
                                status: 'pending',
                                dosage: parseInt(medication.dosage, 10) || 1
                            }); });
                        }
                        else if (medication.administrationTimes && medication.administrationTimes.trim() !== '') {
                            times = medication.administrationTimes.split(',').map(function (t) { return t.trim(); }).filter(function (t) { return t; });
                            slotedtimesArray = times.map(function (t) { return ({
                                time: t,
                                status: 'pending',
                                dosage: parseInt(medication.dosage, 10) || 1
                            }); });
                        }
                        requestOrdernumber = '36';
                        content_1 = {
                            MedicationAdmin: {
                                API_Meth: "InsertAdminMecationInfo",
                                orderDate: orderDate,
                                orderTime: orderTime,
                                accountnumber: allData.value.patient.externId2, //"904575107", 
                                npinumber: medication.providerNpi || medication.providernpi || allData.value.manager.externid || '',
                                proflicensenumber: "123123123", // prev nurse # needs items passed from pacmny-fe "609382", //insurance test
                                patientid: allData.value.patient.externId, //"709081242",
                                ordernumber: requestOrdernumber,
                                name: medication.medicationName || '',
                                dates: {},
                                tabsAvailable: medication.tabsAvailable || 0,
                                totalTabs: medication.quantity,
                                frequency: medication.frequency || '',
                                dosage: medication.dosage || '',
                                administrationTimes: medication.administrationTimes || '',
                                slotedtimes: slotedtimesArray,
                                scheduletimes: medication.administrationTimes,
                                route: medication.route || '',
                                dosageForm: medication.dosageForm || '',
                                diagnosis: medication.diagnosis || '',
                                prn: medication.prn,
                                newMedication: medication.newMedication || false,
                                administration: isAdminFlagOn(medication) ? 1 : 0,
                                prepour: medication.prepour === true || medication.prepour === 1 || medication.prepour === '1' ? 1 : 0,
                                nebulizer: medication.nebulizer === true || medication.nebulizer === 1 || medication.nebulizer === '1' ? 1 : 0,
                                datescriptFilled: medication.filledDate,
                                startDate: medication.startDate,
                                endDate: medication.endDate,
                                primeprovName: medication.providerName,
                                primeprovEmail: medication.providerEmail,
                                primeprovAddress: medication.providerAddress,
                                primeprovPhone: medication.providerOffice,
                                primeprovFax: medication.providerFax,
                                primeprovNpi: medication.providerNpi,
                                providerDea: medication.providerDea || '',
                                providerCell: medication.providerCell || '',
                                pharmacy: medication.pharmacyName || '',
                                pharmacyNpi: medication.pharmacyNpi || '',
                                pharmacyAddress: medication.pharmacyAddress || '',
                                pharmacyPhone: medication.pharmacyOffice || '',
                                pharmacyCell: medication.pharmacyCell || '',
                                pharmacyEmail: medication.pharmacyEmail || '',
                                pharmacyDea: medication.pharmacyDea || '',
                                prescriberInfo: medication.prescriberInfo || '',
                                prescriberDeaNpi: medication.prescriberDeaNpi || '',
                                previousProvider: medication.previousProvider || '',
                                rxNumber: medication.rxnorns || '',
                                ndcnumber: medication.ndcnumber,
                                refills: medication.refills || 0,
                                refillReminderDate: medication.refillReminderDate,
                                expirationDate: medication.expirationDate || '',
                                instructions: medication.instructions || '',
                                status: 'active',
                                medsetting: medsetting,
                                discontinuedDate: undefined,
                                discontinuedTimes: {},
                                via: medication.via || 0,
                                fluidType: medication.fluidType,
                                startTime: medication.startTime,
                                endTime: medication.endTime,
                                howLong: medication.howLong || 0,
                                totalVolume: medication.totalVolume,
                                totalVolumeUnit: medication.totalVolumeUnit,
                                rate: medication.rate,
                                provaccountnumber: allData.value.manager.externid2,
                                provsubaccountnumber: allData.value.manager.externid,
                                units: medication.unitType || '',
                                source: 'Manual', // Med Admin adds are always manual entry, not CDA import
                            }
                        };
                        axios_1.default.post(apis_1.CURR_API + '/tswebhook.php', content_1)
                            .then(function (response) {
                            if (response.data && response.data.count >= 1) {
                                /*let the user know that the medication is already in the table and active. Then ask with a confirm dialog if they want to add the Mec to the
                                *Administration setting, so that it can be added from the Medication table
                                */
                                sweetalert2_1.default.fire({
                                    title: 'Duplicate Medication Detected',
                                    text: medication.medicationName + " is already listed in the Patients Medication List. Do you want to add it to the Administration setting to be included?",
                                    icon: 'question',
                                    showCancelButton: true,
                                    confirmButtonText: 'Yes',
                                    cancelButtonText: 'No',
                                    confirmButtonColor: '#0c8687',
                                    cancelButtonColor: '#6c757d'
                                }).then(function (result) {
                                    if (result.isConfirmed) {
                                        // User clicked Yes - continue with update
                                        content_1.MedicationAdmin.medsetting = "update";
                                        updateMedAdminSetting(content_1).then(function () {
                                            // Show success Swal after update completes
                                            sweetalert2_1.default.fire({
                                                icon: 'success',
                                                title: 'Medication Updated Successfully',
                                                text: 'The medication has been added to the Administration setting.',
                                                confirmButtonText: 'Ok'
                                            }).then(function () {
                                                // Close all popups and reload medications
                                                isAddmedForm.value = false;
                                                showAddForm.value = false;
                                                dateList.value = []; //reset
                                                loadMedications();
                                            });
                                        }).catch(function (error) {
                                            // Handle error if update fails
                                            sweetalert2_1.default.fire({
                                                icon: 'error',
                                                title: 'Update Failed',
                                                text: 'There was an error updating the medication. Please try again.',
                                                confirmButtonText: 'Ok'
                                            });
                                        });
                                    }
                                    else {
                                        // User clicked No - just close the Swal, form stays open
                                        // Swal will auto-close, no action needed
                                    }
                                });
                            }
                            else if (response.data.message == "Medication Added Successfully" && response.data.status == "200 Successfull") {
                                // Update medications.value when medication is successfully added (moved inside nested structure)
                                if (response.data.records) {
                                    medications.value = response.data.records;
                                }
                                // Medicationlog entry should be created by backend InsertAdminMecationInfo if slotedtimes was provided
                                // No need for separate frontend call
                                sweetalert2_1.default.close();
                                sweetalert2_1.default.fire({
                                    icon: 'success',
                                    title: 'Medication Added Successfully',
                                    text: 'The medication has been saved successfully.',
                                    confirmButtonText: 'Ok'
                                }).then(function () {
                                    isAddmedForm.value = false;
                                    showAddForm.value = false;
                                    dateList.value = [];
                                    loadMedications();
                                });
                                // Reset saving flag
                                isSavingMedication.value = false;
                            }
                            else {
                                // Hide loading popup and show error popup for unexpected response
                                sweetalert2_1.default.close();
                                // Show error popup using Swal directly. 2026-10 (MED-14): the
                                // server's own sentence when it gives one — a refusal (no
                                // permission to order, a dose time not on the schedule) used to read
                                // as "a system error with the returned payload".
                                sweetalert2_1.default.fire({
                                    icon: 'error',
                                    title: 'Error Saving Medication',
                                    text: (response.data && response.data.message) || 'There was a system error with the returned payload. Please check the logs or try again.',
                                    confirmButtonText: 'Ok'
                                });
                                errorMessage.value = "There is a system error - with returned payload. Look into logs";
                                // Reset saving flag on error
                                isSavingMedication.value = false;
                            }
                            errorMessage.value = ""; // Clear any previous error messages     
                        })
                            .catch(function (error) {
                            var _a, _b, _c;
                            sweetalert2_1.default.close();
                            var errorText = 'An error occurred while saving the medication. Please try again.';
                            if (axios_1.default.isAxiosError(error)) {
                                console.error('Error posting data:', ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) || error.message);
                                errorText = ((_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) || errorText;
                                errorMessage.value = errorText;
                            }
                            else {
                                errorMessage.value = 'An unexpected error occurred. Please try again.';
                            }
                            sweetalert2_1.default.fire({
                                icon: 'error',
                                title: 'Error Saving Medication',
                                text: errorText,
                                confirmButtonText: 'Ok'
                            });
                        })
                            .finally(function () {
                            // Always reset loading state (loader already hidden in success/error handlers)
                            isSavingMedication.value = false;
                        });
                    }
                    return [2 /*return*/];
                });
            });
        }
        function updateMedAdminSetting(payload) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            axios_1.default.post(apis_1.CURR_API + '/tswebhook.php', payload)
                                .then(function (response) {
                                if (response.data && response.data.message == "Updated Successfully") {
                                    // Don't close form or load medications here - let the caller handle it
                                    resolve('Medication Updated Successfully');
                                }
                                else {
                                    // Return success even if message format is different
                                    resolve('Update Note Successful');
                                }
                            })
                                .catch(function (error) {
                                var _a, _b, _c;
                                var errorMessage = '';
                                if (axios_1.default.isAxiosError(error)) {
                                    console.error('Error posting data:', ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) || error.message);
                                    errorMessage = ((_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) || 'An error occurred while posting data.';
                                }
                                else {
                                    errorMessage = 'An unexpected error occurred. Please try again.';
                                }
                                reject(new Error(errorMessage));
                            });
                        })];
                });
            });
        }
        function handleMedicationUpdate(updatedMedication) {
            var i = medications.value.findIndex(function (m) { return m.name === updatedMedication.name; });
            if (i !== -1) {
                medications.value[i] = updatedMedication;
            }
        }
        // ---------- SIGN OFF PENDING ----------
        // 2026-10 (UHjWAgbK): a slot is locked as given or refused only once the
        // server has recorded it. This used to lock every pending slot first and then
        // post, and a refused post was silent, so the nurse saw a dose recorded that
        // never was — and after a reload the dose showed as due again.
        function finalSignOff() {
            return __awaiter(this, void 0, void 0, function () {
                var now, nurseSignature, items, outcome, results;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            now = new Date();
                            nurseSignature = allData.value.manager.name;
                            if (!nurseSignature)
                                return [2 /*return*/];
                            items = pendingTransactions.value.filter(function (item) { return item && item.timeObj && item.timeObj.temporaryStatus; });
                            pendingTransactions.value = [];
                            showSignOffPopup.value = false;
                            if (items.length === 0)
                                return [2 /*return*/];
                            items.forEach(function (item) {
                                // The scheduled time, before any "(taken at …)" label is added to it.
                                if (!item.timeObj.rawTime) {
                                    item.timeObj.rawTime = String(item.timeObj.time).split("(")[0].trim();
                                }
                            });
                            return [4 /*yield*/, medFinalSignOff(items)];
                        case 1:
                            outcome = _a.sent();
                            results = Array.isArray(outcome === null || outcome === void 0 ? void 0 : outcome.medications) ? outcome.medications : [];
                            items.forEach(function (item, index) {
                                var medication = item.medication, timeObj = item.timeObj;
                                var pendingAction = timeObj.temporaryStatus;
                                var result = results.find(function (r) { return r.index === index; });
                                if (!result || !result.ok) {
                                    // Not recorded: the slot goes back to what it was, unlocked.
                                    timeObj.temporaryStatus = timeObj.status || 'pending';
                                    return;
                                }
                                timeObj.locked = true;
                                timeObj.status = pendingAction;
                                timeObj.signedOff = { nurse: nurseSignature, date: now };
                                if (pendingAction === 'taken') {
                                    var dose = (typeof timeObj.dosage === 'number')
                                        ? timeObj.dosage
                                        : parseInt(medication.dosage || medication.med_amount || '1', 10);
                                    var currentAvailable = medication.available || medication.tabsAvailable || medication.total || 0;
                                    medication.available = Math.max(0, currentAvailable - dose);
                                    medication.tabsAvailable = medication.available;
                                    var formatted = formatTime12Hour(now);
                                    timeObj.time = timeObj.rawTime + " (taken at " + formatted + ")";
                                }
                            });
                            pendingSignoff.value = false;
                            return [2 /*return*/];
                    }
                });
            });
        }
        // Chris version
        // function finalSignOff() {
        //   if (!signOffNurseSignature.value) {
        //     alert("Please enter your nurse signature before signing off.")
        //     return
        //   }
        //   const now = new Date()
        //   pendingTransactions.value.forEach(item => {
        //     const { medication, timeObj } = item
        //     const pendingAction = timeObj.temporaryStatus
        //     if (!pendingAction) return
        //     timeObj.locked = true
        //     timeObj.status = pendingAction
        //     timeObj.signedOff = { nurse: signOffNurseSignature.value, date: now }
        //     if (pendingAction === 'taken') {
        //       const dose = (typeof timeObj.dosage === 'number')
        //         ? timeObj.dosage
        //         : parseInt(medication.dosage || '1', 10)
        //       medication.tabsAvailable = Math.max(0, medication.tabsAvailable - dose)
        //       const formatted = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        //       timeObj.time = timeObj.time + " (taken at " + formatted + ")"
        //     }
        //   })
        //   pendingTransactions.value = []
        //   signOffNurseSignature.value = ''
        //   showSignOffPopup.value = false
        // }
        //discText,cancelOrdernumber,cancelMedID,cancelMedName,props.order
        function handleDCOrder(reasontext, ordNum, medID, medName, medobj) {
            return __awaiter(this, void 0, void 0, function () {
                var dcdataobj, content;
                return __generator(this, function (_a) {
                    dcdataobj = {
                        medname: medName,
                        medentryid: medID || medobj.medentryid || '',
                        reason: reasontext,
                        type: "all",
                        ordernumber: ordNum || medobj.ordernumber || medobj.order_number || '',
                        status: 'discontinue',
                        originalObj: medobj
                    };
                    content = {
                        MedicationAdmin: {
                            API_Meth: "DiscontinueOrder",
                            accountnumber: allData.value.patient.externId2,
                            npinumber: allData.value.manager.externid || '',
                            patientid: allData.value.patient.externId,
                            holdobjec: dcdataobj,
                            provsubaccnt: allData.value.manager.externid
                        }
                    };
                    //make server call
                    axios_1.default.post(apis_1.CURR_API + '/tswebhook.php', content)
                        .then(function (response) {
                        if (response.data.code && response.data.code == "200-Successfull") {
                            var returnmsg = "";
                            returnmsg = response.data.message;
                            alert(returnmsg);
                            //showAddForm.value = false;
                            showOrderModal.value = false; //closeing the Order Sign oFf modal
                            dateList.value = []; //I think this is the datelist used in loadMedications
                            loadMedications();
                            // populateMedicationTable();
                            return;
                        }
                        else if (response.data.code && response.data.code == "304-CodeError" && response.data.error) {
                            //now lets add the information to the Appropriate tables 
                            alert(response.data.error);
                            //alert("Meciation Settings Not Updated Successfully, Please try again later");
                        }
                        // a refusal is a reply on the port, not a rejection (see handleSubmit): say why
                        else {
                            alert((0, keyonRefusal_1.keyonRefusalMessage)(response.data));
                        }
                    })
                        .catch(function (error) {
                        var _a;
                        if (axios_1.default.isAxiosError(error)) {
                            alert((0, keyonRefusal_1.keyonRefusalMessage)(error));
                            console.error('Error posting data:', ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) || error.message);
                            //  errorMessage = error.response?.data?.message || 'An error occurred while posting data.';  
                        }
                        else {
                            alert("Opps, we hit an unexpectant snag, please contact your system administrator if this error presist.");
                            //  errorMessage = 'An unexpected error occurred. Please try again.'; 
                        }
                    });
                    return [2 /*return*/];
                });
            });
        }
        //-------Schedule Medication Hold Axios Call -------//
        function scheduleholdMedication(medholddata_1) {
            return __awaiter(this, arguments, void 0, function (medholddata, appliedChange) {
                var content;
                if (appliedChange === void 0) { appliedChange = null; }
                return __generator(this, function (_a) {
                    content = {
                        MedicationAdmin: {
                            API_Meth: "ScheduleHoldMedication",
                            accountnumber: allData.value.patient.externId2, //"904575107",
                            npinumber: allData.value.manager.externid || '',
                            patientid: allData.value.patient.externId, //"709081242",
                            // ordernumber:medholderddata.order_number,//"36",
                            holdobjec: medholddata,
                            provsubaccnt: allData.value.manager.externid
                        }
                    };
                    axios_1.default.post(apis_1.CURR_API + '/tswebhook.php', content)
                        .then(function (response) {
                        if (response.data && response.data.code == "1" && response.data.results == "Inserted") {
                            var returnmsg = "";
                            returnmsg = "Medication Administration Hold times has been scheduled successfully.";
                            alert(returnmsg);
                            //showAddForm.value = false;
                            dateList.value = []; //I think this is the datelist used in loadMedications
                            loadMedications();
                            // populateMedicationTable();
                            return;
                        }
                        else if (response.data && response.data.code == "1" && response.data.results == "Updated") {
                            alert("Scheduled/Pending Hold has been successfully updated.");
                            dateList.value = []; //I think this is the datelist used in loadMedications
                            loadMedications();
                        }
                        else if (response.data && response.data.code == "1" && response.data.results == "Canceled") {
                            alert("Scheduled Hold has been removed successfully.");
                            dateList.value = []; //I think this is the datelist used in loadMedications
                            loadMedications();
                        }
                        else if (response.data && response.data.code == "0") {
                            //now lets add the information to the Appropriate tables 
                            alert(response.data.error);
                            revertStatusChange(appliedChange); // refused - put the row back
                            //alert("Meciation Settings Not Updated Successfully, Please try again later");
                        }
                        // The port's refusal carries no code '0': legacyBridge answers it as a reply, so the .catch below does not see
                        // it either. Say why and put the row back, as holdMedication does for any reply that is not a success.
                        else {
                            alert((0, keyonRefusal_1.keyonRefusalMessage)(response.data));
                            revertStatusChange(appliedChange);
                        }
                    })
                        .catch(function (error) {
                        var _a;
                        revertStatusChange(appliedChange); // the change did not happen
                        if (axios_1.default.isAxiosError(error)) {
                            alert((0, keyonRefusal_1.keyonRefusalMessage)(error));
                            console.error('Error posting data:', ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) || error.message);
                            //  errorMessage = error.response?.data?.message || 'An error occurred while posting data.';  
                        }
                        else {
                            alert("Opps, we hit an unexpectant snag, please contact your system administrator if this error presist.");
                            //  errorMessage = 'An unexpected error occurred. Please try again.'; 
                        }
                    });
                    return [2 /*return*/];
                });
            });
        }
        //-------Hold Medication Axios Call --------//
        function holdMedication(medholddata_1) {
            return __awaiter(this, arguments, void 0, function (medholddata, appliedChange) {
                var now, orderDate, orderTime, content;
                if (appliedChange === void 0) { appliedChange = null; }
                return __generator(this, function (_a) {
                    now = new Date();
                    orderDate = now.toISOString().split('T')[0];
                    orderTime = now.toTimeString().split(' ')[0];
                    content = {
                        MedicationAdmin: {
                            API_Meth: "HoldMedication",
                            accountnumber: allData.value.patient.externId2, //"904575107",
                            npinumber: allData.value.manager.externid || '',
                            patientid: allData.value.patient.externId, //"709081242",
                            // ordernumber:medholderddata.order_number,//"36",
                            holdobjec: medholddata,
                            provsubaccnt: allData.value.manager.externid,
                            orderDate: orderDate,
                            orderTime: orderTime
                        }
                    };
                    axios_1.default.post(apis_1.CURR_API + '/tswebhook.php', content)
                        .then(function (response) {
                        if (response.data && response.data.results == "Updated" && response.data.message == "Medication Held Successfully!") {
                            var returnmsg = "";
                            // Determine message based on status (hold or discontinue)
                            var holdInfo = medholddata;
                            if (holdInfo.status === 'discontinue') {
                                returnmsg = "Medication Discontinued Successfully";
                            }
                            else {
                                returnmsg = "Medication Held Successfully";
                            }
                            alert(returnmsg);
                            // Close the add medication form
                            showAddForm.value = false;
                            isEditForm.value = false;
                            editFormdata.value = null;
                            dateList.value = []; //I think this is the datelist used in loadMedications
                            loadMedications();
                            // populateMedicationTable();
                            return;
                        }
                        else if (response.data && response.data.results == "Updated" && response.data.message == "Medication Discontinued Successfully!") {
                            alert("Medication Discontinued Successfully");
                            showAddForm.value = false;
                            isEditForm.value = false;
                            editFormdata.value = null;
                            dateList.value = [];
                            loadMedications();
                            //make call to remove any scheudle hold that are still in tack in the background
                            var accnt = allData.value.patient.externId2;
                            var provsub = allData.value.patient.externId;
                            var holdobj = medholddata;
                            checkAndRemoveScheduleHoldIfExist(accnt, provsub, holdobj);
                            return;
                        }
                        // a refusal keyon explains (e.g. a non-prescription discontinue: "Mark it Completed
                        // instead") was dropped silently and the form stayed open
                        else {
                            // any other reply is a refusal - say why (a reply with no message was silent) and put the row back
                            alert((0, keyonRefusal_1.keyonRefusalMessage)(response.data));
                            revertStatusChange(appliedChange);
                        }
                    })
                        .catch(function (error) {
                        var _a;
                        revertStatusChange(appliedChange); // the change did not happen
                        if (axios_1.default.isAxiosError(error)) {
                            // keyon's own message when it gives one (a non-prescription hold it cannot place says why)
                            alert((0, keyonRefusal_1.keyonRefusalMessage)(error));
                            console.error('Error posting data:', ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) || error.message);
                            //  errorMessage = error.response?.data?.message || 'An error occurred while posting data.';  
                        }
                        else {
                            alert("Opps, we hit an unexpectant snag, please contact your system administrator if this error presist.");
                            //  errorMessage = 'An unexpected error occurred. Please try again.'; 
                        }
                    });
                    return [2 /*return*/];
                });
            });
        }
        function checkAndRemoveScheduleHoldIfExist(accountnumber, provsubaccountnumber, holdobj) {
            return __awaiter(this, void 0, void 0, function () {
                var content;
                return __generator(this, function (_a) {
                    content = {
                        MedicationAdmin: {
                            API_Meth: "CheckRemoveScheduledHold",
                            accountnumber: accountnumber, //"904575107",
                            npinumber: allData.value.manager.externid || '',
                            patientid: allData.value.patient.externId, //"709081242",
                            // ordernumber:medholderddata.order_number,//"36",
                            holdobjec: holdobj,
                            provsubaccnt: provsubaccountnumber
                        }
                    };
                    axios_1.default.post(apis_1.CURR_API + '/tswebhook.php', content)
                        .then(function (response) {
                        if (response.data && response.data.results == "Cleared" && response.data.message == "Medication Scheduled Hold have been reoved successfully") {
                            var returnmsg = "";
                            returnmsg = "Medication Scheduled Hold have been reoved successfully.";
                            alert(returnmsg);
                            //showAddForm.value = false;
                            dateList.value = []; //I think this is the datelist used in loadMedications
                            loadMedications();
                            // populateMedicationTable();
                            return;
                        }
                        // a refusal is a reply on the port, not a rejection (see handleSubmit): say why
                        else {
                            alert((0, keyonRefusal_1.keyonRefusalMessage)(response.data));
                        }
                    })
                        .catch(function (error) {
                        var _a;
                        if (axios_1.default.isAxiosError(error)) {
                            alert((0, keyonRefusal_1.keyonRefusalMessage)(error));
                            console.error('Error posting data:', ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) || error.message);
                            //  errorMessage = error.response?.data?.message || 'An error occurred while posting data.';  
                        }
                        else {
                            alert("Opps, we hit an unexpectant snag, please contact your system administrator if this error presist.");
                            //  errorMessage = 'An unexpected error occurred. Please try again.'; 
                        }
                    });
                    return [2 /*return*/];
                });
            });
        }
        //--------FinalSignOff Async Axios Call ------//
        // 2026-10 (UHjWAgbK): answers what happened to each dose, and tells the nurse
        // about every one that was not recorded, in the server's words. A failure used
        // to fall into a branch that showed nothing.
        function medFinalSignOff(pendingTrans) {
            return __awaiter(this, void 0, Promise, function () {
                var content, response, data, results, failed, lines, error_3;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            content = {
                                MedicationAdmin: {
                                    API_Meth: "MedSignOff",
                                    accountnumber: allData.value.patient.externId2, //"904575107", 
                                    npinumber: allData.value.manager.externid || '',
                                    patientid: allData.value.patient.externId, //"709081242",
                                    providersubaccount: allData.value.manager.externid,
                                    signoffObj: pendingTrans
                                }
                            };
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, axios_1.default.post(apis_1.CURR_API + '/tswebhook.php', content)
                                // No console output of the answer: it carries the doses charted
                                // (9Uks65wT — no clinical payloads in the browser console).
                            ];
                        case 2:
                            response = _c.sent();
                            data = response.data || {};
                            results = Array.isArray(data.medications) ? data.medications : [];
                            if (data.results == "Updated") {
                                alert("Medication Signed off Successfully");
                                showAddForm.value = false;
                                dateList.value = []; //reset before populating
                                loadMedications();
                                return [2 /*return*/, data];
                            }
                            failed = results.filter(function (r) { return !r.ok; });
                            lines = failed.length
                                ? failed.map(function (r) { return "".concat(r.slot_time || 'A dose').concat(r.administered_on ? ' on ' + r.administered_on : '', ": ").concat(r.message || 'not recorded'); })
                                : [data.message || 'The sign-off was not recorded.'];
                            alert((data.results == "Partial" ? "Some doses were not signed off:\n" : "The sign-off was not recorded:\n") + lines.join("\n"));
                            if (data.results == "Partial") {
                                dateList.value = [];
                                loadMedications();
                            }
                            return [2 /*return*/, data];
                        case 3:
                            error_3 = _c.sent();
                            if (axios_1.default.isAxiosError(error_3)) {
                                alert(((_b = (_a = error_3.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || "The sign-off was not recorded. Please try again.");
                            }
                            else {
                                alert("The sign-off was not recorded. Please try again.");
                            }
                            return [2 /*return*/, { results: 'Error', medications: [] }];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        // ---------- PRN SIGN-OFF ----------
        function openPrnSignOffPopup(med, timeObj) {
            if (timeObj.dosage == null || timeObj.dosage === '') {
                timeObj.dosage = med.med_amount || '1'; // med.dosage || '1'
            }
            if (!timeObj.reason) {
                timeObj.reason = '';
            }
            if (!timeObj.time) {
                var now = new Date();
                // const timStr = now.toLocaleTimeString([],{hour:'2-digit',minute:'2-digit'});
                var timStr = formatTime24Hour(now);
                timeObj.time = timStr;
            }
            prnSignOffMedication.value = med;
            prnSignOffTimeObj.value = timeObj;
            prnNurseSignature.value = '';
            showPrnSignOffPopup.value = true;
        }
        function closePrnSignOffPopup() {
            showPrnSignOffPopup.value = false;
            prnSignOffMedication.value = null;
            prnSignOffTimeObj.value = null;
            prnNurseSignature.value = '';
            // Discard pending times if popup was cancelled
            pendingPrnTimes.value = null;
        }
        function handlePrnSignOff() {
            return __awaiter(this, void 0, void 0, function () {
                var med, timeObj, pending, recorded, dose, currentAvailable, timesToAdd;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!prnSignOffMedication.value || !prnSignOffTimeObj.value) {
                                showPrnSignOffPopup.value = false;
                                return [2 /*return*/];
                            }
                            if (!prnNurseSignature.value) {
                                alert("Please enter your nurse signature before signing off.");
                                return [2 /*return*/];
                            }
                            med = prnSignOffMedication.value;
                            timeObj = prnSignOffTimeObj.value;
                            pending = (pendingPrnTimes.value && pendingPrnTimes.value.medication === med) ? pendingPrnTimes.value : null;
                            timeObj.signedOff = {
                                nurse: prnNurseSignature.value,
                                date: new Date()
                            };
                            closePrnSignOffPopup();
                            return [4 /*yield*/, prnAPISignOff(med, timeObj)];
                        case 1:
                            recorded = _b.sent();
                            if (!recorded) {
                                timeObj.signedOff = undefined;
                                return [2 /*return*/];
                            }
                            timeObj.locked = true;
                            timeObj.status = 'taken';
                            dose = (typeof timeObj.dosage === 'number')
                                ? timeObj.dosage
                                : parseInt(med.dosage || med.med_amount || '1', 10);
                            currentAvailable = med.available || med.tabsAvailable || 0;
                            med.available = Math.max(0, currentAvailable - dose);
                            med.tabsAvailable = med.available;
                            // The times that follow this dose, now that it is recorded.
                            if (pending) {
                                if (!med.times || !Array.isArray(med.times)) {
                                    med.times = [];
                                }
                                timesToAdd = __spreadArray([], pending.timeObjects, true);
                                if (timesToAdd.length > 0) {
                                    med.times.unshift(timesToAdd[0]);
                                    if (timesToAdd.length > 1) {
                                        (_a = med.times).push.apply(_a, timesToAdd.slice(1));
                                    }
                                }
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        //12/4/25 
        // Answers whether the dose was recorded. Every answer but the bridge's
        // success is a refusal the nurse is shown — a `status: 'Error'` body carries
        // the server's sentence and no `error` key, which this used to ignore.
        function prnAPISignOff(med, timeObj) {
            return __awaiter(this, void 0, Promise, function () {
                var content, notRecorded, response, data, error_4;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            content = {
                                MedicationAdmin: {
                                    API_Meth: "PrnSignOff",
                                    accountnumber: allData.value.patient.externId2,
                                    patientid: allData.value.patient.externId,
                                    providersubaccount: allData.value.manager.externid,
                                    medname: med.medname,
                                    medid: med.medentryid,
                                    ordernumber: med.order_number || med.ordernumber,
                                    prn: med.prn,
                                    signoffobj: timeObj,
                                }
                            };
                            notRecorded = "The PRN dose was not recorded. Please try again.";
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, axios_1.default.post(apis_1.CURR_API + "/tswebhook.php", content)];
                        case 2:
                            response = _c.sent();
                            data = response.data || {};
                            if (data.code == "200 Successfull" && data.results == "Inserted") {
                                alert("PRN Medication Signed Off Successfully.");
                                // Reload so the next sign-off works on the server's record.
                                dateList.value = [];
                                loadMedications();
                                return [2 /*return*/, true];
                            }
                            alert(data.message || (typeof data.error === 'string' ? data.error : '') || notRecorded);
                            return [2 /*return*/, false];
                        case 3:
                            error_4 = _c.sent();
                            alert(axios_1.default.isAxiosError(error_4) ? (((_b = (_a = error_4.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || notRecorded) : notRecorded);
                            return [2 /*return*/, false];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        // ---------- STAMP PRN TIME ----------
        //----New stampPRNTIME----//
        function stampPRNTime(med) {
            if (!canMedicationAdminister.value) {
                alert("You do not have permission to administer medications");
                return;
            }
            // Prevent multiple "As needed" clicks before confirmation
            if (pendingPrnTimes.value && pendingPrnTimes.value.medication === med) {
                return;
            }
            var limit = getTimesCountFromFrequency(med.med_frequency || '');
            if (!med.times)
                med.times = [];
            var todayStr = formatDateToYYYYMMDD(new Date());
            var todaysPRNs = med.times.filter(function (entry) { return entry.date === todayStr; });
            if (todaysPRNs.length >= limit) {
                alert("You can only add up to ".concat(limit, " PRN timestamp(s) per day."));
                return;
            }
            // special early-dose check (kept from your original logic)
            if (med.med_frequency === '2 time daily' && med.times.length > 0) {
                var lastDose = med.times[med.times.length - 1];
                var lastDoseDateTime = new Date("".concat(lastDose.date, " ").concat(lastDose.time));
                var now_1 = new Date();
                var diffHours = (now_1.getTime() - lastDoseDateTime.getTime()) / (1000 * 60 * 60);
                if (diffHours < 11) {
                    confirmationMessage.value = "This medication is early (less than 11 hours from the initial dose). Do you still want to give it?";
                    isEarly.value = true;
                    showTimeConfirmationPopup.value = true;
                    pendingDateAndTime.value = { dateObj: new Date(), timeObj: { med: med }, medication: med };
                    return;
                }
            }
            // Determine loop count and exact interval in hours (no Math.ceil rounding)
            var loopcount = 0;
            var intervalHours = 0;
            switch ((med.med_frequency || '').toLowerCase()) {
                case '1 time daily':
                    loopcount = 0;
                    intervalHours = 24;
                    break;
                case '2 time daily':
                    loopcount = 1;
                    intervalHours = 24 / 2; // 12
                    break;
                case '3 time daily':
                    loopcount = 2;
                    intervalHours = 24 / 3; // 8
                    break;
                case '4 time daily':
                    loopcount = 3;
                    intervalHours = 24 / 4; // 6
                    break;
                case 'every 2 hours':
                    loopcount = Math.floor(24 / 2) - 1;
                    intervalHours = 2;
                    break;
                case 'every 4 hours':
                    loopcount = Math.floor(24 / 4) - 1;
                    intervalHours = 4;
                    break;
                case 'every 6 hours':
                    loopcount = Math.floor(24 / 6) - 1;
                    intervalHours = 6;
                    break;
                default:
                    // fallback: single stamp
                    loopcount = 0;
                    intervalHours = 24;
            }
            var now = new Date();
            var todayDateStr = formatDateToYYYYMMDD(now);
            var msPerHour = 3600 * 1000;
            // build times in temporary array instead of modifying med.times directly
            var printableTimes = [];
            var pendingTimesArray = [];
            for (var i = 0; i <= loopcount; i++) {
                var dt = new Date(now.getTime() + i * intervalHours * msPerHour);
                //const timeStr = dt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
                var timeStr = formatTime24Hour(dt);
                var newTimeObj = {
                    time: timeStr,
                    status: i === 0 ? 'PRN' : 'pending',
                    date: todayDateStr,
                    dosage: med.med_amount || med.dosage || '1',
                    reason: '',
                    prntime: timeStr
                };
                if (i == 0) {
                    printableTimes.unshift(timeStr);
                    pendingTimesArray.unshift(newTimeObj);
                }
                else {
                    printableTimes.push(timeStr);
                    pendingTimesArray.push(newTimeObj);
                }
            }
            // Store pending times instead of adding to med.times
            pendingPrnTimes.value = {
                medication: med,
                timeObjects: pendingTimesArray,
                printableTimes: printableTimes
            };
            // Get the first time object for the popup
            var lastNewTimeObj = pendingTimesArray[0];
            // Attach printable list to the first time object
            lastNewTimeObj.prntimes = printableTimes;
            // Open barcode scanner first (or skip for testing), then PRN sign-off after successful scan
            var dateObj = new Date();
            if (REQUIRE_BARCODE_SCAN_FOR_ADMIN) {
                scannerContext.value = { med: med, timeObj: lastNewTimeObj, dateObj: dateObj };
            }
            else {
                openPrnSignOffPopup(med, lastNewTimeObj);
            }
        }
        //--End NEW prn timestamp-----//
        function oldstampPRNTime(med) {
            var limit = getTimesCountFromFrequency(med.med_frequency || '');
            if (!med.times || !Array.isArray(med.times)) {
                med.times = [];
            }
            var todayStr = formatDateToYYYYMMDD(new Date());
            var todaysPRNs = med.times.filter(function (entry) { return entry.date === todayStr; });
            if (todaysPRNs.length >= limit) {
                alert("You can only add up to ".concat(limit, " PRN timestamp(s) per day."));
                return;
            }
            if (med.med_frequency === '2 time daily' && med.times.length > 0) {
                var lastDose = med.times[med.times.length - 1];
                var lastDoseDateTime = new Date(lastDose.date + ' ' + lastDose.time);
                var now_2 = new Date();
                var diffHours = (now_2.getTime() - lastDoseDateTime.getTime()) / (1000 * 60 * 60);
                if (diffHours < 11) {
                    confirmationMessage.value = "This medication is early (less than 11 hours from the initial dose). Do you still want to give it?";
                    isEarly.value = true;
                    showTimeConfirmationPopup.value = true;
                    // Create a proper time object for the scanner context
                    var timeStr_1 = formatTime24Hour(now_2);
                    var earlyTimeObj = {
                        time: timeStr_1,
                        status: 'PRN',
                        date: todayStr,
                        dosage: med.med_amount || '1',
                        reason: ''
                    };
                    pendingDateAndTime.value = { dateObj: now_2, timeObj: earlyTimeObj, medication: med };
                    return;
                }
            }
            //if freq is more than 1 time daily  then grab the freq and create a loop to add needed time objects to set appropiate time slots
            var loopcount = 0;
            var intervalHours = 0;
            if (med.frequency != "") {
                switch (med.med_frequency) {
                    case "1 time daily": {
                        //alert("Case 2");
                        loopcount = 0;
                        intervalHours = 1; //Math.ceil(24/2);
                        break;
                    }
                    case "2 time daily": {
                        //alert("Case 2");
                        loopcount = 1;
                        intervalHours = Math.ceil(24 / 2);
                        break;
                    }
                    case "3 time daily":
                        {
                            loopcount = 2;
                            intervalHours = Math.ceil(24 / 3);
                            break;
                        }
                    case "4 time daily":
                        {
                            loopcount = 3;
                            intervalHours = Math.ceil(24 / 4);
                            break;
                        }
                    case "every 2 hours":
                        {
                            loopcount = Math.ceil(24 / 2);
                            intervalHours = 2; // Math.ceil(24/2);;
                            break;
                        }
                    case "every 4 hours":
                        {
                            loopcount = Math.ceil(24 / 4);
                            intervalHours = 4;
                            break;
                        }
                    case "every 6 hours":
                        {
                            loopcount = Math.ceil(24 / 6);
                            intervalHours = 6;
                        }
                }
            }
            var now = new Date();
            // const timeStr = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
            var timeStr = formatTime24Hour(now);
            var msPerHour = 3600 * 1000;
            var newTimeObj = {
                time: timeStr, //[],
                status: 'PRN',
                date: todayStr,
                dosage: med.med_amount || '1',
                reason: '',
                prntimes: [],
            };
            var prntimess = [];
            //alert("Dosage"+" "+ med.dosage);
            //let newTimeObj={};
            //alert("lopcount"+" "+loopcount);
            //alert("interval"+" "+intervalHours);
            for (var i = 0; i <= loopcount; i++) {
                if (i == 0) {
                    newTimeObj = {
                        time: timeStr,
                        status: 'PRN',
                        date: todayStr,
                        dosage: med.dosage || '1',
                        reason: ''
                    };
                    prntimess.push(timeStr);
                    newTimeObj.time = timeStr;
                    newTimeObj.prntimes = prntimess[i];
                    med.times.push(newTimeObj);
                }
                else {
                    var addTime = new Date(now.getTime() + i * intervalHours * msPerHour);
                    // alert("New Add TIme");
                    // alert(addTime);
                    // const nwtimestr = addTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                    var nwtimestr = formatTime24Hour(addTime);
                    var nwdtStr = addTime.toLocaleDateString();
                    newTimeObj = {
                        time: nwtimestr,
                        status: 'pending',
                        date: todayStr,
                        dosage: med.dosage || '1',
                        reason: ''
                    };
                    newTimeObj.time = nwtimestr;
                    prntimess.push(nwtimestr);
                    // prntimess.reverse();
                    newTimeObj.prntimes = prntimess;
                    med.times.push(newTimeObj);
                    med.times.reverse();
                }
            }
            /*const newTimeObj = {
              time: timeStr,
              status: 'PRN',
              date: todayStr,
              dosage: med.dosage || '1',
              reason: ''
            }*/
            // med.times.push(newTimeObj) 
            // Store the first time object (current administration) for barcode scanning
            var currentTimeObj = med.times.find(function (t) { return t.time === timeStr && t.status === 'PRN' && t.date === todayStr; }) || newTimeObj;
            var dateObj = new Date();
            // Set up scanner context (or skip for testing) instead of directly opening PRN sign-off popup
            if (REQUIRE_BARCODE_SCAN_FOR_ADMIN) {
                scannerContext.value = { med: med, timeObj: currentTimeObj, dateObj: dateObj };
            }
            else {
                openPrnSignOffPopup(med, currentTimeObj);
            }
        }
        // ---------- TOOLTIP ----------
        function getTooltipText(timeObj, med) {
            /*if (!timeObj.signedOff) {
              return ''
            }
          
            const nurseStr = timeObj.signedOff.nurse || 'Unknown Nurse'
            const reasonStr = timeObj.reason || '(none)'
            const doseStr = timeObj.dosage || '(not specified)'
            const signoffTime = timeObj.signedOff.date
              ? new Date(timeObj.signedOff.date).toLocaleString()
              : ''
            return `Nurse: ${nurseStr}\nReason: ${reasonStr}\nDosage: ${doseStr}\nSigned Off: ${signoffTime}`
            */
            var _a, _b, _c;
            /*Refactor to try and replicate similar rubric but used different attributes because Sever vs AI Local is different | Confirm with Dr later*/
            if ((med.prn == '1' || !timeObj.status)) {
                return '';
            }
            var tdy = new Date();
            var year = tdy.getFullYear(); //should give us Y-m-d formatt
            var month = String(tdy.getMonth() + 1).padStart(2, '0');
            var day = String(tdy.getDate()).padStart(1, '0');
            var curdt = "".concat(year, "-").concat(month, "-").concat(day);
            //alert(curdt);
            var nurseStr = med.nursesignature; //setting the sign off nurse
            var reasonStr = (_c = (_b = (_a = med === null || med === void 0 ? void 0 : med.dates) === null || _a === void 0 ? void 0 : _a[curdt]) === null || _b === void 0 ? void 0 : _b.earlyReason) !== null && _c !== void 0 ? _c : '';
            var doseStr = med.med_amount;
            var signoffTime = med.nursedatesig;
            return "Nurse: ".concat(nurseStr, "\nReason: ").concat(reasonStr, "\nDosage: ").concat(doseStr, "\nSigned Off ").concat(signoffTime);
        }
        function showTooltip(_timeObj) { }
        function hideTooltip() { }
        return function (_ctx, _cache) {
            var _a, _b, _c;
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, [
                        (0, vue_2.createVNode)(HelpIcon_vue_1.default, {
                            "help-id": "medadmin",
                            title: "Help for Medication Administration"
                        })
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (!isMobile.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, [
                                _cache[22] || (_cache[22] = (0, vue_2.createElementVNode)("h3", null, "Select by Status:", -1)),
                                (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                    (0, vue_2.createElementVNode)("button", {
                                        class: (0, vue_2.normalizeClass)(["status-button", { active: selectedStatus.value === null }]),
                                        onClick: _cache[0] || (_cache[0] = function ($event) { return (handleStatusFilter(null)); })
                                    }, " Show All ", 2),
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(statusOptions.value, function (option) {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                            key: option.value,
                                            class: (0, vue_2.normalizeClass)(["status-button", { active: selectedStatus.value === option.value }]),
                                            style: (0, vue_2.normalizeStyle)({ backgroundColor: option.color }),
                                            onClick: function ($event) { return (handleStatusFilter(option.value)); }
                                        }, (0, vue_2.toDisplayString)(option.label), 15, _hoisted_6));
                                    }), 128))
                                ])
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (!isMobile.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, [
                                _cache[23] || (_cache[23] = (0, vue_2.createElementVNode)("label", { for: "date-range-picker" }, "Select Date Range:", -1)),
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((srchDtfield).value = $event); }),
                                    type: "text",
                                    id: "date-range-picker",
                                    placeholder: "Select date range"
                                }, null, 512), [
                                    [vue_2.vModelText, srchDtfield.value]
                                ]),
                                (0, vue_2.createElementVNode)("button", {
                                    class: "add-manually-btn",
                                    onClick: clearFilter
                                }, " Clear Filter "),
                                (0, vue_2.createElementVNode)("button", {
                                    class: "add-manually-btn",
                                    onClick: _cache[2] || (_cache[2] = function ($event) { return (openAddMedicationManually(true)); })
                                }, " Add Med Manually ")
                            ]))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_8, [
                                (0, vue_2.createElementVNode)("div", _hoisted_9, [
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "add-manually-btn",
                                        onClick: _cache[3] || (_cache[3] = function ($event) { return (openAddMedicationManually(true)); })
                                    }, " Add Manually "),
                                    _cache[24] || (_cache[24] = (0, vue_2.createElementVNode)("input", {
                                        type: "text",
                                        id: "date-range-picker",
                                        placeholder: "Date Range"
                                    }, null, -1))
                                ])
                            ])),
                        (isMobile.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 3 }, [
                                (0, vue_2.createElementVNode)("div", _hoisted_10, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_11, [
                                        _cache[26] || (_cache[26] = (0, vue_2.createElementVNode)("label", { for: "mobileFilter" }, "Filter by:", -1)),
                                        (0, vue_2.createElementVNode)("select", {
                                            id: "mobileFilter",
                                            onChange: _cache[4] || (_cache[4] = function (e) { return handleStatusFilter(e.target.value === '' ? null : e.target.value); }),
                                            class: "mobile-filter-select"
                                        }, __spreadArray([], (_cache[25] || (_cache[25] = [
                                            (0, vue_2.createStaticVNode)("<option value=\"\" data-v-5e34c7d9>Show All</option><option value=\"active\" data-v-5e34c7d9>Active</option><option value=\"discontinue\" data-v-5e34c7d9>Discontinue</option><option value=\"hold\" data-v-5e34c7d9>Hold</option><option value=\"new\" data-v-5e34c7d9>New</option><option value=\"pending\" data-v-5e34c7d9>Pending</option><option value=\"change\" data-v-5e34c7d9>Change</option><option value=\"completed\" data-v-5e34c7d9>Completed</option><option value=\"partial\" data-v-5e34c7d9>Partial</option>", 9)
                                        ])), true), 32)
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_12, [
                                        _cache[28] || (_cache[28] = (0, vue_2.createElementVNode)("label", { for: "mobileSort" }, "Sort by:", -1)),
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                            id: "mobileSort",
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) { return ((selectedSort).value = $event); }),
                                            onChange: onSortChange,
                                            class: "mobile-sort-select"
                                        }, __spreadArray([], (_cache[27] || (_cache[27] = [
                                            (0, vue_2.createStaticVNode)("<option disabled value=\"\" data-v-5e34c7d9>— Select —</option><option value=\"Medication\" data-v-5e34c7d9>Medication</option><option value=\"Time\" data-v-5e34c7d9>Time</option><option value=\"Diagnosis\" data-v-5e34c7d9>Diagnosis</option><option value=\"Route\" data-v-5e34c7d9>Route</option><option value=\"PRN\" data-v-5e34c7d9>PRN</option>", 6)
                                        ])), true), 544), [
                                            [vue_2.vModelSelect, selectedSort.value]
                                        ])
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_13, [
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(selectedDates.value, function (date) {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                            key: date,
                                            class: (0, vue_2.normalizeClass)(["mobile-date-box", { 'mobile-date-box--active': date === activeDate.value }]),
                                            onClick: function ($event) { return (selectDate(date)); }
                                        }, (0, vue_2.toDisplayString)(date), 11, _hoisted_14));
                                    }), 128))
                                ])
                            ], 64))
                            : (0, vue_2.createCommentVNode)("", true),
                        (!isMobile.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_15, [
                                (0, vue_2.createElementVNode)("button", {
                                    class: (0, vue_2.normalizeClass)(["sort-button", { active: sortBy.value === 'medication' }]),
                                    onClick: _cache[6] || (_cache[6] = function ($event) { return (handleSort('medication')); })
                                }, " Sort by Medication ", 2),
                                (0, vue_2.createElementVNode)("button", {
                                    class: (0, vue_2.normalizeClass)(["sort-button", { active: sortBy.value === 'time' }]),
                                    onClick: _cache[7] || (_cache[7] = function ($event) { return (handleSort('time')); })
                                }, " Sort by Time ", 2),
                                (0, vue_2.createElementVNode)("button", {
                                    class: (0, vue_2.normalizeClass)(["sort-button", { active: sortBy.value === 'diagnosis' }]),
                                    onClick: _cache[8] || (_cache[8] = function ($event) { return (handleSort('diagnosis')); })
                                }, " Sort by Diagnosis ", 2),
                                (0, vue_2.createElementVNode)("button", {
                                    class: (0, vue_2.normalizeClass)(["sort-button", { active: sortBy.value === 'route' }]),
                                    onClick: _cache[9] || (_cache[9] = function ($event) { return (handleSort('route')); })
                                }, " Sort by Route ", 2),
                                (0, vue_2.createElementVNode)("button", {
                                    class: (0, vue_2.normalizeClass)(["sort-button", { active: sortBy.value === 'prn' }]),
                                    onClick: _cache[10] || (_cache[10] = function ($event) { return (handleSort('prn')); })
                                }, " Sort by PRN ", 2),
                                _cache[29] || (_cache[29] = (0, vue_2.createElementVNode)("span", { class: "spacer" }, null, -1)),
                                (0, vue_2.createElementVNode)("button", {
                                    class: "sort-button",
                                    onClick: toggleCollapse
                                }, (0, vue_2.toDisplayString)(collapsed.value ? 'Expand' : 'Collapse'), 1)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (!isMobile.value)
                            ? ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 5 }, (0, vue_2.renderList)(groupedMedications.value, function (medsInGroup, category) {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: category }, [
                                    (medsInGroup.length > 0)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_16, [
                                            (0, vue_2.createElementVNode)("h3", _hoisted_17, (0, vue_2.toDisplayString)(category), 1),
                                            (0, vue_2.createElementVNode)("div", _hoisted_18, [
                                                (0, vue_2.createElementVNode)("table", _hoisted_19, [
                                                    (0, vue_2.createElementVNode)("thead", null, [
                                                        (0, vue_2.createElementVNode)("tr", null, [
                                                            _cache[30] || (_cache[30] = (0, vue_2.createElementVNode)("th", { class: "sticky-header-1" }, "Medication Details", -1)),
                                                            (!collapsed.value)
                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("th", _hoisted_20, "Status"))
                                                                : (0, vue_2.createCommentVNode)("", true),
                                                            (!collapsed.value)
                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("th", _hoisted_21, "Tabs Available"))
                                                                : (0, vue_2.createCommentVNode)("", true),
                                                            (!collapsed.value)
                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("th", _hoisted_22, "Frequency"))
                                                                : (0, vue_2.createCommentVNode)("", true),
                                                            (!collapsed.value)
                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("th", _hoisted_23, "Dosage"))
                                                                : (0, vue_2.createCommentVNode)("", true),
                                                            (!collapsed.value)
                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("th", _hoisted_24, "Select Times"))
                                                                : (0, vue_2.createCommentVNode)("", true),
                                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(allColumns.value, function (dateObj) {
                                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("th", {
                                                                    key: dateObj.getTime()
                                                                }, " Administration Times (" + (0, vue_2.toDisplayString)(formatDate(dateObj)) + ") ", 1));
                                                            }), 128))
                                                        ])
                                                    ]),
                                                    (0, vue_2.createElementVNode)("tbody", null, [
                                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(medsInGroup, function (med, medIndex) {
                                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", {
                                                                key: medIndex,
                                                                class: (0, vue_2.normalizeClass)(["medication-row", getRowStatusClass(med)]),
                                                                "data-med-index": medIndex
                                                            }, [
                                                                (0, vue_2.createElementVNode)("td", _hoisted_26, [
                                                                    (((med.orderstatus == 'Active-Pending' && med.nursesignature == '' && med.providersignature !== '') || (med.orderstatus == 'Pending' &&
                                                                        med.providersignature == '' && med.nursesignature !== '') || (med.orderstatus == 'discontinue' && med.nursesignature !== '' && med.providersignature == '')
                                                                        || (med.orderstatus == 'Hold' && med.nursesignature !== '' && med.providersignature == '')))
                                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                                            key: 0,
                                                                            class: "sig-card",
                                                                            onClick: function ($event) { return (openOrderModal((med.order_number || med.ordernumber), (med.medentryid || med.medicationid))); }
                                                                        }, [
                                                                            (0, vue_2.createElementVNode)("div", _hoisted_28, [
                                                                                (med.nursesignature == '' && med.providersignature != '' && med.orderstatus == 'Active-Pending')
                                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_29, __spreadArray([], (_cache[31] || (_cache[31] = [
                                                                                        (0, vue_2.createTextVNode)("Nurse", -1),
                                                                                        (0, vue_2.createElementVNode)("br", null, null, -1),
                                                                                        (0, vue_2.createTextVNode)("Signature", -1)
                                                                                    ])), true)))
                                                                                    : (med.nursesignature !== '' && med.providersignature == '' && (med.orderstatus == 'Pending' || med.orderstatus == 'discontinue' || med.orderstatus == 'Hold'))
                                                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_30, __spreadArray([], (_cache[32] || (_cache[32] = [
                                                                                            (0, vue_2.createTextVNode)("Provider", -1),
                                                                                            (0, vue_2.createElementVNode)("br", null, null, -1),
                                                                                            (0, vue_2.createTextVNode)("Signature", -1)
                                                                                        ])), true)))
                                                                                        : (0, vue_2.createCommentVNode)("", true),
                                                                                ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("svg", _hoisted_31, __spreadArray([], (_cache[33] || (_cache[33] = [
                                                                                    (0, vue_2.createElementVNode)("g", { transform: "translate(24,0) scale(-1,1)" }, [
                                                                                        (0, vue_2.createElementVNode)("path", {
                                                                                            fill: "white",
                                                                                            d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                                                                                        })
                                                                                    ], -1)
                                                                                ])), true)))
                                                                            ])
                                                                        ], 8, _hoisted_27))
                                                                        : (0, vue_2.createCommentVNode)("", true),
                                                                    (hasScheduleDate(med))
                                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_32, [
                                                                            (0, vue_2.createElementVNode)("div", _hoisted_33, [
                                                                                _cache[34] || (_cache[34] = (0, vue_2.createElementVNode)("span", { class: "badge-icon" }, [
                                                                                    (0, vue_2.createElementVNode)("svg", {
                                                                                        width: "14",
                                                                                        height: "14",
                                                                                        viewBox: "0 0 24 24",
                                                                                        fill: "none",
                                                                                        "aria-hidden": "true"
                                                                                    }, [
                                                                                        (0, vue_2.createElementVNode)("rect", {
                                                                                            x: "3",
                                                                                            y: "5",
                                                                                            width: "18",
                                                                                            height: "16",
                                                                                            rx: "2",
                                                                                            stroke: "#FFB300",
                                                                                            "stroke-width": "1.5"
                                                                                        }),
                                                                                        (0, vue_2.createElementVNode)("path", {
                                                                                            d: "M16 3v4M8 3v4",
                                                                                            stroke: "#FFB300",
                                                                                            "stroke-width": "1.5",
                                                                                            "stroke-linecap": "round"
                                                                                        })
                                                                                    ])
                                                                                ], -1)),
                                                                                (0, vue_2.createElementVNode)("p", _hoisted_34, (0, vue_2.toDisplayString)(med.medname) + ": Pending Hold Start Date: " + (0, vue_2.toDisplayString)(med.schedHoldStartDate), 1)
                                                                            ])
                                                                        ]))
                                                                        : (0, vue_2.createCommentVNode)("", true),
                                                                    (0, vue_2.createElementVNode)("span", {
                                                                        class: (0, vue_2.normalizeClass)([{ 'row-disabled': ifOrderSigned(med), 'medication-link--disabled': !canMedicationEditOrdered.value }, "medication-link"]),
                                                                        "aria-disabled": ifOrderSigned(med),
                                                                        onClick: function ($event) { return (openMedicationForm(med)); },
                                                                        style: (0, vue_2.normalizeStyle)({
                                                                            backgroundColor: getEffectiveStatus(med) === 'hold'
                                                                                ? '#fff3cd'
                                                                                : '#f8f9fa'
                                                                        })
                                                                    }, (0, vue_2.toDisplayString)(med.medname), 15, _hoisted_35),
                                                                    (getAddMedicationTooltip(med))
                                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                                                            key: 2,
                                                                            class: "tooltip-icon",
                                                                            title: getAddMedicationTooltip(med),
                                                                            style: { "margin-left": "4px" }
                                                                        }, " ℹ️ ", 8, _hoisted_36))
                                                                        : (0, vue_2.createCommentVNode)("", true)
                                                                ]),
                                                                (!collapsed.value)
                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                                                                        key: 0,
                                                                        class: (0, vue_2.normalizeClass)({ 'sticky-column-2 row-disabled': ifOrderSigned(med) }),
                                                                        "aria-disabled": ifOrderSigned(med)
                                                                    }, [
                                                                        (0, vue_2.createElementVNode)("select", {
                                                                            class: "status-dropdown",
                                                                            disabled: !!isStatusDisabled(med),
                                                                            onChange: function (e) { return handleStatusChange(e, medIndex); }
                                                                        }, [
                                                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(statusOptions.value, function (option) {
                                                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                                                    key: option.value,
                                                                                    value: option.value,
                                                                                    style: (0, vue_2.normalizeStyle)({ backgroundColor: option.color }),
                                                                                    selected: getEffectiveStatus(med) === option.value
                                                                                }, (0, vue_2.toDisplayString)(option.label), 13, _hoisted_39));
                                                                            }), 128))
                                                                        ], 40, _hoisted_38)
                                                                    ], 10, _hoisted_37))
                                                                    : (0, vue_2.createCommentVNode)("", true),
                                                                (!collapsed.value)
                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                                                                        key: 1,
                                                                        class: (0, vue_2.normalizeClass)({ 'tabs-available sticky-column-3 row-disabled': ifOrderSigned(med) }),
                                                                        "aria-disabled": ifOrderSigned(med)
                                                                    }, [
                                                                        (0, vue_2.createElementVNode)("div", _hoisted_41, [
                                                                            (0, vue_2.createElementVNode)("div", _hoisted_42, [
                                                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                                                    type: "number",
                                                                                    "onUpdate:modelValue": function ($event) { return ((med.available) = $event); },
                                                                                    onChange: function ($event) { return (handleTabsChange(med, $event.target.value)); },
                                                                                    class: "tabs-input",
                                                                                    min: "0"
                                                                                }, null, 40, _hoisted_43), [
                                                                                    [vue_2.vModelText, med.available]
                                                                                ]),
                                                                                _cache[35] || (_cache[35] = (0, vue_2.createElementVNode)("label", null, "Qty", -1))
                                                                            ]),
                                                                            (0, vue_2.createElementVNode)("div", _hoisted_44, [
                                                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                                                                    "onUpdate:modelValue": function ($event) { return ((med.med_doseuom) = $event); },
                                                                                    onChange: function ($event) { return (handleDoseUOMChange(med, $event.target.value)); },
                                                                                    class: "unit-select"
                                                                                }, [
                                                                                    _cache[36] || (_cache[36] = (0, vue_2.createElementVNode)("option", { value: "" }, "Select Dosage Type", -1)),
                                                                                    ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(unitOptions, function (option) {
                                                                                        return (0, vue_2.createElementVNode)("option", {
                                                                                            key: option,
                                                                                            value: option
                                                                                        }, (0, vue_2.toDisplayString)(option), 9, _hoisted_46);
                                                                                    }), 64))
                                                                                ], 40, _hoisted_45), [
                                                                                    [vue_2.vModelSelect, med.med_doseuom]
                                                                                ]),
                                                                                _cache[37] || (_cache[37] = (0, vue_2.createElementVNode)("label", null, "Type", -1))
                                                                            ])
                                                                        ])
                                                                    ], 10, _hoisted_40))
                                                                    : (0, vue_2.createCommentVNode)("", true),
                                                                (!collapsed.value)
                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", _hoisted_47, (0, vue_2.toDisplayString)(med.med_frequency || 'Not set'), 1))
                                                                    : (0, vue_2.createCommentVNode)("", true),
                                                                (!collapsed.value)
                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", _hoisted_48, (0, vue_2.toDisplayString)(med.med_amount || 'Not set'), 1))
                                                                    : (0, vue_2.createCommentVNode)("", true),
                                                                (!collapsed.value)
                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                                                                        key: 4,
                                                                        class: (0, vue_2.normalizeClass)({ 'select-time-dosage sticky-column-6 row-disabled': ifOrderSigned(med) }),
                                                                        "aria-disabled": ifOrderSigned(med)
                                                                    }, [
                                                                        (0, vue_2.createElementVNode)("button", {
                                                                            disabled: med.prn == '1',
                                                                            class: "select-button",
                                                                            onClick: function ($event) { return (toggleSelectDropdown(med)); }
                                                                        }, " Select ", 8, _hoisted_50)
                                                                    ], 10, _hoisted_49))
                                                                    : (0, vue_2.createCommentVNode)("", true),
                                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(allColumns.value, function (dateObj) {
                                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                                                                        key: dateObj.getTime(),
                                                                        style: { "background-color": "#d4edda" }
                                                                    }, [
                                                                        (0, vue_2.createElementVNode)("div", {
                                                                            class: (0, vue_2.normalizeClass)({ 'administration-times row-disabled': ifOrderSigned(med) }),
                                                                            "aria-disabled": ifOrderSigned(med)
                                                                        }, [
                                                                            (med.prn == '1')
                                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                                                                                    (!hasPrnTimesForDate(med, dateObj))
                                                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                                                            key: 0,
                                                                                            class: "prn-indicator",
                                                                                            onClick: function ($event) { return (stampPRNTime(med)); }
                                                                                        }, " As needed ", 8, _hoisted_52))
                                                                                        : (0, vue_2.createCommentVNode)("", true),
                                                                                    (med.times && Array.isArray(med.times) && med.times.length)
                                                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_53, [
                                                                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(getPrnTimesForDate(med, dateObj), function (timeObj) {
                                                                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                                                                    key: timeObj.time,
                                                                                                    class: (0, vue_2.normalizeClass)(["time-entry", [timeObj.status, { discontinued: (timeObj.status === 'discontinue' || timeObj.status === 'discontinue-medtime') }]]),
                                                                                                    onMouseover: function ($event) { return (showTooltip(timeObj)); },
                                                                                                    onMouseout: hideTooltip,
                                                                                                    onClick: function ($event) { return (!timeObj.locked && openActionPopup(dateObj, timeObj, med)); },
                                                                                                    style: (0, vue_2.normalizeStyle)({
                                                                                                        backgroundColor: timeObj.locked && timeObj.status === 'taken'
                                                                                                            ? '#b3f0b3'
                                                                                                            : timeObj.locked && timeObj.status === 'refused'
                                                                                                                ? '#f9b3b3'
                                                                                                                : timeObj.status === 'hold'
                                                                                                                    ? '#fff3cd'
                                                                                                                    : timeObj.locked === false && timeObj.status === 'refused'
                                                                                                                        ? '#f9b3b3'
                                                                                                                        : timeObj.locked && timeObj.status == 'discontinue'
                                                                                                                            ? '#f8d7da'
                                                                                                                            : (timeObj.status == 'discontinue' || timeObj.status == 'discontinue-medtime')
                                                                                                                                ? '#f8d7da'
                                                                                                                                : 'transparent'
                                                                                                    })
                                                                                                }, [
                                                                                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(formatTimeString12Hour(timeObj.time)) + " ", 1),
                                                                                                    (timeObj.earlyReason)
                                                                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_55, " (" + (0, vue_2.toDisplayString)(timeObj.earlyReason) + ") ", 1))
                                                                                                        : (0, vue_2.createCommentVNode)("", true),
                                                                                                    (timeObj.status === 'taken')
                                                                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_56, " ✔ "))
                                                                                                        : (timeObj.status === 'refused')
                                                                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_57, " ✘ "))
                                                                                                            : (timeObj.status === 'later')
                                                                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_58, " ⏳ "))
                                                                                                                : (timeObj.status === 'discontinue-medtime')
                                                                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_59, " x "))
                                                                                                                    : (0, vue_2.createCommentVNode)("", true),
                                                                                                    (getTooltipText(timeObj, med))
                                                                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                                                                                            key: 5,
                                                                                                            class: "tooltip-icon",
                                                                                                            title: getTooltipText(timeObj, med)
                                                                                                        }, " ℹ️ ", 8, _hoisted_60))
                                                                                                        : (0, vue_2.createCommentVNode)("", true)
                                                                                                ], 46, _hoisted_54));
                                                                                            }), 128))
                                                                                        ]))
                                                                                        : (0, vue_2.createCommentVNode)("", true)
                                                                                ], 64))
                                                                                : ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, (0, vue_2.renderList)(getTimesForDate(med, dateObj), function (timeObj) {
                                                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                                                                                        (sortBy.value !== 'time' || extractBaseTime(timeObj.time) === category)
                                                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                                                                key: timeObj.time,
                                                                                                class: (0, vue_2.normalizeClass)(["time-entry", [timeObj.status, timeObj.temporaryStatus, { discontinued: timeObj.status === 'discontinue-medtime' }]]),
                                                                                                onClick: function ($event) { return (!timeObj.locked && handleTimeClick(dateObj, timeObj, med)); },
                                                                                                style: (0, vue_2.normalizeStyle)({
                                                                                                    backgroundColor: bgForTime(med, dateObj, timeObj)
                                                                                                })
                                                                                            }, [
                                                                                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(formatTimeString12Hour(timeObj.time)) + " ", 1),
                                                                                                (timeObj.temporaryStatus === 'taken')
                                                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_62, " ✔ "))
                                                                                                    : (timeObj.temporaryStatus === 'refused')
                                                                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_63, " ✘ "))
                                                                                                        : (timeObj.temporaryStatus === 'later')
                                                                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_64, " ⏳ "))
                                                                                                            : (0, vue_2.createCommentVNode)("", true),
                                                                                                (timeObj.status === 'discontinue-medtime')
                                                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_65, " x "))
                                                                                                    : (0, vue_2.createCommentVNode)("", true),
                                                                                                (getTooltipText(timeObj, med))
                                                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                                                                                        key: 4,
                                                                                                        class: "tooltip-icon",
                                                                                                        title: getTooltipText(timeObj, med)
                                                                                                    }, " ℹ️ ", 8, _hoisted_66))
                                                                                                    : (0, vue_2.createCommentVNode)("", true)
                                                                                            ], 14, _hoisted_61))
                                                                                            : (0, vue_2.createCommentVNode)("", true)
                                                                                    ], 64));
                                                                                }), 256))
                                                                        ], 10, _hoisted_51)
                                                                    ]));
                                                                }), 128))
                                                            ], 10, _hoisted_25));
                                                        }), 128))
                                                    ])
                                                ])
                                            ])
                                        ]))
                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_67, __spreadArray([], (_cache[38] || (_cache[38] = [
                                            (0, vue_2.createElementVNode)("div", { class: "container" }, [
                                                (0, vue_2.createElementVNode)("h2", null, "No Filter Results Found ")
                                            ], -1)
                                        ])), true)))
                                ], 64));
                            }), 128))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_68, [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(groupedMedications.value, function (medsInGroup, category) {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: category }, [
                                        (0, vue_2.createElementVNode)("h3", _hoisted_69, (0, vue_2.toDisplayString)(category), 1),
                                        (0, vue_2.createElementVNode)("div", _hoisted_70, [
                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(medsInGroup, function (med) {
                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                    class: (0, vue_2.normalizeClass)(["accordion-item", {
                                                            active: openAccordions[med.medentryid || med.medname],
                                                            'accordion-item--needs-sig': needsSignatureRibbon(med),
                                                        }]),
                                                    key: med.medentryid || med.medname
                                                }, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_71, [
                                                        (0, vue_2.createElementVNode)("button", {
                                                            class: "accordion-button",
                                                            onClick: function ($event) { return (toggleAccordion(med.medentryid || med.medname)); }
                                                        }, [
                                                            (0, vue_2.createElementVNode)("span", _hoisted_73, (0, vue_2.toDisplayString)(med.medname || med.name || 'Unknown Medication'), 1)
                                                        ], 8, _hoisted_72),
                                                        (needsSignatureRibbon(med))
                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                                key: 0,
                                                                type: "button",
                                                                class: "mobile-sig-action",
                                                                onClick: (0, vue_2.withModifiers)(function ($event) { return (openOrderModal((med.order_number || med.ordernumber), (med.medentryid || med.medicationid))); }, ["stop"])
                                                            }, [
                                                                (0, vue_2.createElementVNode)("span", _hoisted_75, (0, vue_2.toDisplayString)(signatureRibbonLabel(med)) + " required", 1),
                                                                _cache[39] || (_cache[39] = (0, vue_2.createElementVNode)("span", { class: "mobile-sig-action__cta" }, "Sign", -1))
                                                            ], 8, _hoisted_74))
                                                            : (0, vue_2.createCommentVNode)("", true)
                                                    ]),
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("div", _hoisted_76, [
                                                        (0, vue_2.createElementVNode)("div", {
                                                            class: (0, vue_2.normalizeClass)(["accordion-content-interactive", { 'row-disabled': ifOrderSigned(med) }]),
                                                            "aria-disabled": ifOrderSigned(med)
                                                        }, [
                                                            (0, vue_2.createElementVNode)("div", _hoisted_78, [
                                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(getTimesForDate(med, findDateObj(activeDate.value)), function (timeObj) {
                                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                                        type: "button",
                                                                        key: timeObj.time + timeObj.status,
                                                                        class: (0, vue_2.normalizeClass)(["time-bubble", [
                                                                                timeObj.status,
                                                                                timeObj.temporaryStatus,
                                                                                { discontinued: timeObj.status === 'discontinue-medtime', locked: timeObj.locked }
                                                                            ]]),
                                                                        disabled: !!timeObj.locked || ifOrderSigned(med),
                                                                        style: (0, vue_2.normalizeStyle)(timeBubbleStyle(med, findDateObj(activeDate.value), timeObj)),
                                                                        onClick: function ($event) { return (!timeObj.locked && !ifOrderSigned(med) && handleTimeClick(findDateObj(activeDate.value), timeObj, med)); }
                                                                    }, [
                                                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(formatTimeString12Hour(timeObj.time)) + " ", 1),
                                                                        (timeObj.temporaryStatus === 'taken' || (timeObj.locked && timeObj.status === 'taken'))
                                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_80, "✔"))
                                                                            : (timeObj.temporaryStatus === 'refused' || (timeObj.locked && timeObj.status === 'refused'))
                                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_81, "✘"))
                                                                                : (timeObj.status === 'later')
                                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_82, "⏳"))
                                                                                    : (0, vue_2.createCommentVNode)("", true)
                                                                    ], 14, _hoisted_79));
                                                                }), 128))
                                                            ]),
                                                            (0, vue_2.createElementVNode)("div", _hoisted_83, [
                                                                _cache[40] || (_cache[40] = (0, vue_2.createElementVNode)("span", { class: "label" }, "Dosage", -1)),
                                                                (0, vue_2.createElementVNode)("span", _hoisted_84, (0, vue_2.toDisplayString)(med.med_amount || '–') + " " + (0, vue_2.toDisplayString)(med.med_doseuom || med.unitType || ''), 1)
                                                            ]),
                                                            (0, vue_2.createElementVNode)("div", _hoisted_85, [
                                                                _cache[41] || (_cache[41] = (0, vue_2.createElementVNode)("span", { class: "label" }, "Frequency", -1)),
                                                                (0, vue_2.createElementVNode)("span", _hoisted_86, (0, vue_2.toDisplayString)(med.med_frequency || med.frequency || 'Not set'), 1)
                                                            ]),
                                                            (0, vue_2.createElementVNode)("div", _hoisted_87, [
                                                                _cache[42] || (_cache[42] = (0, vue_2.createElementVNode)("span", { class: "label" }, "Available", -1)),
                                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                                    type: "number",
                                                                    "onUpdate:modelValue": function ($event) { return ((med.available) = $event); },
                                                                    class: "available-input",
                                                                    readonly: ""
                                                                }, null, 8, _hoisted_88), [
                                                                    [vue_2.vModelText, med.available]
                                                                ])
                                                            ]),
                                                            (0, vue_2.createElementVNode)("div", _hoisted_89, [
                                                                (0, vue_2.createElementVNode)("button", {
                                                                    class: "select-btn",
                                                                    disabled: ifOrderSigned(med),
                                                                    onClick: function ($event) { return (toggleSelectDropdown(med)); }
                                                                }, " Select Time & Dosage ", 8, _hoisted_90)
                                                            ]),
                                                            (0, vue_2.createElementVNode)("div", _hoisted_91, [
                                                                _cache[43] || (_cache[43] = (0, vue_2.createElementVNode)("span", { class: "label" }, "Status", -1)),
                                                                (0, vue_2.createElementVNode)("select", {
                                                                    disabled: ifOrderSigned(med),
                                                                    onChange: function (e) { return handleMobileStatusChange(e, med); },
                                                                    class: "status-select"
                                                                }, [
                                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(statusOptions.value, function (opt) {
                                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                                            key: opt.value,
                                                                            value: opt.value,
                                                                            selected: getEffectiveStatus(med) === opt.value
                                                                        }, (0, vue_2.toDisplayString)(opt.label), 9, _hoisted_93));
                                                                    }), 128))
                                                                ], 40, _hoisted_92)
                                                            ])
                                                        ], 10, _hoisted_77)
                                                    ], 512), [
                                                        [vue_2.vShow, openAccordions[med.medentryid || med.medname]]
                                                    ])
                                                ], 2));
                                            }), 128))
                                        ])
                                    ], 64));
                                }), 128))
                            ]))
                    ]),
                    (showLabelScanner.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(LabelScanner_vue_1.default, {
                            key: 0,
                            onScanned: handleLabelScanned,
                            onClose: handleLabelScanClose
                        }))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createVNode)(AddMedicationForm_vue_1.default, {
                        show: showAddForm.value,
                        pastProvloaded: pastProvloaded.value,
                        pastProvar: pastProvar.value,
                        isEditMedication: isEditForm.value,
                        isAddNewMed: isAddmedForm.value,
                        editFormdata: editFormdata.value,
                        ifStatusIsChange: ifStatusIsChange.value,
                        isSaving: isSavingMedication.value,
                        holdSelectorCancelled: holdSelectorCancelledCounter.value,
                        "lock-administration-to-on": !isEditForm.value,
                        "lock-all-creation-flags-on-edit": isEditForm.value,
                        onClose: _cache[11] || (_cache[11] = function ($event) { return (showAddForm.value = false, isEditForm.value = false, editFormdata.value = null); }),
                        onUpdtPastProvbool: updatepastProvBoolean,
                        onSave: handleNewMedication,
                        onLoadprov: loadpastProv,
                        onFreqchange: checkMedActiveStatus,
                        onDosagechange: checkMedActiveDosageStatus,
                        onHolddtchange: checkMedHoldDatesUpdate,
                        onPassMedStatus: triggerHoldDCModal,
                        onCancelMedHolds: clearMedicationHold
                    }, null, 8, ["show", "pastProvloaded", "pastProvar", "isEditMedication", "isAddNewMed", "editFormdata", "ifStatusIsChange", "isSaving", "holdSelectorCancelled", "lock-administration-to-on", "lock-all-creation-flags-on-edit"]),
                    (0, vue_2.createVNode)(MedadminshortOrderTemplate_vue_1.default, {
                        modelValue: showOrderModal.value,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) { return ((showOrderModal).value = $event); }),
                        order: selectedOrder.value,
                        onSubmitsig: handleSubmit,
                        onCancelMedHolds: clearMedicationHold,
                        onNotApproveOrder: handleDCOrder
                    }, null, 8, ["modelValue", "order"]),
                    (showHoldSelector.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_94, [
                            (0, vue_2.createElementVNode)("div", _hoisted_95, [
                                (selectedMedicationForHold.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(HoldTimeSelector_vue_1.default, {
                                        key: 0,
                                        statusOption: selectedStatusOption.value,
                                        "medication-times": holdTimes.value,
                                        timepairs: selectedMedicationForHold.value.time_status_pairs,
                                        medObj: selectedMedicationForHold.value,
                                        onSubmit: handleHoldSubmit,
                                        onCancel: handleHoldCancel,
                                        onSubmitSchedule: handleHoldSubmitSchedule
                                    }, null, 8, ["statusOption", "medication-times", "timepairs", "medObj"]))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (showTimeModal.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_96, [
                            (0, vue_2.createElementVNode)("div", _hoisted_97, [
                                _cache[47] || (_cache[47] = (0, vue_2.createElementVNode)("h3", null, "Select Times", -1)),
                                (selectedMedicationForTime.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("h4", _hoisted_98, (0, vue_2.toDisplayString)(selectedMedicationForTime.value.medname), 1))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (0, vue_2.createElementVNode)("div", _hoisted_99, [
                                    _cache[44] || (_cache[44] = (0, vue_2.createElementVNode)("label", null, "Frequency:", -1)),
                                    (0, vue_2.createElementVNode)("label", null, (0, vue_2.toDisplayString)(selectedFrequency.value), 1)
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_100, [
                                    (0, vue_2.createElementVNode)("label", null, "Dosage (" + (0, vue_2.toDisplayString)(selectedMedicationForTime.value.unitType || 'unit') + " per admin time):", 1),
                                    (0, vue_2.createElementVNode)("label", null, (0, vue_2.toDisplayString)(selectedDosage.value), 1)
                                ]),
                                (timeInputs.value.length > 0)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_101, [
                                        _cache[45] || (_cache[45] = (0, vue_2.createElementVNode)("label", null, "Administration Times:", -1)),
                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(timeInputs.value, function (_, index) {
                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                key: index,
                                                class: "time-input-row"
                                            }, [
                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                    type: "time",
                                                    "onUpdate:modelValue": function ($event) { return ((timeInputs.value[index]) = $event); },
                                                    class: "time-input",
                                                    required: ""
                                                }, null, 8, _hoisted_102), [
                                                    [vue_2.vModelText, timeInputs.value[index]]
                                                ])
                                            ]));
                                        }), 128))
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (ifStatusIsChange.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_103, [
                                        _cache[46] || (_cache[46] = (0, vue_2.createElementVNode)("label", null, "Enter Reason For Change:", -1)),
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            type: "text",
                                            placeholder: "Enter Reason for Change",
                                            "onUpdate:modelValue": _cache[13] || (_cache[13] = function ($event) { return ((Reasaon4change).value = $event); })
                                        }, null, 512), [
                                            [vue_2.vModelText, Reasaon4change.value]
                                        ])
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (0, vue_2.createElementVNode)("div", _hoisted_104, [
                                    (0, vue_2.createElementVNode)("button", {
                                        onClick: _cache[14] || (_cache[14] = function () { return handleSave(selectedMedicationForTime.value, timeInputs.value, selectedFrequency.value.value); }),
                                        class: "btn-save"
                                    }, "Save"),
                                    (0, vue_2.createElementVNode)("button", {
                                        onClick: handleCancel,
                                        class: "btn-cancel"
                                    }, "Cancel")
                                ])
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (showTimeActionPopup.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(MedicationActionPopup_vue_1.default, {
                            key: 3,
                            timeObj: (_a = selectedDateAndTime.value) === null || _a === void 0 ? void 0 : _a.timeObj,
                            providerSignature: actionProviderSignature.value,
                            onClose: closeTimeActionPopup,
                            onActionSelected: handleTimeActionSelected
                        }, null, 8, ["timeObj", "providerSignature"]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (showTimeConfirmationPopup.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_105, [
                            (0, vue_2.createElementVNode)("div", _hoisted_106, [
                                (0, vue_2.createElementVNode)("h3", null, (0, vue_2.toDisplayString)(confirmationMessage.value), 1),
                                (isEarly.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_107, [
                                        (!showEarlyReasonInput.value)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_108, [
                                                (0, vue_2.createElementVNode)("button", { onClick: triggerEarlyYes }, "Yes"),
                                                (0, vue_2.createElementVNode)("button", { onClick: cancelTimeActionConfirmation }, "No")
                                            ]))
                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_109, [
                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = function ($event) { return ((earlyReason).value = $event); }),
                                                    placeholder: "Enter reason"
                                                }, null, 512), [
                                                    [vue_2.vModelText, earlyReason.value]
                                                ]),
                                                (0, vue_2.createElementVNode)("button", {
                                                    class: "btn-green",
                                                    onClick: confirmEarlyWithReason
                                                }, "Select")
                                            ]))
                                    ]))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_110, [
                                        (0, vue_2.createElementVNode)("div", { class: "button-row" }, [
                                            (0, vue_2.createElementVNode)("button", { onClick: confirmTimeAction }, "Yes"),
                                            (0, vue_2.createElementVNode)("button", { onClick: cancelTimeActionConfirmation }, "No")
                                        ])
                                    ]))
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (showErrorModal.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_111, [
                            (0, vue_2.createElementVNode)("div", _hoisted_112, [
                                (0, vue_2.createElementVNode)("h3", null, (0, vue_2.toDisplayString)(errorMessage.value), 1),
                                (0, vue_2.createElementVNode)("div", { class: "button-row" }, [
                                    (0, vue_2.createElementVNode)("button", { onClick: closeErrorModal }, "OK")
                                ])
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (showSignOffPopup.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_113, [
                            (0, vue_2.createElementVNode)("div", _hoisted_114, [
                                _cache[52] || (_cache[52] = (0, vue_2.createElementVNode)("h3", null, "Signature Pending Transactions", -1)),
                                (pendingTransactions.value.length === 0)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_115, [
                                        _cache[48] || (_cache[48] = (0, vue_2.createElementVNode)("p", null, "No medications pending signature.", -1)),
                                        (0, vue_2.createElementVNode)("div", _hoisted_116, [
                                            (0, vue_2.createElementVNode)("button", {
                                                onClick: _cache[16] || (_cache[16] = function ($event) { return (showSignOffPopup.value = false); })
                                            }, "Close")
                                        ])
                                    ]))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_117, [
                                        _cache[51] || (_cache[51] = (0, vue_2.createElementVNode)("p", null, "Please confirm the following medication administrations:", -1)),
                                        (0, vue_2.createElementVNode)("ul", null, [
                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(pendingTransactions.value, function (item, index) {
                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", { key: index }, [
                                                    (0, vue_2.createElementVNode)("strong", null, (0, vue_2.toDisplayString)(item.medication.medname), 1),
                                                    (item.timeObj.temporaryStatus === 'taken')
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_118, "✔ Taken"))
                                                        : (item.timeObj.temporaryStatus === 'refused')
                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_119, "✘ Refused"))
                                                            : (0, vue_2.createCommentVNode)("", true),
                                                    (0, vue_2.createElementVNode)("span", null, [
                                                        _cache[49] || (_cache[49] = (0, vue_2.createTextVNode)(" — Time: ", -1)),
                                                        (0, vue_2.createElementVNode)("em", null, (0, vue_2.toDisplayString)(item.timeObj.time.includes("(")
                                                            ? item.timeObj.time.split("(")[0].trim()
                                                            : item.timeObj.time), 1)
                                                    ])
                                                ]));
                                            }), 128))
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_120, [
                                            _cache[50] || (_cache[50] = (0, vue_2.createElementVNode)("label", { for: "signOffNurseSignature" }, "Nurse Signature:", -1)),
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                type: "text",
                                                id: "signOffNurseSignature",
                                                "onUpdate:modelValue": _cache[17] || (_cache[17] = function ($event) { return ((signOffNurseSignature).value = $event); }),
                                                placeholder: "Enter your name or initials"
                                            }, null, 512), [
                                                [vue_2.vModelText, signOffNurseSignature.value]
                                            ])
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_121, [
                                            (0, vue_2.createElementVNode)("button", {
                                                onClick: finalSignOff,
                                                class: "save-button",
                                                disabled: !signOffNurseSignature.value
                                            }, "Sign Off", 8, _hoisted_122),
                                            (0, vue_2.createElementVNode)("button", {
                                                onClick: _cache[18] || (_cache[18] = function ($event) { return (showSignOffPopup.value = false); }),
                                                class: "cancel-button"
                                            }, "Cancel")
                                        ])
                                    ]))
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (showPrnSignOffPopup.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_123, [
                            (0, vue_2.createElementVNode)("div", _hoisted_124, [
                                _cache[58] || (_cache[58] = (0, vue_2.createElementVNode)("h3", null, "PRN Signature", -1)),
                                (0, vue_2.createElementVNode)("p", null, [
                                    _cache[53] || (_cache[53] = (0, vue_2.createElementVNode)("strong", null, "Medication: ", -1)),
                                    (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((_b = prnSignOffMedication.value) === null || _b === void 0 ? void 0 : _b.medname), 1)
                                ]),
                                (0, vue_2.createElementVNode)("p", null, [
                                    _cache[54] || (_cache[54] = (0, vue_2.createElementVNode)("strong", null, "Time: ", -1)),
                                    ((_c = prnSignOffTimeObj.value) === null || _c === void 0 ? void 0 : _c.time)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_125, (0, vue_2.toDisplayString)(prnSignOffTimeObj.value.time), 1))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ]),
                                (0, vue_2.createElementVNode)("p", null, [
                                    _cache[55] || (_cache[55] = (0, vue_2.createElementVNode)("strong", null, "Dosage: ", -1)),
                                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(prnSignOffTimeObj.value.dosage), 1)
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_126, [
                                    _cache[56] || (_cache[56] = (0, vue_2.createElementVNode)("label", null, "Reason for PRN:", -1)),
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        type: "text",
                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = function ($event) { return ((prnSignOffTimeObj.value.reason) = $event); }),
                                        placeholder: "Enter PRN reason"
                                    }, null, 512), [
                                        [vue_2.vModelText, prnSignOffTimeObj.value.reason]
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_127, [
                                    _cache[57] || (_cache[57] = (0, vue_2.createElementVNode)("label", { for: "prn-nurse-signature" }, "Nurse Signature:", -1)),
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        type: "text",
                                        id: "prn-nurse-signature",
                                        "onUpdate:modelValue": _cache[20] || (_cache[20] = function ($event) { return ((prnNurseSignature).value = $event); }),
                                        placeholder: "Enter your name or initials"
                                    }, null, 512), [
                                        [vue_2.vModelText, prnNurseSignature.value]
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_128, [
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "save-button",
                                        disabled: !prnNurseSignature.value,
                                        onClick: handlePrnSignOff
                                    }, " Sign Off ", 8, _hoisted_129),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "cancel-button",
                                        onClick: closePrnSignOffPopup
                                    }, " Cancel ")
                                ])
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                (REQUIRE_BARCODE_SCAN_FOR_ADMIN && scannerContext.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                        key: 0,
                        class: "scanner-modal-overlay",
                        onClick: (0, vue_2.withModifiers)(handleScannerClose, ["self"])
                    }, [
                        (0, vue_2.createElementVNode)("div", _hoisted_130, [
                            (0, vue_2.createVNode)(BarcodeScanner_vue_1.default, {
                                active: true,
                                scanRegion: scanRegion.value,
                                rapidScanMode: rapidScanMode.value,
                                onScanned: onBarcodeScanned,
                                onClose: handleScannerClose
                            }, null, 8, ["scanRegion", "rapidScanMode"])
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true),
                (showNdcMismatchPopup.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_131, [
                        (0, vue_2.createElementVNode)("div", _hoisted_132, [
                            (0, vue_2.createElementVNode)("span", _hoisted_133, " Scanned NDC (" + (0, vue_2.toDisplayString)(mismatchScannedValue.value) + ") does not match expected NDC (" + (0, vue_2.toDisplayString)(mismatchExpectedNdc.value) + "). ", 1),
                            (0, vue_2.createElementVNode)("div", { class: "button-row" }, [
                                (0, vue_2.createElementVNode)("button", {
                                    class: "btn-save",
                                    onClick: retryScan
                                }, "Retry"),
                                (0, vue_2.createElementVNode)("button", {
                                    class: "btn-cancel",
                                    onClick: closeMismatchPopup
                                }, "Close")
                            ])
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true),
                (manualNdcPopup.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_134, [
                        (0, vue_2.createElementVNode)("div", _hoisted_135, [
                            _cache[59] || (_cache[59] = (0, vue_2.createElementVNode)("span", { style: { "display": "block", "margin-bottom": "1rem", "color": "#dc3545" } }, " NDC mismatch occurred 3 times. Please manually enter NDC to confirm match. ", -1)),
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = function ($event) { return ((0, vue_2.isRef)(manualNdc) ? (manualNdc).value = $event : manualNdc = $event); })
                            }, null, 512), [
                                [vue_2.vModelText, (0, vue_2.unref)(manualNdc)]
                            ]),
                            (0, vue_2.createElementVNode)("div", { class: "button-row" }, [
                                (0, vue_2.createElementVNode)("button", {
                                    class: "btn-save",
                                    onClick: handleManualNdc
                                }, "Confirm"),
                                (0, vue_2.createElementVNode)("button", {
                                    class: "btn-cancel",
                                    onClick: closeManualNdcPopup
                                }, "Close")
                            ])
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true),
                (ndcFailure.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_136, [
                        (0, vue_2.createElementVNode)("div", { class: "modal-content" }, [
                            _cache[60] || (_cache[60] = (0, vue_2.createElementVNode)("span", { style: { "display": "block", "margin-bottom": "1rem", "color": "#dc3545" } }, " Barcode scanner and manual entry failed to match NDCs. The medication cannot be administered. ", -1)),
                            (0, vue_2.createElementVNode)("div", { class: "button-row" }, [
                                (0, vue_2.createElementVNode)("button", {
                                    class: "btn-cancel",
                                    onClick: closeNdcFailure
                                }, "Close")
                            ])
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 64));
        };
    }
});
